export const chunk1_icons = {
  "general-icon": {
    name: "general-icon",
    viewBox: "0 0 18 18.006",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="general-icon" transform="translate(0.5 0.5)">
      <path id="Union_80" data-name="Union 80" d="M0,16.636V16.37A.591.591,0,0,1,.652,16c.123.011.248,0,.378,0v-.242q0-7.568,0-15.135A.586.586,0,0,1,1.427,0h.233A.742.742,0,0,0,1.73.038L9.548,2.971a.554.554,0,0,1,.446.644V17H9.78q-4.564,0-9.129,0h0A.62.62,0,0,1,0,16.636Zm6.023-3.618V16H8c0-.853.007-1.7-.005-2.543a.453.453,0,0,0-.466-.432c-.226,0-.452-.005-.679-.005Zm-2.422,0a.509.509,0,0,0-.579.58q0,1.12,0,2.242V16H5.006v-2.98H3.6ZM6.51,11.026a.5.5,0,1,0,.008.993q.489.008.977,0a.5.5,0,1,0,.008-.993c-.166-.005-.331,0-.5,0l-.311,0C6.633,11.023,6.571,11.024,6.51,11.026Zm-2.974,0a.5.5,0,1,0-.005.994q.489.008.977,0a.5.5,0,1,0,.005-.993c-.16-.005-.32,0-.481,0l-.331,0ZM3.523,9.033a.5.5,0,1,0,0,.994c.326,0,.653,0,.978,0A.5.5,0,1,0,4.5,9.032c-.16,0-.32,0-.481,0l-.311,0C3.647,9.031,3.585,9.031,3.523,9.033Zm3.98.994A.492.492,0,0,0,8,9.536a.487.487,0,0,0-.489-.5c-.337-.008-.674-.008-1.011,0a.486.486,0,0,0-.49.5.492.492,0,0,0,.5.494c.165,0,.331,0,.5,0S7.337,10.031,7.5,10.027ZM6.509,7.042a.5.5,0,1,0,.009.993q.489.008.977,0A.5.5,0,1,0,7.5,7.042c-.166-.005-.331,0-.5,0H6.722C6.651,7.039,6.58,7.039,6.509,7.042Zm-2.989,0a.5.5,0,1,0,.01.993q.489.008.977,0a.5.5,0,1,0,.007-.993c-.166-.005-.331,0-.5,0l-.293,0C3.656,7.038,3.588,7.039,3.52,7.042Zm1-1a.5.5,0,0,0,.014-.991c-.342-.009-.685-.009-1.027,0a.5.5,0,0,0,0,.991c.166.006.332,0,.5,0S4.35,6.048,4.521,6.042Zm2.981,0a.493.493,0,0,0,.5-.49.487.487,0,0,0-.487-.5c-.337-.009-.674-.008-1.011,0a.5.5,0,0,0,0,.992c.166.005.331,0,.5,0S7.336,6.047,7.5,6.043ZM11.005,17V5.525l.267.085,4.242,1.421c.365.122.458.25.458.63v8.344c.192,0,.367-.005.543,0a.5.5,0,0,1,0,.991q-1.374,0-2.749,0Zm2.98-2.975V16h.991c0-.816,0-1.618,0-2.42a.5.5,0,0,0-.565-.561H12.567a.508.508,0,0,0-.579.58q0,1.122,0,2.242V16h1V14.025Zm.462-2.005a.5.5,0,1,0,0-.995q-.961,0-1.923,0a.5.5,0,1,0,0,.995c.32,0,.642,0,.962,0S14.126,12.022,14.447,12.02ZM12.513,9.033a.5.5,0,1,0,.007.994c.315,0,.63,0,.945,0s.652,0,.977,0a.5.5,0,0,0,.532-.492.49.49,0,0,0-.522-.5l-.97,0Z" transform="translate(0.5 0.5)" fill="#5b5b5b" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
    </g>
    `,
  },
  "Icon_ionic-ios-arrow-down": {
    name: "Icon_ionic-ios-arrow-down",
    viewBox: "0 0 13.5 7.719",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="time-off-icon" transform="translate(-6.188 -11.246)">
      <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M12.94,16.638l5.1-5.109a.961.961,0,0,1,1.363,0,.973.973,0,0,1,0,1.367l-5.784,5.788a.963.963,0,0,1-1.33.028L6.469,12.9a.965.965,0,0,1,1.363-1.367Z" transform="translate(-6.188 -11.246)" fill="#5b5b5b"/>
    </g>
    `,
  },
  "time-off-icon": {
    name: "time-off-icon",
    viewBox: "0 0 16.029 16.029",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="time-off-icon" transform="translate(-1.688 -1.688)">
      <path id="time-off-icon" data-name="Time off" d="M9.7,1.688A8.015,8.015,0,1,0,17.717,9.7,8.013,8.013,0,0,0,9.7,1.688Zm.539,8.708a.541.541,0,0,1-.539.539H6A.539.539,0,0,1,6,9.856h3.16V4.77a.539.539,0,1,1,1.079,0Z" transform="translate(-1.688 -1.688)" fill="#5b5b5b"/>
    </g>
    `,
  },
  "calendar-icon": {
    name: "calendar-icon",
    viewBox: "0 0 16.329 10.886",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="calendar-icon" transform="translate(0 -2.5)">
      <path id="calendar-icon" d="M16.23,7.529A9.093,9.093,0,0,0,8.164,2.5,9.094,9.094,0,0,0,.1,7.529a.917.917,0,0,0,0,.828,9.093,9.093,0,0,0,8.066,5.029A9.094,9.094,0,0,0,16.23,8.357a.917.917,0,0,0,0-.828Zm-8.066,4.5a4.082,4.082,0,1,1,4.082-4.082A4.082,4.082,0,0,1,8.164,12.025Zm0-6.8a2.7,2.7,0,0,0-.718.107,1.356,1.356,0,0,1-1.9,1.9,2.715,2.715,0,1,0,2.614-2Z" transform="translate(0 -2.5)" fill="#5b5b5b"/>
    </g>
    `,
  },
  "announcement-icon": {
    name: "announcement-icon",
    viewBox: "0 0 14.088 17.536",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="announcement-icon" transform="translate(0.5 0.5)">
      <path id="announcement-icon" d="M9.665,0h.291a.76.76,0,0,1,.551.855c-.014.229,0,.458,0,.7h.635A1.9,1.9,0,0,1,13.089,3.5q0,5.546,0,11.093a1.893,1.893,0,0,1-1.951,1.945q-4.594,0-9.187,0A1.886,1.886,0,0,1,0,14.592Q0,9.046,0,3.5A1.889,1.889,0,0,1,1.961,1.55h.624V.7A.649.649,0,0,1,2.849.149,2.26,2.26,0,0,1,3.109,0h.324A2.131,2.131,0,0,1,3.68.139a.662.662,0,0,1,.277.57c0,.279,0,.556,0,.83h1.9c0-.235.011-.461,0-.686A.759.759,0,0,1,6.4,0h.291a.782.782,0,0,1,.543.876c-.014.218,0,.438,0,.666h1.89c0-.228.011-.447,0-.666A.781.781,0,0,1,9.665,0M6.886,8.268q-1.7,0-3.4,0a.69.69,0,1,0,0,1.378c.587.006,1.174,0,1.76,0q2.5,0,5,0a.743.743,0,0,0,.585-.22.689.689,0,0,0-.506-1.161c-1.147,0-2.293,0-3.439,0m0,4.134h.935c.834,0,1.667,0,2.5,0a.682.682,0,0,0,.629-.975.7.7,0,0,0-.7-.4q-3.372,0-6.746,0a1.051,1.051,0,0,0-.209.02.652.652,0,0,0-.516.458.685.685,0,0,0,.678.9c1.139,0,2.281,0,3.422,0M5.169,6.885c.587,0,1.172.008,1.759,0a.682.682,0,0,0,0-1.362c-1.174-.008-2.346-.009-3.518,0a.782.782,0,0,0-.421.169.647.647,0,0,0-.194.745.666.666,0,0,0,.615.446c.587.006,1.172,0,1.759,0" transform="translate(0.5 0.5)" fill="#5b5b5b" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
    </g>
    `,
  },
  "permission-icon": {
    name: "permission-icon",
    viewBox: "0 0 14.101 17",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="permission-icon" transform="translate(0.5 0.5)">
      <path id="permission-icon" d="M9.665,0h.291a.76.76,0,0,1,.551.855c-.014.229,0,.458,0,.7h.635A1.9,1.9,0,0,1,13.089,3.5q0,5.546,0,11.093a1.893,1.893,0,0,1-1.951,1.945q-4.594,0-9.187,0A1.886,1.886,0,0,1,0,14.592Q0,9.046,0,3.5A1.889,1.889,0,0,1,1.961,1.55h.624V.7A.649.649,0,0,1,2.849.149,2.26,2.26,0,0,1,3.109,0h.324A2.131,2.131,0,0,1,3.68.139a.662.662,0,0,1,.277.57c0,.279,0,.556,0,.83h1.9c0-.235.011-.461,0-.686A.759.759,0,0,1,6.4,0h.291a.782.782,0,0,1,.543.876c-.014.218,0,.438,0,.666h1.89c0-.228.011-.447,0-.666A.781.781,0,0,1,9.665,0M6.886,8.268q-1.7,0-3.4,0a.69.69,0,1,0,0,1.378c.587.006,1.174,0,1.76,0q2.5,0,5,0a.743.743,0,0,0,.585-.22.689.689,0,0,0-.506-1.161c-1.147,0-2.293,0-3.439,0m0,4.134h.935c.834,0,1.667,0,2.5,0a.682.682,0,0,0,.629-.975.7.7,0,0,0-.7-.4q-3.372,0-6.746,0a1.051,1.051,0,0,0-.209.02.652.652,0,0,0-.516.458.685.685,0,0,0,.678.9c1.139,0,2.281,0,3.422,0M5.169,6.885c.587,0,1.172.008,1.759,0a.682.682,0,0,0,0-1.362c-1.174-.008-2.346-.009-3.518,0a.782.782,0,0,0-.421.169.647.647,0,0,0-.194.745.666.666,0,0,0,.615.446c.587.006,1.172,0,1.759,0" transform="translate(0.5 0.5)" fill="#5b5b5b" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
    </g>
    `,
  },
  "soundSetting-icon": {
    name: "soundSetting-icon",
    viewBox: "0 0 50 49.999",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="soundSetting-icon" transform="translate(-0.002)">
      <path id="Path_12128" data-name="Path 12128" d="M112.44,336.758a61.42,61.42,0,0,1-19.079,0,17.665,17.665,0,0,1-14.711-14.716,61.38,61.38,0,0,1,0-19.075A17.674,17.674,0,0,1,93.361,288.25a61.416,61.416,0,0,1,19.079,0,17.673,17.673,0,0,1,14.719,14.716,61.379,61.379,0,0,1,0,19.075,17.665,17.665,0,0,1-14.719,14.716Z" transform="translate(-77.903 -287.505)" fill="#F9F9F9"/>
      <g id="speakers" transform="translate(16.002 15)">
        <g id="Group_12590" data-name="Group 12590">
          <path id="Path_12203" data-name="Path 12203" d="M10.613.817,3.879,5.755H.807A.812.812,0,0,0,0,6.563v7.2a.812.812,0,0,0,.807.809H3.933l6.684,4.934a.808.808,0,0,0,1.292-.607V1.466A.822.822,0,0,0,10.613.817ZM3.348,12.994H1.575V7.329H3.352v5.665Zm6.944,4.328L5,13.43V6.9L10.291,3Z" transform="translate(0 -0.668)" fill="black" stroke="#fff" stroke-width="0.3"/>
          <path id="Path_12204" data-name="Path 12204" d="M402.819,102.485a.8.8,0,1,0-1.168,1.094,6.248,6.248,0,0,1,0,8.428.821.821,0,0,0,.039,1.133.785.785,0,0,0,1.129-.082A7.815,7.815,0,0,0,402.819,102.485Z" transform="translate(-385.879 -98.297)" fill="black" stroke="#a3a3b1" stroke-width="0.3"/>
          <path id="Path_12205" data-name="Path 12205" d="M341.645,166.984a.816.816,0,0,0-1.129-.039.78.78,0,0,0,0,1.129,2.49,2.49,0,0,1,0,3.39.815.815,0,0,0,.039,1.129.789.789,0,0,0,1.09-.039A4.065,4.065,0,0,0,341.645,166.984Z" transform="translate(-327.081 -160.273)" fill="black" stroke="#fff" stroke-width="0.3"/>
        </g>
      </g>
    </g>
    `,
  },
  "dialer-callerID-icon": {
    name: "dialer-callerID-icon",
    viewBox: "0 0 27.384 32.285",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="dialer-callerIDNew" transform="translate(-1318.249 -641.967)">
        <path id="Path_12211" data-name="Path 12211" d="M26.111,19.969v3.613A2.412,2.412,0,0,1,23.48,25.99a23.911,23.911,0,0,1-10.414-3.7,23.508,23.508,0,0,1-7.24-7.226,23.8,23.8,0,0,1-3.7-10.441A2.411,2.411,0,0,1,4.523,2h3.62a2.412,2.412,0,0,1,2.413,2.071A15.438,15.438,0,0,0,11.4,7.456,2.4,2.4,0,0,1,10.858,10L9.326,11.526a19.288,19.288,0,0,0,7.24,7.226L18.1,17.223a2.417,2.417,0,0,1,2.546-.542,15.519,15.519,0,0,0,3.391.843A2.41,2.41,0,0,1,26.111,19.969Z" transform="translate(1316.888 647.5)" fill="none" stroke="#4a4a4a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
        <g id="name" transform="translate(1341.249 588.967)">
          <g id="Group_12651" data-name="Group 12651" transform="translate(-14 30)">
            <path id="Path_12212" data-name="Path 12212" d="M146.043,177.5a2.75,2.75,0,1,0-2.75-2.75A2.75,2.75,0,0,0,146.043,177.5Zm0-4.431a1.686,1.686,0,1,1-1.686,1.686A1.686,1.686,0,0,1,146.043,173.069Zm0,0" transform="translate(-134.542 -143.653)" fill="#4a4a4a"/>
            <path id="Path_12213" data-name="Path 12213" d="M112.362,325.122a3.61,3.61,0,0,0-2.615,1.093,3.859,3.859,0,0,0-1.079,2.731.467.467,0,0,0,.465.465h6.458a.467.467,0,0,0,.465-.465,3.859,3.859,0,0,0-1.079-2.731,3.61,3.61,0,0,0-2.615-1.093Zm-2.731,3.359a2.846,2.846,0,0,1,.782-1.615,2.741,2.741,0,0,1,3.9,0,2.86,2.86,0,0,1,.782,1.615Zm0,0" transform="translate(-100.917 -290.443)" fill="#4a4a4a"/>
          </g>
          <path id="Path_12214" data-name="Path 12214" d="M7.254,0h-9.8A2.042,2.042,0,0,0-4.582,2.041V16.489A2.042,2.042,0,0,0-2.541,18.53h9.8A2.042,2.042,0,0,0,9.3,16.489V2.041A2.042,2.042,0,0,0,7.254,0ZM8.479,16.489a1.228,1.228,0,0,1-1.224,1.224h-9.8a1.228,1.228,0,0,1-1.224-1.224V2.041A1.228,1.228,0,0,1-2.541.816h9.8A1.228,1.228,0,0,1,8.479,2.041Zm0,0" transform="translate(-4.911 53)" fill="#4a4a4a"/>
          <path id="Path_12215" data-name="Path 12215" d="M143.628,59.545h2.68a.335.335,0,1,0,0-.67h-2.68a.335.335,0,0,0,0,.67Zm0,0" transform="translate(-147.522 -3.595)" fill="#4a4a4a"/>
        </g>
      </g>
    `,
  },
  "dialer-telephone-icon": {
    name: "dialer-telephone-icon",
    viewBox: "0 0 26.075 26.855",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="dialer-telephoneNumber" transform="translate(-1318.249 -647.397)">
        <path id="Path_12211" data-name="Path 12211" d="M26.111,19.969v3.613A2.412,2.412,0,0,1,23.48,25.99a23.911,23.911,0,0,1-10.414-3.7,23.508,23.508,0,0,1-7.24-7.226,23.8,23.8,0,0,1-3.7-10.441A2.411,2.411,0,0,1,4.523,2h3.62a2.412,2.412,0,0,1,2.413,2.071A15.438,15.438,0,0,0,11.4,7.456,2.4,2.4,0,0,1,10.858,10L9.326,11.526a19.288,19.288,0,0,0,7.24,7.226L18.1,17.223a2.417,2.417,0,0,1,2.546-.542,15.519,15.519,0,0,0,3.391.843A2.41,2.41,0,0,1,26.111,19.969Z" transform="translate(1316.888 647.5)" fill="none" stroke="#4a4a4a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
        <path id="hash-tag" d="M20.414,4.713V2.763H18.253L18.669,0H16.407l-.417,2.763h-2.85L13.558,0H11.3l-.417,2.763H7.8V4.713h2.782l-.327,2.176H7.8V8.838H9.965L9.548,11.6H11.81l.417-2.765h2.85L14.66,11.6h2.262l.417-2.765h3.075V6.889H17.632l.327-2.176h2.454ZM15.37,6.889H12.52l.327-2.176H15.7Z" transform="translate(1323.91 647.397)" fill="#4a4a4a"/>
      </g>
    `,
  },
  "speedDial-icon": {
    name: "speedDial-icon",
    viewBox: "0 0 51 50.999",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `<g id="speedDial-icon" transform="translate(-0.002)">
        <path id="Path_12128" data-name="Path 12128" d="M113.131,337.743a62.649,62.649,0,0,1-19.461,0,18.018,18.018,0,0,1-15-15.011,62.609,62.609,0,0,1,0-19.457,18.027,18.027,0,0,1,15-15.011,62.646,62.646,0,0,1,19.461,0,18.027,18.027,0,0,1,15.014,15.011,62.609,62.609,0,0,1,0,19.457,18.018,18.018,0,0,1-15.014,15.01Z" transform="translate(-77.903 -287.505)" fill="#e9f2ff"/>
        <g id="ios-keypad-outline" transform="translate(16.002 16)">
          <circle id="Ellipse_981" data-name="Ellipse 981" cx="2.5" cy="2.5" r="2.5" fill="#a3a3b1"/>
          <circle id="Ellipse_982" data-name="Ellipse 982" cx="2.5" cy="2.5" r="2.5" transform="translate(7)" fill="#a3a3b1"/>
          <circle id="Ellipse_983" data-name="Ellipse 983" cx="2.5" cy="2.5" r="2.5" transform="translate(14)" fill="#a3a3b1"/>
          <circle id="Ellipse_984" data-name="Ellipse 984" cx="2.5" cy="2.5" r="2.5" transform="translate(0 7)" fill="#a3a3b1"/>
          <circle id="Ellipse_985" data-name="Ellipse 985" cx="2.5" cy="2.5" r="2.5" transform="translate(7 7)" fill="#a3a3b1"/>
          <circle id="Ellipse_986" data-name="Ellipse 986" cx="2.5" cy="2.5" r="2.5" transform="translate(14 7)" fill="#a3a3b1"/>
          <circle id="Ellipse_987" data-name="Ellipse 987" cx="2.5" cy="2.5" r="2.5" transform="translate(0 14)" fill="#a3a3b1"/>
          <circle id="Ellipse_988" data-name="Ellipse 988" cx="2.5" cy="2.5" r="2.5" transform="translate(7 14)" fill="#a3a3b1"/>
          <circle id="Ellipse_989" data-name="Ellipse 989" cx="2.5" cy="2.5" r="2.5" transform="translate(14 14)" fill="#a3a3b1"/>
        </g>
      </g>
    `,
  },
  "users-icon": {
    name: "users-icon",
    viewBox: "0 0 50 49.999",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="users-icon" transform="translate(-0.002 0.002)">
      <path id="Path_12127" data-name="Path 12127" d="M112.44,336.758a61.422,61.422,0,0,1-19.079,0,17.665,17.665,0,0,1-14.711-14.716,61.381,61.381,0,0,1,0-19.075A17.673,17.673,0,0,1,93.361,288.25a61.417,61.417,0,0,1,19.079,0,17.674,17.674,0,0,1,14.719,14.716,61.381,61.381,0,0,1,0,19.075,17.665,17.665,0,0,1-14.719,14.716Z" transform="translate(-77.903 -287.507)" fill="#F9F9F9"/>
      <g id="user" transform="translate(15.003 15.998)">
        <g id="Group_12533" data-name="Group 12533">
          <path id="Path_12152" data-name="Path 12152" d="M18.951,16.28a.742.742,0,0,0-1.453.3.775.775,0,0,1-.157.65.754.754,0,0,1-.594.282H2.253a.754.754,0,0,1-.594-.282.775.775,0,0,1-.157-.65,8.2,8.2,0,0,1,7.8-6.493q.1,0,.2,0t.2,0a8.164,8.164,0,0,1,6.594,3.624.742.742,0,1,0,1.233-.827,9.654,9.654,0,0,0-5-3.8,5.047,5.047,0,1,0-6.041,0A9.653,9.653,0,0,0,.049,16.28,2.255,2.255,0,0,0,2.253,19H16.747a2.255,2.255,0,0,0,2.2-2.719ZM5.938,5.047A3.562,3.562,0,1,1,9.68,8.6l-.18,0-.18,0A3.567,3.567,0,0,1,5.938,5.047Z" transform="translate(0)" fill="black" stroke="#a3a3b1" stroke-width="0.5"/>
        </g>
      </g>
    </g>
    `,
  },
  "departments-icon": {
    name: "departments-icon",
    viewBox: "0 0 50 49.999",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="departments-icon" transform="translate(-0.002 0.928)">
      <path id="Path_12129" data-name="Path 12129" d="M112.44,336.758a61.422,61.422,0,0,1-19.079,0,17.665,17.665,0,0,1-14.711-14.716,61.381,61.381,0,0,1,0-19.075A17.673,17.673,0,0,1,93.361,288.25a61.417,61.417,0,0,1,19.079,0,17.674,17.674,0,0,1,14.719,14.716,61.381,61.381,0,0,1,0,19.075,17.665,17.665,0,0,1-14.719,14.716Z" transform="translate(-77.903 -288.433)" fill="#e9f2ff"/>
      <path id="building" d="M8.375,3h14.25A2.338,2.338,0,0,1,25,5.3V26H6V5.3A2.338,2.338,0,0,1,8.375,3Zm0,20.7h4.75V19.1h4.75v4.6h4.75V5.3H8.375ZM16.688,7.6H20.25v3.45H16.688ZM10.75,13.35h3.563V16.8H10.75Zm5.938,0H20.25V16.8H16.688ZM10.75,7.6h3.563v3.45H10.75Z" transform="translate(9.502 9.572)" fill="#a3a3b1" stroke="#e9f2ff" stroke-width="0.3"/>
    </g>
    `,
  },
  "addressBook-icon": {
    name: "addressBook-icon",
    viewBox: "0 0 50 49.999",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
    <g id="addressBook-icon" transform="translate(-0.002 -264)">
      <path id="Path_12130" data-name="Path 12130" d="M112.44,336.758a61.422,61.422,0,0,1-19.079,0,17.665,17.665,0,0,1-14.711-14.716,61.381,61.381,0,0,1,0-19.075A17.673,17.673,0,0,1,93.361,288.25a61.417,61.417,0,0,1,19.079,0,17.674,17.674,0,0,1,14.719,14.716,61.381,61.381,0,0,1,0,19.075,17.665,17.665,0,0,1-14.719,14.716Z" transform="translate(-77.903 -23.505)" fill="#f9f9f9"/>
      <path id="bx-book-open" d="M22.95,4.5H15.6a3.125,3.125,0,0,0-2.1.821A3.125,3.125,0,0,0,11.4,4.5H4.05A1.051,1.051,0,0,0,3,5.553v15.79a1.051,1.051,0,0,0,1.05,1.053H10.1a2.113,2.113,0,0,1,1.485.617l1.177,1.18c.009.009.022.013.031.022a1.087,1.087,0,0,0,.309.206h0a1.043,1.043,0,0,0,.8,0h0a1.087,1.087,0,0,0,.309-.206c.009-.009.022-.013.031-.022l1.177-1.18a2.113,2.113,0,0,1,1.485-.617H22.95A1.051,1.051,0,0,0,24,21.342V5.553A1.051,1.051,0,0,0,22.95,4.5ZM10.1,20.29h-5V6.605h6.3a1.052,1.052,0,0,1,1.05,1.053V21.015A4.226,4.226,0,0,0,10.1,20.29Zm11.8,0h-5a4.228,4.228,0,0,0-2.354.725V7.658A1.052,1.052,0,0,1,15.6,6.605h6.3Z" transform="translate(11.002 274.5)" fill="black"/>
    </g>
    `,
  },

  "dialer-notificationRing-icon": {
    name: "dialer-notificationRing-icon",
    viewBox: "0 0 0 0",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path fill="#8193a8" d="M14.813 25.263c3.552.0 6.42-2.82 6.42-6.316V6.316C21.233 2.82 18.365.0 14.813.0 11.26.0 8.392 2.821 8.392 6.316v12.631c0 3.495 2.868 6.316 6.42 6.316zm12.649-6.316c-1.05.0-1.927.758-2.098 1.79-.877 4.947-5.265 8.737-10.551 8.737-5.287.0-9.674-3.79-10.552-8.737-.171-1.032-1.049-1.79-2.097-1.79-1.306.0-2.333 1.137-2.14 2.4 1.048 6.316 6.185 11.264 12.648 12.169v4.379c0 1.158.963 2.105 2.14 2.105 1.178.0 2.14-.947 2.14-2.105v-4.38c6.464-.904 11.601-5.852 12.65-12.168.214-1.263-.835-2.4-2.14-2.4z"/>
    `,
  },
  "dialOne-icon": {
    name: "dialOne-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="one" transform="translate(0.508 0.508)">
        <path
          id="_1"
          data-name="1"
          d="M59.509,84.671a104.906,104.906,0,0,1-32.6,0A30.182,30.182,0,0,1,1.782,59.51a104,104,0,0,1,0-32.6A30.167,30.167,0,0,1,26.914,1.782a104,104,0,0,1,32.6,0A30.182,30.182,0,0,1,84.671,26.914a104.906,104.906,0,0,1,0,32.6A30.2,30.2,0,0,1,59.509,84.671Z"
          transform="translate(-0.498 -0.497)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12011"
          data-name="Path 12011"
          d="M30.073,17.183H26.14v-2.5h6.748V43.119H30.073Z"
          transform="translate(12.061 6.448)"
          fill="#464646"
        />
      </g>
    `,
  },
  "dialTwo-icon": {
    name: "dialTwo-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="two" transform="translate(-114.809 0.508)">
        <path
          id="Path_12012"
          data-name="Path 12012"
          d="M136.906,84.671a104.905,104.905,0,0,1-32.6,0A30.182,30.182,0,0,1,79.179,59.509a104.906,104.906,0,0,1,0-32.6A30.167,30.167,0,0,1,104.31,1.782a104,104,0,0,1,32.6,0,30.167,30.167,0,0,1,25.147,25.132,104.906,104.906,0,0,1,0,32.6A30.182,30.182,0,0,1,136.906,84.671Z"
          transform="translate(37.412 -0.497)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12013"
          data-name="Path 12013"
          d="M100.35,41.066c8.164-6.108,15.27-12.246,15.27-18.324,0-3.292-1.49-5.959-5.825-5.959s-6.272,2.979-6.51,6.9h-2.7c.313-5.959,3.963-9.281,9.207-9.281,4.946,0,8.6,2.816,8.6,8.283,0,7.27-8.208,13.974-13.795,18.085H119.27v2.354H100.35Z"
          transform="translate(48.403 6.311)"
          fill="#464646"
        />
        <path
          id="Path_12014"
          data-name="Path 12014"
          d="M101.906,39a2.979,2.979,0,0,1,2.816,1.668V39.18h.909V46.3h-.909V44.677a2.979,2.979,0,0,1-2.831,1.683,3.68,3.68,0,0,1,0-7.329Zm.164.79a2.89,2.89,0,1,0,2.6,2.875A2.89,2.89,0,0,0,102.07,39.791Z"
          transform="translate(47.518 18.357)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12015"
          data-name="Path 12015"
          d="M108.439,39.788a3.68,3.68,0,0,1,0,7.329,2.979,2.979,0,0,1-2.845-1.668v1.49H104.7V37.39h.894V41.5A2.979,2.979,0,0,1,108.439,39.788Zm-.194.79a2.89,2.89,0,1,0,2.6,2.875A2.89,2.89,0,0,0,108.246,40.578Z"
          transform="translate(50.534 17.57)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12016"
          data-name="Path 12016"
          d="M113.855,39a3.084,3.084,0,0,1,3.277,2.428h-.983a2.175,2.175,0,0,0-2.294-1.639,2.533,2.533,0,0,0-2.533,2.875,2.547,2.547,0,0,0,2.533,2.979,2.175,2.175,0,0,0,2.294-1.668h.983a3.114,3.114,0,0,1-3.277,2.428,3.665,3.665,0,1,1,0-7.329Z"
          transform="translate(53.223 18.355)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialThree-icon": {
    name: "dialThree-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="three" transform="translate(-230.069 0.508)">
        <path
          id="Path_12017"
          data-name="Path 12017"
          d="M214.335,84.671a105,105,0,0,1-32.655,0,30.182,30.182,0,0,1-25.132-25.147,104.907,104.907,0,0,1,0-32.6A30.167,30.167,0,0,1,181.68,1.782a104.1,104.1,0,0,1,32.61,0,30.167,30.167,0,0,1,25.132,25.132,104.905,104.905,0,0,1,0,32.6A30.182,30.182,0,0,1,214.335,84.671Z"
          transform="translate(75.302 -0.497)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12018"
          data-name="Path 12018"
          d="M187.362,14.33c5.467,0,8.4,3.218,8.4,7.255a6.346,6.346,0,0,1-5.616,6.585v.209a7.076,7.076,0,0,1,6.153,7.374c0,4.32-2.979,7.732-8.938,7.732-5.348,0-9.281-2.89-9.832-8.283h2.7a6.7,6.7,0,0,0,7.136,5.959c4.2,0,6.227-2.5,6.227-5.631,0-4.2-3.173-6.033-8.685-6.033h-.864V27.142h.909c5.438,0,8.089-1.788,8.089-5.274,0-2.979-2.026-5.11-5.8-5.11-3.531,0-6.108,1.892-6.54,5.348h-2.7C178.424,17.265,182.044,14.33,187.362,14.33Z"
          transform="translate(86.201 6.277)"
          fill="#464646"
        />
        <path
          id="Path_12019"
          data-name="Path 12019"
          d="M180.806,39.788a3.069,3.069,0,0,1,2.8,1.639V37.39h.924v9.653h-.924V45.449a2.979,2.979,0,0,1-2.816,1.7,3.68,3.68,0,0,1,0-7.329Zm.149.79a2.89,2.89,0,1,0,2.6,2.875A2.89,2.89,0,0,0,180.955,40.578Z"
          transform="translate(86.158 17.57)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12020"
          data-name="Path 12020"
          d="M186.865,46.351a3.665,3.665,0,0,1,0-7.329,3.2,3.2,0,0,1,3.367,3.307,5.525,5.525,0,0,1,0,.715h-5.959a2.5,2.5,0,0,0,2.577,2.547A2.2,2.2,0,0,0,189.144,44h.968a3.128,3.128,0,0,1-3.248,2.354ZM184.288,42.3h5.02a2.339,2.339,0,0,0-2.488-2.488,2.458,2.458,0,0,0-2.533,2.488Z"
          transform="translate(88.978 18.367)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12021"
          data-name="Path 12021"
          d="M189.513,40.771h-.983V40h.983V39.5c0-1.49.73-2.264,2.518-2.264v.79c-1.207,0-1.594.447-1.594,1.49v.492h1.654v.775h-1.654v6.346h-.924Z"
          transform="translate(91.588 17.496)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialFour-icon": {
    name: "dialFour-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="four" transform="translate(0.508 -104.738)">
        <path
          id="Path_12022"
          data-name="Path 12022"
          d="M59.509,155.248a104.907,104.907,0,0,1-32.6,0A30.167,30.167,0,0,1,1.782,130.116a104.1,104.1,0,0,1,0-32.61A30.167,30.167,0,0,1,26.914,72.419a104.907,104.907,0,0,1,32.6,0A30.182,30.182,0,0,1,84.671,97.506a105,105,0,0,1,0,32.61,30.182,30.182,0,0,1-25.162,25.132Z"
          transform="translate(-0.498 34.101)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12023"
          data-name="Path 12023"
          d="M36.9,106.907H22v-2.1L36.435,85.44h3.292v19.054H43.9v2.413H39.653v6.748H36.9Zm.119-2.413V88.419L25.1,104.494Z"
          transform="translate(10.033 41.102)"
          fill="#464646"
        />
        <path
          id="Path_12024"
          data-name="Path 12024"
          d="M26.361,109.631a2.979,2.979,0,0,1,2.83,1.654V109.8H30.1v7.315a3.158,3.158,0,0,1-3.337,3.307,3.143,3.143,0,0,1-3.4-2.428h.894a2.443,2.443,0,0,0,2.5,1.639,2.324,2.324,0,0,0,2.428-2.518v-1.773a2.979,2.979,0,0,1-2.83,1.683,3.68,3.68,0,0,1,0-7.329Zm.179.79a2.89,2.89,0,0,0,0,5.75,2.89,2.89,0,0,0,0-5.75Z"
          transform="translate(10.529 52.947)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12025"
          data-name="Path 12025"
          d="M29.17,108h.909v3.754a2.667,2.667,0,0,1,2.473-1.356,2.756,2.756,0,0,1,2.845,3.084v4.171H34.5v-4.067a2.086,2.086,0,0,0-2.175-2.384c-1.326,0-2.249.834-2.249,2.562v3.888H29.17Z"
          transform="translate(13.544 52.15)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12026"
          data-name="Path 12026"
          d="M34.572,108.528a.67.67,0,1,1,.3.663A.67.67,0,0,1,34.572,108.528Zm.209,2.026h.909v7.121h-.909Z"
          transform="translate(16.187 52.129)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialFive-icon": {
    name: "dialFive-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="five" transform="translate(-114.809 -104.738)">
        <path
          id="Path_12027"
          data-name="Path 12027"
          d="M136.906,155.248a104.906,104.906,0,0,1-32.6,0,30.167,30.167,0,0,1-25.132-25.132,105,105,0,0,1,0-32.61A30.167,30.167,0,0,1,104.31,72.419a104.907,104.907,0,0,1,32.6,0A30.167,30.167,0,0,1,162.052,97.55a105,105,0,0,1,0,32.61,30.167,30.167,0,0,1-25.147,25.087Z"
          transform="translate(37.412 34.101)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12028"
          data-name="Path 12028"
          d="M117.963,85.26v2.428H103.438V97.833a8.8,8.8,0,0,1,7.017-3.173c6.868,0,9.207,4.842,9.207,9.326,0,5.348-2.979,9.877-9.639,9.877-5.512,0-8.938-3.128-9.713-7.851h2.741a6.585,6.585,0,0,0,6.972,5.467c4.8,0,6.987-3.173,6.987-7.449s-2.384-6.987-6.9-6.987a6.987,6.987,0,0,0-6.629,3.963h-2.622V85.26Z"
          transform="translate(48.384 41.013)"
          fill="#464646"
        />
        <path
          id="Path_12029"
          data-name="Path 12029"
          d="M104.674,110.582v8.8a1.49,1.49,0,0,1-1.713,1.683h-.641v-.775h.492c.685,0,.953-.253.953-.939v-8.775Zm-1.1-2.026a.641.641,0,0,1,.67-.655.626.626,0,0,1,.641.655.641.641,0,0,1-.641.685.655.655,0,0,1-.67-.685Z"
          transform="translate(49.368 52.101)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12030"
          data-name="Path 12030"
          d="M105.315,108h.924v5.721l2.86-3.188h1.281L107,114.078l3.411,3.575h-1.236l-2.979-3.188v3.188h-.924Z"
          transform="translate(50.813 52.15)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12031"
          data-name="Path 12031"
          d="M109.5,108h.924v9.653H109.5Z"
          transform="translate(52.885 52.15)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialSix-icon": {
    name: "dialSix-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="six" transform="translate(-230.113 -104.738)">
        <path
          id="Path_12032"
          data-name="Path 12032"
          d="M214.321,155.248a105,105,0,0,1-32.61,0,30.167,30.167,0,0,1-25.132-25.132,105,105,0,0,1,0-32.61,30.167,30.167,0,0,1,25.087-25.087,105,105,0,0,1,32.61,0,30.167,30.167,0,0,1,25.132,25.132,105,105,0,0,1,0,32.61A30.167,30.167,0,0,1,214.321,155.248Z"
          transform="translate(75.316 34.101)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12033"
          data-name="Path 12033"
          d="M193.609,92.47a5.542,5.542,0,0,0-5.959-5.154c-4.991,0-7.806,3.441-7.613,12.886,1.073-3.248,4.469-5.11,8.164-5.11,5.557,0,9.058,3.605,9.058,9.594,0,5.035-2.86,9.4-9.281,9.4-8.492,0-10.428-6.272-10.428-14.435,0-8.938,2.816-14.674,10.071-14.674a8.015,8.015,0,0,1,8.566,7.449Zm-13.244,11.784c0,4.007,2.294,7.449,7.449,7.449,4.082,0,6.7-2.667,6.7-6.942,0-4.6-2.473-7.344-6.868-7.344-3.471-.03-7.285,2.071-7.285,6.763Z"
          transform="translate(86.211 40.865)"
          fill="#464646"
        />
        <path
          id="Path_12034"
          data-name="Path 12034"
          d="M185.143,112.8c0-1.579-.819-2.384-2.086-2.384s-2.2.864-2.2,2.592v3.858h-.909V112.8c0-1.579-.834-2.384-2.1-2.384s-2.2.864-2.2,2.592v3.858h-.909v-7.121h.909v1.222a2.562,2.562,0,0,1,2.369-1.356,2.637,2.637,0,0,1,2.637,1.758,2.592,2.592,0,0,1,2.562-1.758,2.741,2.741,0,0,1,2.83,3.084v4.171h-.894Z"
          transform="translate(84.83 52.937)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12035"
          data-name="Path 12035"
          d="M189.013,112.8a2.086,2.086,0,0,0-2.175-2.384c-1.326,0-2.249.834-2.249,2.562v3.888h-.909v-7.121h.909v1.222a2.607,2.607,0,0,1,2.428-1.356,2.771,2.771,0,0,1,2.89,3.084v4.171h-.894Z"
          transform="translate(89.213 52.937)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12036"
          data-name="Path 12036"
          d="M192.539,116.959a3.665,3.665,0,1,1,3.59-3.665,3.471,3.471,0,0,1-3.59,3.665Zm0-.79a2.89,2.89,0,1,0-2.607-2.875,2.577,2.577,0,0,0,2.607,2.845Z"
          transform="translate(91.72 52.948)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialSeven-icon": {
    name: "dialSeven-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="seven" transform="translate(0.508 -209.883)">
        <path
          id="Path_12037"
          data-name="Path 12037"
          d="M59.509,225.872a104.908,104.908,0,0,1-32.6,0A30.167,30.167,0,0,1,1.782,200.741a104.1,104.1,0,0,1,0-32.61A30.167,30.167,0,0,1,26.914,143a104.91,104.91,0,0,1,32.6,0A30.182,30.182,0,0,1,84.671,168.13a105,105,0,0,1,0,32.61A30.182,30.182,0,0,1,59.509,225.872Z"
          transform="translate(-0.498 68.666)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12038"
          data-name="Path 12038"
          d="M41.362,155.93v2.13L30.293,184.339H27.478l11.188-26.026H22.8v-2.369Z"
          transform="translate(10.425 75.623)"
          fill="#464646"
        />
        <path
          id="Path_12039"
          data-name="Path 12039"
          d="M24,180.242a3.68,3.68,0,0,1,0,7.329,2.979,2.979,0,0,1-2.845-1.728v4.931H20.26V180.346h.894v1.564A2.98,2.98,0,0,1,24,180.242Zm-.194.79a2.89,2.89,0,0,0,0,5.75,2.89,2.89,0,0,0,0-5.75Z"
          transform="translate(9.181 87.527)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12040"
          data-name="Path 12040"
          d="M29.291,180.26a2.979,2.979,0,0,1,2.816,1.668v-1.564h.909v10.428h-.909v-4.931a2.98,2.98,0,0,1-2.845,1.669,3.68,3.68,0,0,1,0-7.329Zm.164.79a2.89,2.89,0,0,0,0,5.75,2.89,2.89,0,0,0,0-5.75Z"
          transform="translate(11.949 87.508)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12041"
          data-name="Path 12041"
          d="M32.989,187.479H32.08v-7.121h.909v1.266a2.443,2.443,0,0,1,2.443-1.4v.953h-.253c-1.192,0-2.19.536-2.19,2.324Z"
          transform="translate(14.97 87.515)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12042"
          data-name="Path 12042"
          d="M37.835,187.576c-1.624,0-2.756-.8-2.875-2.115H35.9c.089.79.76,1.356,1.922,1.356s1.594-.551,1.594-1.236c0-1.758-4.276-.73-4.276-3.4,0-1.058,1-1.937,2.5-1.937a2.309,2.309,0,0,1,2.607,2.175H39.34a1.49,1.49,0,0,0-1.728-1.385c-.953,0-1.49.506-1.49,1.132,0,1.922,4.216.894,4.261,3.411A2.287,2.287,0,0,1,37.835,187.576Z"
          transform="translate(16.38 87.522)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialEight-icon": {
    name: "dialEight-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="eight" transform="translate(-114.809 -209.883)">
        <path
          id="Path_12043"
          data-name="Path 12043"
          d="M136.906,225.872a104.9,104.9,0,0,1-32.6,0,30.167,30.167,0,0,1-25.132-25.132,105,105,0,0,1,0-32.61A30.167,30.167,0,0,1,104.31,143a104.905,104.905,0,0,1,32.6,0,30.167,30.167,0,0,1,25.147,25.132,105,105,0,0,1,0,32.61,30.167,30.167,0,0,1-25.147,25.132Z"
          transform="translate(37.412 68.666)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12044"
          data-name="Path 12044"
          d="M100.6,163.089c0-4.2,3.248-7.449,9.326-7.449s9.311,3.263,9.311,7.449A6.644,6.644,0,0,1,114.2,169.7a7.21,7.21,0,0,1,5.8,7.225c0,5.125-3.963,8.372-10.071,8.372s-10.085-3.248-10.085-8.372a7.21,7.21,0,0,1,5.8-7.225,6.585,6.585,0,0,1-5.035-6.614Zm1.937,13.765c0,3.8,2.86,6.108,7.449,6.108s7.329-2.339,7.329-6.108c0-4.082-3.248-5.959-7.329-5.959S102.537,172.682,102.537,176.854Zm14-13.408c0-3.575-2.607-5.467-6.614-5.467s-6.629,1.862-6.629,5.467c0,3.292,2.652,5.393,6.629,5.393s6.614-2.145,6.614-5.438Z"
          transform="translate(48.153 75.481)"
          fill="#464646"
        />
        <path
          id="Path_12045"
          data-name="Path 12045"
          d="M101.168,181.672h-1V180.9h1V179.11h.924V180.9h1.952v.775h-1.952v4.469c0,.864.3,1.147,1.117,1.147h.834v.775h-.968c-1.251,0-1.907-.507-1.907-1.922Z"
          transform="translate(48.315 86.975)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12046"
          data-name="Path 12046"
          d="M110,187.446h-.909v-1.251a2.562,2.562,0,0,1-2.428,1.371,2.756,2.756,0,0,1-2.979-3.069v-4.171h.909v4.007c0,1.594.864,2.4,2.16,2.4s2.264-.834,2.264-2.577V180.28h.909Z"
          transform="translate(50.028 87.548)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12047"
          data-name="Path 12047"
          d="M109.743,180.31l2.369,6.242,2.4-6.242h.968l-2.86,7.121H111.59l-2.86-7.121Z"
          transform="translate(52.507 87.562)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialNine-icon": {
    name: "dialNine-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="nine" transform="translate(-230.113 -209.883)">
        <path
          id="Path_12048"
          data-name="Path 12048"
          d="M214.321,225.872a105,105,0,0,1-32.61,0,30.167,30.167,0,0,1-25.132-25.132,105,105,0,0,1,0-32.61A30.167,30.167,0,0,1,181.666,143a105,105,0,0,1,32.61,0,30.167,30.167,0,0,1,25.132,25.132,105,105,0,0,1,0,32.61A30.167,30.167,0,0,1,214.321,225.872Z"
          transform="translate(75.316 68.666)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12049"
          data-name="Path 12049"
          d="M181.051,176.928a5.78,5.78,0,0,0,6.227,5.363c4.767,0,7.449-3.262,7.181-12.573-1.028,2.979-4.156,4.678-7.732,4.678-5.467,0-9.207-3.411-9.207-9.445,0-5.2,2.979-9.4,9.326-9.4,8.015,0,10.071,5.87,10.071,14.2,0,9.37-2.294,14.9-9.758,14.9a8.045,8.045,0,0,1-8.685-7.7Zm13.02-11.575c0-4.082-2.309-7.449-7.151-7.449a6.436,6.436,0,0,0-6.734,6.987c0,4.365,2.458,7.136,6.972,7.136a6.5,6.5,0,0,0,6.912-6.674Z"
          transform="translate(86.196 75.437)"
          fill="#464646"
        />
        <path
          id="Path_12050"
          data-name="Path 12050"
          d="M174.32,180.31h.924l1.773,6.2,2-6.2h.924l1.966,6.212,1.758-6.212h.909l-2.235,7.121h-.924l-1.966-5.959-1.966,5.959h-.924Z"
          transform="translate(84.629 87.562)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12051"
          data-name="Path 12051"
          d="M184.191,184.571l-1.773,2.86h-.968l2.309-3.56-2.264-3.56h1.028l1.817,2.83,1.758-2.83h.953l-2.264,3.531,2.294,3.59h-1.028Z"
          transform="translate(88.121 87.562)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12052"
          data-name="Path 12052"
          d="M191.275,180.325h.953L188,190.753h-.953l1.385-3.382-2.979-7.091h1l2.428,6.078Z"
          transform="translate(90.08 87.548)"
          fill="#9a9a9a"
        />
        <path
          id="Path_12053"
          data-name="Path 12053"
          d="M195.148,181.07l-3.665,5.616h3.739v.745H190.44v-.745l3.665-5.616h-3.59v-.76h4.633Z"
          transform="translate(92.523 87.562)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "dialZero-icon": {
    name: "dialZero-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="zero" transform="translate(-114.809 -315.147)">
        <path
          id="Path_12056"
          data-name="Path 12056"
          d="M136.906,296.458a104.91,104.91,0,0,1-32.6,0A30.167,30.167,0,0,1,79.179,271.4a105,105,0,0,1,0-32.61,30.167,30.167,0,0,1,25.132-25.132,104.908,104.908,0,0,1,32.6,0,30.167,30.167,0,0,1,25.147,25.132,105,105,0,0,1,0,32.61,30.167,30.167,0,0,1-25.147,25.057Z"
          transform="translate(37.412 103.27)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12057"
          data-name="Path 12057"
          d="M109.779,226.24c7.776,0,9.639,6.227,9.639,14.361s-1.862,14.555-9.639,14.555S100.14,248.9,100.14,240.6,101.957,226.24,109.779,226.24Zm0,2.5c-5.959,0-6.912,5.438-6.912,11.918,0,6.674.879,12.022,6.912,12.022s6.9-5.348,6.9-12.022C116.676,234.18,115.8,228.743,109.779,228.743Z"
          transform="translate(48.301 110.056)"
          fill="#464646"
        />
        <path
          id="Path_12058"
          data-name="Path 12058"
          d="M108.4,252.46v3.352h3.322v.894H108.4v3.352h-.953v-3.352H104.14v-.894h3.307V252.46Z"
          transform="translate(50.26 122.896)"
          fill="#9a9a9a"
        />
      </g>
    `,
  },
  "hash-icon": {
    name: "hash-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="hash-icon" transform="translate(-230.113 -315.073)">
        <path
          id="Path_12059"
          data-name="Path 12059"
          d="M214.321,296.483a105,105,0,0,1-32.61,0,30.167,30.167,0,0,1-25.132-25.057,105,105,0,0,1,0-32.61,30.167,30.167,0,0,1,25.087-25.206,105,105,0,0,1,32.61,0,30.167,30.167,0,0,1,25.132,25.132,105,105,0,0,1,0,32.61A30.167,30.167,0,0,1,214.321,296.483Z"
          transform="translate(75.316 103.246)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12060"
          data-name="Path 12060"
          d="M191.9,246.756h-8.8l-1.832,8.492h-2.652l1.817-8.492h-6.3V244.3h6.823l1.49-7.33h-6.2v-2.458h6.748l1.817-8.611h2.667l-1.832,8.611h8.8l1.832-8.611h2.652l-1.818,8.611h5.75v2.458h-6.3l-1.49,7.329h5.676v2.458h-6.2l-1.817,8.491H190.07Zm2.056-9.788h-8.8l-1.49,7.329h8.8Z"
          transform="translate(84.536 109.889)"
          fill="#464646"
        />
      </g>
    `,
  },
  "asterik-icon": {
    name: "asterik-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="sterik-icon" transform="translate(0.508 -315.148)">
        <path
          id="Path_12054"
          data-name="Path 12054"
          d="M59.509,296.458a104.911,104.911,0,0,1-32.6,0A30.167,30.167,0,0,1,1.782,271.4a104.1,104.1,0,0,1,0-32.61,30.167,30.167,0,0,1,25.132-25.132,104.907,104.907,0,0,1,32.6,0,30.182,30.182,0,0,1,25.162,25.057,105,105,0,0,1,0,32.685,30.182,30.182,0,0,1-25.162,25.057Z"
          transform="translate(-0.498 103.27)"
          fill="none"
          stroke="#a3a3a3"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <path
          id="Path_12055"
          data-name="Path 12055"
          d="M32.232,232.347l5.11-3.412,1.117,2.026-5.6,2.443,5.631,2.533-1.147,2.071-5.11-3.411.447,6.257H30.4l.447-6.227-5.125,3.441-1.192-2.1,5.631-2.533-5.586-2.5,1.147-2.071,5.154,3.456L30.4,226.09h2.279Z"
          transform="translate(11.272 109.982)"
          fill="#464646"
        />
      </g>
    `,
  },
  "dialPad-call-icon": {
    name: "dialPad-call-icon",
    viewBox: "0 0 86.463 86.463",
    fill: "none",
    "stroke-width": "1",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "",
    icon: `
      <g id="keypad-call-icon" transform="translate(-115.317 -427.564)">
        <path
          id="Path_12061"
          data-name="Path 12061"
          d="M136.906,371.667a104.912,104.912,0,0,1-32.6,0,30.182,30.182,0,0,1-25.132-25.147,104.907,104.907,0,0,1,0-32.6,30.2,30.2,0,0,1,25.132-25.147,104.907,104.907,0,0,1,32.6,0,30.2,30.2,0,0,1,25.147,25.147,104.908,104.908,0,0,1,0,32.6,30.182,30.182,0,0,1-25.147,25.147Z"
          transform="translate(37.412 140.059)"
          fill="#4cd964"
        />
        <g id="Call-icon" transform="translate(139.934 452.122)">
          <rect
            id="Rectangle_2952"
            data-name="Rectangle 2952"
            width="36.171"
            height="36.171"
            transform="translate(0)"
            fill="rgba(243,243,243,0)"
          />
          <path
            id="phone"
            d="M130.541,331.064V336.5a3.635,3.635,0,0,1-3.62,3.65h-.358a35.949,35.949,0,0,1-15.657-5.572,35.337,35.337,0,0,1-10.89-10.89,35.932,35.932,0,0,1-5.572-15.732,3.635,3.635,0,0,1,3.277-3.948h5.78a3.635,3.635,0,0,1,3.62,3.128,23.224,23.224,0,0,0,1.281,5.095,3.635,3.635,0,0,1-.819,3.829l-2.309,2.309a28.946,28.946,0,0,0,10.89,10.89l2.309-2.309a3.635,3.635,0,0,1,3.829-.8,23.836,23.836,0,0,0,5.095,1.266,3.62,3.62,0,0,1,3.128,3.68Z"
            transform="translate(-94.43 -303.98)"
            fill="#f3f3f3"
          />
        </g>
      </g>
    `,
  },
  "dialer-edit-icon": {
    name: "dialer-edit-icon",
    viewBox: "0 0 31.997 31.997",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
       <path id="Path_12166" data-name="Path 12166" d="M30.122,1.875a6.4,6.4,0,0,0-9.054,0L3.177,19.767a1.25,1.25,0,0,0-.32.549l-2.81,10.1a1.25,1.25,0,0,0,1.546,1.537l10.1-2.868A1.25,1.25,0,0,0,12.232,27L5.867,20.612,20.7,5.781,26.213,11.3,14.859,22.62a1.25,1.25,0,0,0,1.765,1.77l13.5-13.461a6.4,6.4,0,0,0,0-9.054ZM8.962,27.257l-5.91,1.679L4.707,22.99ZM28.356,9.16l-.373.372L22.465,4.014l.371-.371a3.9,3.9,0,0,1,5.52,5.517Z" transform="translate(0)" fill="#fff"/>
    `,
  },
  "dialer-delete-icon": {
    name: "dialer-delete-icon",
    viewBox: "0 0 16 19.995",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="trash" transform="translate(-48)">
        <path id="Path_12245" data-name="Path 12245" d="M62.462,2.5H59.077V1.875A1.863,1.863,0,0,0,57.231,0H54.769a1.863,1.863,0,0,0-1.846,1.875V2.5H49.538A1.552,1.552,0,0,0,48,4.062V6.248a.62.62,0,0,0,.615.625h.336l.532,11.336A1.857,1.857,0,0,0,51.327,20h9.345a1.857,1.857,0,0,0,1.844-1.785l.532-11.336h.336A.62.62,0,0,0,64,6.248V4.062A1.552,1.552,0,0,0,62.462,2.5Zm-8.308-.625a.621.621,0,0,1,.615-.625h2.462a.621.621,0,0,1,.615.625V2.5H54.154ZM49.231,4.062a.31.31,0,0,1,.308-.312H62.462a.31.31,0,0,1,.308.312V5.624H49.231ZM61.287,18.15a.619.619,0,0,1-.615.6H51.327a.619.619,0,0,1-.615-.6L50.184,6.873H61.816Z" transform="translate(0)" fill="#8e8e8e"/>
        <path id="Path_12246" data-name="Path 12246" d="M240.625,217.373a.625.625,0,0,0,.625-.625v-8.123a.625.625,0,1,0-1.25,0v8.123A.625.625,0,0,0,240.625,217.373Z" transform="translate(-184.625 -199.877)" fill="#8e8e8e"/>
        <path id="Path_12247" data-name="Path 12247" d="M320.625,217.373a.625.625,0,0,0,.625-.625v-8.123a.625.625,0,1,0-1.25,0v8.123A.625.625,0,0,0,320.625,217.373Z" transform="translate(-261.552 -199.877)" fill="#8e8e8e"/>
        <path id="Path_12248" data-name="Path 12248" d="M160.625,217.373a.625.625,0,0,0,.625-.625v-8.123a.625.625,0,1,0-1.25,0v8.123A.625.625,0,0,0,160.625,217.373Z" transform="translate(-107.698 -199.877)" fill="#8e8e8e"/>
      </g>
    `,
  },
  "dialer-delete-icon-filled": {
    name: "dialer-delete-icon-filled",
    viewBox: "0 0 19.475 25.039",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <path id="Icon_material-delete" data-name="Icon material-delete" d="M8.891,26.757a2.79,2.79,0,0,0,2.782,2.782H22.8a2.79,2.79,0,0,0,2.782-2.782V10.064H8.891ZM26.975,5.891H22.106L20.715,4.5H13.76L12.369,5.891H7.5V8.673H26.975Z" transform="translate(-7.5 -4.5)"/>  
    `,
  },
  "dialer-arrowDown-icon": {
    name: "dialer-arrowDown-icon",
    viewBox: "0 0 13.825 8.326",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
         <path id="arrowDown" d="M0,0,5.5,5.5,11,0" transform="translate(1.414 1.414)" fill="none" stroke="#5b5b5b" stroke-linecap="round" stroke-width="2"/>
    `,
  },
  "dialer-userInBox-icon": {
    name: "dialer-userInBox-icon",
    viewBox: "0 0 50 50",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="user-inBox" transform="translate(-24 -32.001)">
      <path id="Path_12210" data-name="Path 12210" d="M35.029,49.752a61.387,61.387,0,0,1-19.073,0A17.661,17.661,0,0,1,1.249,35.029a60.855,60.855,0,0,1,0-19.073A17.652,17.652,0,0,1,15.955,1.249a60.855,60.855,0,0,1,19.073,0A17.661,17.661,0,0,1,49.752,15.955a61.387,61.387,0,0,1,0,19.073A17.67,17.67,0,0,1,35.029,49.752Z" transform="translate(23.503 31.503)" fill="#f1f6ff"/>
      <g id="user" transform="translate(37 45)">
        <g id="Group_12533" data-name="Group 12533">
          <path id="Path_12152" data-name="Path 12152" d="M23.94,20.565a.937.937,0,0,0-1.836.382.98.98,0,0,1-.2.821.952.952,0,0,1-.75.357H2.845a.953.953,0,0,1-.75-.357.979.979,0,0,1-.2-.821,10.358,10.358,0,0,1,9.855-8.2q.124,0,.249,0t.249,0a10.313,10.313,0,0,1,8.329,4.578.937.937,0,1,0,1.557-1.044,12.2,12.2,0,0,0-6.319-4.8,6.375,6.375,0,1,0-7.631,0A12.194,12.194,0,0,0,.061,20.565,2.848,2.848,0,0,0,2.845,24h18.31a2.848,2.848,0,0,0,2.784-3.435ZM7.5,6.375a4.5,4.5,0,1,1,4.728,4.494l-.228,0-.227,0A4.506,4.506,0,0,1,7.5,6.375Z" transform="translate(0)" fill="#005dff" stroke="#005dff" stroke-width="0.3"/>
        </g>
      </g>
    </g>
    `,
  },
  "dialer-padInBox-icon": {
    name: "dialer-padInBox-icon",
    viewBox: "0 0 50 50",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <g id="pad-inBox" transform="translate(-24 -32.001)">
      <path id="Path_12210" data-name="Path 12210" d="M35.029,49.752a61.387,61.387,0,0,1-19.073,0A17.661,17.661,0,0,1,1.249,35.029a60.855,60.855,0,0,1,0-19.073A17.652,17.652,0,0,1,15.955,1.249a60.855,60.855,0,0,1,19.073,0A17.661,17.661,0,0,1,49.752,15.955a61.387,61.387,0,0,1,0,19.073A17.67,17.67,0,0,1,35.029,49.752Z" transform="translate(23.503 31.503)" fill="#f1f6ff"/>
      <g id="pad" transform="translate(38 46)">
        <g id="Group_12543" data-name="Group 12543">
          <g id="Group_12542" data-name="Group 12542">
            <path id="Path_12153" data-name="Path 12153" d="M2.72,0A2.72,2.72,0,1,0,5.44,2.72,2.723,2.723,0,0,0,2.72,0Z" transform="translate(0)" fill="#005dff"/>
            <path id="Path_12154" data-name="Path 12154" d="M2.72,192a2.72,2.72,0,1,0,2.72,2.72A2.723,2.723,0,0,0,2.72,192Z" transform="translate(0 -184)" fill="#005dff"/>
            <path id="Path_12155" data-name="Path 12155" d="M2.72,384a2.72,2.72,0,1,0,2.72,2.72A2.723,2.723,0,0,0,2.72,384Z" transform="translate(0 -368)" fill="#005dff"/>
            <path id="Path_12156" data-name="Path 12156" d="M194.72,0a2.72,2.72,0,1,0,2.72,2.72A2.723,2.723,0,0,0,194.72,0Z" transform="translate(-184.218)" fill="#005dff"/>
            <path id="Path_12157" data-name="Path 12157" d="M194.72,192a2.72,2.72,0,1,0,2.72,2.72A2.723,2.723,0,0,0,194.72,192Z" transform="translate(-184.218 -184)" fill="#005dff"/>
            <path id="Path_12158" data-name="Path 12158" d="M194.72,384a2.72,2.72,0,1,0,2.72,2.72A2.723,2.723,0,0,0,194.72,384Z" transform="translate(-184.218 -368)" fill="#005dff"/>
            <path id="Path_12159" data-name="Path 12159" d="M386.72,5.44A2.72,2.72,0,1,0,384,2.72,2.723,2.723,0,0,0,386.72,5.44Z" transform="translate(-368.436)" fill="#005dff"/>
            <path id="Path_12160" data-name="Path 12160" d="M386.72,192a2.72,2.72,0,1,0,2.72,2.72A2.723,2.723,0,0,0,386.72,192Z" transform="translate(-368.436 -184)" fill="#005dff"/>
            <path id="Path_12161" data-name="Path 12161" d="M386.72,384a2.72,2.72,0,1,0,2.72,2.72A2.723,2.723,0,0,0,386.72,384Z" transform="translate(-368.436 -368)" fill="#005dff"/>
          </g>
        </g>
      </g>
    </g>
    `,
  },

  // sip active call icons
  "dialer-callAcceptInbox-icon": {
    name: "dialer-callAcceptInbox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="dialer-callAcceptInbox-icon" transform="translate(1.001 1)">
      <path id="Path_12118" data-name="Path 12118" d="M28.121,39.9a49.108,49.108,0,0,1-15.258,0A14.128,14.128,0,0,1,1.1,28.121a48.682,48.682,0,0,1,0-15.258A14.121,14.121,0,0,1,12.863,1.1a48.682,48.682,0,0,1,15.258,0A14.128,14.128,0,0,1,39.9,12.863a49.108,49.108,0,0,1,0,15.258A14.136,14.136,0,0,1,28.121,39.9Z" transform="translate(-1.498 -1.497)" fill="#3dd66b"/>
      <path id="phone_1_" data-name="phone (1)" d="M19.251,14.833v2.58a1.722,1.722,0,0,1-1.879,1.721,17.079,17.079,0,0,1-7.438-2.64,16.789,16.789,0,0,1-5.171-5.159A17,17,0,0,1,2.119,3.875,1.722,1.722,0,0,1,3.834,2h2.58a1.723,1.723,0,0,1,1.73,1.479,11.026,11.026,0,0,0,.6,2.417A1.718,1.718,0,0,1,8.36,7.711L7.265,8.8a13.776,13.776,0,0,0,5.171,5.159l1.1-1.092a1.726,1.726,0,0,1,1.819-.387,11.085,11.085,0,0,0,2.422.6,1.722,1.722,0,0,1,1.479,1.748Z" transform="translate(7.888 8)" fill="#fff"/>
    </g>`,
  },
  "dialer-callRejectInbox-icon": {
    name: "dialer-callRejectInbox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#e53030"/>
    <path id="phone_1_" data-name="phone (1)" d="M19.254,14.835v2.581a1.723,1.723,0,0,1-1.879,1.72,17.08,17.08,0,0,1-7.439-2.641,16.791,16.791,0,0,1-5.172-5.161A17,17,0,0,1,2.119,3.875,1.722,1.722,0,0,1,3.834,2H6.42A1.723,1.723,0,0,1,8.144,3.48a11.027,11.027,0,0,0,.6,2.417,1.718,1.718,0,0,1-.388,1.815L7.265,8.8a13.777,13.777,0,0,0,5.172,5.161l1.095-1.092a1.726,1.726,0,0,1,1.819-.387,11.085,11.085,0,0,0,2.422.6,1.721,1.721,0,0,1,1.483,1.746Z" transform="translate(35.03 19.921) rotate(135)" fill="#fff"/>
    `,
  },
  "dialer-muteInBox-icon": {
    name: "dialer-muteInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
    <g id="mic-mute-fill" transform="translate(8.296 10.004)">
      <path id="Path_14330" data-name="Path 14330" d="M17.664,12.013A6.2,6.2,0,0,0,18,10V8.747a.63.63,0,0,0-1.259,0V10a4.941,4.941,0,0,1-.1,1Zm-3.175,2.15a5.068,5.068,0,0,1-5.166.24A4.994,4.994,0,0,1,6.668,10V8.747a.63.63,0,0,0-1.259,0V10a6.267,6.267,0,0,0,5.666,6.218v2.531H7.3A.625.625,0,1,0,7.3,20H16.11a.625.625,0,1,0,0-1.25H12.333V16.215a6.289,6.289,0,0,0,3.06-1.154l-.9-.9Zm.992-4.316v-6.1a3.781,3.781,0,0,0-7.355-1.2l7.355,7.3Zm-7.554-2.2,5.648,5.607a3.8,3.8,0,0,1-3.768-.015A3.745,3.745,0,0,1,7.927,10V7.648Zm10.886,9.041L3.7,1.69,4.6.805,19.7,15.8l-.891.884Z" transform="translate(0 0)" fill="#636363" fill-rule="evenodd"/>
    </g>`,
  },
  "dialer-unMuteInBox-icon": {
    name: "dialer-unMuteInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
    <g id="mic-mute-fill" transform="translate(8.296 10.004)">
      <path id="Path_14330" data-name="Path 14330" d="M18,10v0Zm-3.5,4.2a5.088,5.088,0,0,1-5.178.2A4.994,4.994,0,0,1,6.668,10V8.747a.63.63,0,0,0-1.259,0V10a6.267,6.267,0,0,0,5.666,6.218v2.531H7.3A.625.625,0,1,0,7.3,20H16.11a.625.625,0,1,0,0-1.25H12.333V16.215a6.289,6.289,0,0,0,3.06-1.154A6.438,6.438,0,0,0,18.126,10,5.073,5.073,0,0,0,18,8.747s-.107-.564-.56-.625-.7.625-.7.625c0-.161-.005,1.082,0,1.25A5.348,5.348,0,0,1,14.5,14.2Zm.98-4.352v-6.1a3.781,3.781,0,0,0-7.355-1.2l7.355,7.3Zm-7.355-7.3,7.355,7.3a4.782,4.782,0,0,1-1.906,3.407,3.8,3.8,0,0,1-3.768-.015,3.879,3.879,0,0,1-1.88-3.2c.005.2,0,.08,0-.039l.2-7.452ZM18.813,16.688,19.7,15.8l-.891.884Z" transform="translate(0 0)" fill="#636363" fill-rule="evenodd"/>
    </g>`,
  },
  "dialer-SwitchIconInBox": {
    name: "dialer-SwitchIconInBox",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="Group_13002" data-name="Group 13002" transform="translate(11.489 0)">
        <path id="Path_12147" data-name="Path 12147" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-11.986 -0.498)" fill="#ececec"/>
        <path id="exchange_1_" data-name="exchange (1)" d="M17.518,20.25A3.863,3.863,0,0,1,13.559,24h-9.6A3.863,3.863,0,0,1,0,20.25V3.75A3.863,3.863,0,0,1,3.959,0h9.6a3.863,3.863,0,0,1,3.959,3.75v.381a.991.991,0,0,1-1.979,0V3.75a1.932,1.932,0,0,0-1.979-1.875h-9.6A1.932,1.932,0,0,0,1.979,3.75v16.5a1.932,1.932,0,0,0,1.979,1.875h9.6a1.932,1.932,0,0,0,1.979-1.875.991.991,0,0,1,1.979,0Zm-9.748-.51a.991.991,0,1,0,.99-.938A.965.965,0,0,0,7.769,19.74ZM11.738,4.271a.965.965,0,0,0-.99-.938H6.769a.965.965,0,0,0-.99.938.965.965,0,0,0,.99.938h3.979A.965.965,0,0,0,11.738,4.271Zm9.437,2.672h-8.21a.939.939,0,1,0,0,1.875h8.31L20.137,9.886a.9.9,0,0,0-.007,1.326,1.029,1.029,0,0,0,1.4.006l1.738-1.631a2.249,2.249,0,0,0,0-3.321L21.529,4.636a1.029,1.029,0,0,0-1.4.007.9.9,0,0,0,.007,1.326Zm1.835,6.422H14.7L15.839,12.3a.9.9,0,0,0,.007-1.326,1.029,1.029,0,0,0-1.4-.007L12.708,12.6a2.249,2.249,0,0,0,0,3.321l1.738,1.631a1.029,1.029,0,0,0,1.4-.006.9.9,0,0,0-.007-1.326L14.8,15.24h8.21a.939.939,0,1,0,0-1.875Zm0,0" transform="translate(-3.489 8)" fill="#636363" stroke="#636363" stroke-width="0.3"/>
      </g>
      `,
  },
  "dialer-keypadInBox-icon": {
    name: "dialer-keypadInBox-icon  ",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
    <g id="ios-keypad-outline" transform="translate(6.238 6.239)">
      <circle id="Ellipse_981" data-name="Ellipse 981" cx="2.5" cy="2.5" r="2.5" transform="translate(4.762 4.761)" fill="#636363"/>
      <circle id="Ellipse_982" data-name="Ellipse 982" cx="2.5" cy="2.5" r="2.5" transform="translate(11.762 4.761)" fill="#636363"/>
      <circle id="Ellipse_983" data-name="Ellipse 983" cx="2.5" cy="2.5" r="2.5" transform="translate(18.762 4.761)" fill="#636363"/>
      <circle id="Ellipse_984" data-name="Ellipse 984" cx="2.5" cy="2.5" r="2.5" transform="translate(4.762 11.761)" fill="#636363"/>
      <circle id="Ellipse_985" data-name="Ellipse 985" cx="2.5" cy="2.5" r="2.5" transform="translate(11.762 11.761)" fill="#636363"/>
      <circle id="Ellipse_986" data-name="Ellipse 986" cx="2.5" cy="2.5" r="2.5" transform="translate(18.762 11.761)" fill="#636363"/>
      <circle id="Ellipse_987" data-name="Ellipse 987" cx="2.5" cy="2.5" r="2.5" transform="translate(4.762 18.761)" fill="#636363"/>
      <circle id="Ellipse_988" data-name="Ellipse 988" cx="2.5" cy="2.5" r="2.5" transform="translate(11.762 18.761)" fill="#636363"/>
      <circle id="Ellipse_989" data-name="Ellipse 989" cx="2.5" cy="2.5" r="2.5" transform="translate(18.762 18.761)" fill="#636363"/>
    </g>
      `,
  },
  "dialer-noteInBox-icon": {
    name: "dialer-noteInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
    <g id="notes" transform="translate(8 8.496)">
      <path id="Path_12362" data-name="Path 12362" d="M9,8.409A.9.9,0,0,1,9.894,7.5h8.939a.909.909,0,0,1,0,1.818H9.894A.9.9,0,0,1,9,8.409Z" transform="translate(-2.364 -2.364)" fill="#636363"/>
      <path id="Path_12363" data-name="Path 12363" d="M9,14.409a.9.9,0,0,1,.894-.909h8.939a.909.909,0,0,1,0,1.818H9.894A.9.9,0,0,1,9,14.409Z" transform="translate(-2.364 -4.727)" fill="#636363"/>
      <path id="Path_12364" data-name="Path 12364" d="M9.894,19.5a.909.909,0,0,0,0,1.818h8.939a.909.909,0,0,0,0-1.818Z" transform="translate(-2.364 -7.091)" fill="#636363"/>
      <path id="Path_12365" data-name="Path 12365" d="M9,26.409a.909.909,0,0,1,.909-.909h3.636a.909.909,0,0,1,0,1.818H9.909A.909.909,0,0,1,9,26.409Z" transform="translate(-2.416 -9.455)" fill="#636363"/>
      <path id="Path_12366" data-name="Path 12366" d="M3,4.227A2.714,2.714,0,0,1,5.7,1.5H18.3A2.714,2.714,0,0,1,21,4.227V18.773A2.714,2.714,0,0,1,18.3,21.5H5.7A2.714,2.714,0,0,1,3,18.773Zm2.7-.909H18.3a.9.9,0,0,1,.9.909V18.773a.9.9,0,0,1-.9.909H5.7a.9.9,0,0,1-.9-.909V4.227A.9.9,0,0,1,5.7,3.318Z" transform="translate(0 0)" fill="#636363" fill-rule="evenodd"/>
    </g>`,
  },
  "dialer-playInBox-icon": {
    name: "dialer-playInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="Group_12827" data-name="Group 12827" transform="translate(-1310 -896)">
      <g id="dialer_playIcon" data-name="Group 12826" transform="translate(1321.489 896)">
        <path id="Path_12147" data-name="Path 12147" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-11.986 -0.498)" fill="#ececec"/>
        <path id="Path_14335" data-name="Path 14335" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-11.986 -0.498)" fill="#ececec"/>
      </g>
      <g id="play-button-arrowhead" transform="translate(1291.893 1156.001)">
        <path class="notPillowIcon" id="Path_12125" data-name="Path 12125" d="M10.643.353C9.243-.475,8.107.2,8.107,1.866V14.133c0,1.664,1.136,2.341,2.536,1.514L21.056,9.5c1.4-.828,1.4-2.169,0-3Z" transform="translate(23 -248)" fill="#636363"/>
      </g>
    </g>`,
  },
  "dialer-pauseInBox-icon": {
    name: "dialer-pauseInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="dialer-pauseInBox-icon" transform="translate(11.489 0)">
      <path id="Path_12147" data-name="Path 12147" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-11.986 -0.498)" fill="#ececec"/>
      <g id="pause" transform="translate(-8.614 6.375)">
        <path id="Path_14333" data-name="Path 14333" d="M14.125,21.626h-3c-.552,0-1-.326-1-.727V6.352c0-.4.448-.727,1-.727h3c.552,0,1,.326,1,.727V20.9C15.125,21.3,14.677,21.626,14.125,21.626Z" transform="translate(0 0)" fill="#636363"/>
        <path id="Path_14334" data-name="Path 14334" d="M24.25,21.626h-3c-.552,0-1-.326-1-.727V6.352c0-.4.448-.727,1-.727h3c.552,0,1,.326,1,.727V20.9C25.25,21.3,24.8,21.626,24.25,21.626Z" transform="translate(-1.125 0)" fill="#636363"/>
      </g>
    </g>`,
  },
  "dialer-tagInBox-icon": {
    name: "dialer-tagInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
    <g id="tag" transform="translate(8 10.996)">
      <path id="Path_12360" data-name="Path 12360" d="M1.421,11.5,11.4,1.518a1.332,1.332,0,0,1,.949-.393h6.767a2.016,2.016,0,0,1,2.013,2.014V9.9a1.348,1.348,0,0,1-.423.979L10.09,20.852a1,1,0,0,1-.688.273H9.364a1,1,0,0,1-.7-.325L1.392,12.894A1,1,0,0,1,1.421,11.5Zm8,8.14L19.783,9.9V3.139a.672.672,0,0,0-.671-.671H12.345L2.6,12.222Z" transform="translate(-1.125 -1.125)" fill="#636363" stroke="#636363" stroke-width="0.5"/>
      <path id="Path_12361" data-name="Path 12361" d="M8.892,6.75A2.142,2.142,0,1,1,6.75,8.892,2.142,2.142,0,0,1,8.892,6.75Zm0,2.967a.824.824,0,1,0-.824-.824.824.824,0,0,0,.824.824Z" transform="translate(5.594 -3.376)" fill="#636363" stroke="#636363" stroke-width="0.5"/>
    </g>`,
  },
  "dialer-transferInBox-icon": {
    name: "dialer-transferInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="dialer-transferInBox-icon" transform="translate(11.489 0)">
      <path id="Path_12147" data-name="Path 12147" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-11.986 -0.498)" fill="#ececec"/>
      <g id="transfer" transform="translate(-1.614 9.545)">
        <path id="Path_14331" data-name="Path 14331" d="M13.9,9.41l.849.865,4.324-4.41L14.75,1.455,13.9,2.32l2.876,2.933H1.125V6.477H16.777L13.9,9.41Z" transform="translate(0 0)" fill="#636363" stroke="#636363" stroke-width="0.8"/>
        <path id="Path_14332" data-name="Path 14332" d="M19.171,22.128H3.519L6.4,19.2l-.849-.865L1.222,22.74l4.324,4.41.849-.865L3.519,23.352H19.171Z" transform="translate(-0.044 -7.696)" fill="#636363" stroke="#636363" stroke-width="0.8"/>
      </g>
    </g>`,
  },
  "dialer-close-icon": {
    name: "dialer-close-icon",
    viewBox: "0 0 14 14",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="dialer-close-icon-secondary" transform="translate(0 0)">
      <rect id="Rectangle_2984" data-name="Rectangle 2984" width="17.972" height="1.826" rx="0.913" transform="translate(0 12.708) rotate(-45)" fill="#404040"/>
      <rect id="Rectangle_2985" data-name="Rectangle 2985" width="17.972" height="1.826" rx="0.913" transform="translate(12.708 14) rotate(-135)" fill="#404040"/>
    </g>`,
  },

  //video call icons

  "dialer-sharedInBox-icon": {
    name: "dialer-uploadInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="dialer-uploadInBox-icon" transform="translate(11.489 0)">
      <path id="Path_12147" data-name="Path 12147" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-11.986 -0.498)" fill="#ececec"/>
      <g id="Group_12499" data-name="Group 12499" transform="translate(5.435 10)">
        <g id="Rectangle_2997" data-name="Rectangle 2997" transform="translate(-7.424 6.648)" fill="none" stroke="#636363" stroke-width="1.8">
          <rect width="21.001" height="14.353" rx="3" stroke="none"/>
          <rect x="0.9" y="0.9" width="19.201" height="12.553" rx="2.1" fill="none"/>
        </g>
        <g id="right-arrow_1_" data-name="right-arrow (1)" transform="translate(-0.452 13.579) rotate(-90)">
          <g id="Group_12498" data-name="Group 12498">
            <path id="Path_12146" data-name="Path 12146" d="M14.411,3.128h0L11.435.166a.569.569,0,0,0-.8.807l2,1.988H.569a.569.569,0,0,0,0,1.139H12.63l-2,1.988a.569.569,0,0,0,.8.807l2.976-2.961h0A.57.57,0,0,0,14.411,3.128Z" fill="#2abe4d" stroke="#2abe4d" stroke-width="0.7"/>
          </g>
        </g>
      </g>
    </g>`,
  },
  "dialer-videoInBox-icon": {
    name: "dialer-videoInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
      <g id="video_2_" data-name="video (2)" transform="translate(9.654 13.378)">
        <path id="Path_7034" data-name="Path 7034" d="M22.342,6,16,9.813v2.909L22.342,15.9Z" transform="translate(-0.273 -4.606)" fill="#636363"/>
        <path id="Path_12131" data-name="Path 12131" d="M-1.563,0h12.4a1.443,1.443,0,0,1,1.437,1.45V11.791a1.443,1.443,0,0,1-1.437,1.45h-12.4A1.443,1.443,0,0,1-3,11.791V1.45A1.443,1.443,0,0,1-1.563,0Z" transform="translate(3)" fill="#636363"/>
      </g>`,
  },
  "dialer-videoInBoxPause-icon": {
    name: "dialer-videoInBoxPause-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
      <g id="video_2_" data-name="video (2)" transform="translate(9.654 14.378)">
        <path id="Path_7034" data-name="Path 7034" d="M22.342,6,16,9.813v2.909L22.342,15.9Z" transform="translate(-0.273 -4.606)" fill="#636363"/>
        <path id="Path_12131" data-name="Path 12131" d="M-1.563,0h12.4a1.443,1.443,0,0,1,1.437,1.45V11.791a1.443,1.443,0,0,1-1.437,1.45h-12.4A1.443,1.443,0,0,1-3,11.791V1.45A1.443,1.443,0,0,1-1.563,0Z" transform="translate(3)" fill="#636363"/>
        <g id="Rectangle_2998" data-name="Rectangle 2998" transform="matrix(0.809, 0.588, -0.588, 0.809, 15.661, -6.969)" fill="#636363" stroke="#ececec" stroke-width="1">
          <rect width="4" height="29" stroke="none"/>
          <rect x="0.5" y="0.5" width="3" height="28" fill="none"/>
        </g>
      </g>`,
  },
  "dialer-addUsersInBox-icon": {
    name: "dialer-addUsersInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
        <path id="add-group" d="M11.375,13.374a7.283,7.283,0,0,0-1.53-.817,3.9,3.9,0,0,0,1.27-2.576,5.774,5.774,0,0,1,7.322-.6.767.767,0,1,0,.878-1.258,7.291,7.291,0,0,0-1.53-.817A3.912,3.912,0,1,0,12.517,7.3q-.161.062-.319.131a7.285,7.285,0,0,0-1.351.776A3.912,3.912,0,1,0,4.57,12.542a7.377,7.377,0,0,0-4.455,4.59,2.3,2.3,0,0,0,2.191,3.006H8.98a.767.767,0,0,0,0-1.534H2.306a.768.768,0,0,1-.73-1,5.919,5.919,0,0,1,5.623-4,5.738,5.738,0,0,1,3.3,1.034.767.767,0,1,0,.878-1.258Zm3.78-11.339a2.378,2.378,0,1,1-2.378,2.378A2.381,2.381,0,0,1,15.155,2.035ZM7.216,7.285A2.378,2.378,0,1,1,4.838,9.663,2.381,2.381,0,0,1,7.216,7.285Zm12.427,9.21a.767.767,0,0,1-.767.767H16.766v2.109a.767.767,0,1,1-1.534,0V17.262H13.122a.767.767,0,0,1,0-1.534h2.109V13.618a.767.767,0,0,1,1.534,0v2.109h2.109a.767.767,0,0,1,.767.767Zm0,0" transform="translate(9.996 9.495)" fill="#636363"/>
    `,
  },

  // call activity dropdown icon
  "dialer-addToContact-icon": {
    name: "dialer-addToContact-icon",
    viewBox: "0 0 16.245 15.004",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="addToContact-icon" transform="translate(-228 -29.727)">
      <path id="block-user" d="M7.149,13.832H1.777a.6.6,0,0,1-.469-.223.612.612,0,0,1-.124-.513A6.476,6.476,0,0,1,7.351,7.968c.05,0,.1,0,.149,0a3.989,3.989,0,1,0-2.384-.794,7.621,7.621,0,0,0-5.08,5.679A1.781,1.781,0,0,0,1.777,15H7.149a.586.586,0,0,0,0-1.172ZM4.687,3.986A2.813,2.813,0,1,1,7.567,6.8a.582.582,0,0,0-.067,0H7.363a2.817,2.817,0,0,1-2.676-2.81Z" transform="translate(228.002 29.727)" fill="#707070"/>
      <path id="plus" d="M6.646,3.148h-2.8V.35a.35.35,0,0,0-.7,0v2.8H.35a.35.35,0,0,0,0,.7h2.8v2.8a.35.35,0,1,0,.7,0v-2.8h2.8a.35.35,0,1,0,0-.7Zm0,0" transform="translate(236.999 36.731)" fill="#707070" stroke="#707070" stroke-width="0.5"/>
    </g>`,
  },
  "dialer-callinfo-icon": {
    name: "dialer-callinfo-icon",
    viewBox: "0 0 15.7 15.701",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="callinfo-icon" transform="translate(-227.4 -28.627)">
        <path id="Path_14479" data-name="Path 14479" d="M15.224,11.817v1.974a1.318,1.318,0,0,1-1.437,1.316,13.064,13.064,0,0,1-5.69-2.02A12.843,12.843,0,0,1,4.141,9.139a13.005,13.005,0,0,1-2.024-5.7A1.317,1.317,0,0,1,3.429,2H5.407A1.318,1.318,0,0,1,6.726,3.132a8.435,8.435,0,0,0,.461,1.849,1.314,1.314,0,0,1-.3,1.388L6.053,7.2a10.538,10.538,0,0,0,3.956,3.948l.837-.836a1.32,1.32,0,0,1,1.391-.3,8.479,8.479,0,0,0,1.853.461A1.317,1.317,0,0,1,15.224,11.817Z" transform="translate(225.888 28.615)" fill="none" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/>
        <path id="info" d="M6.775,9.795a3.02,3.02,0,1,0-3.02-3.02A3.02,3.02,0,0,0,6.775,9.795Zm0,.755A3.775,3.775,0,1,1,10.55,6.775,3.775,3.775,0,0,1,6.775,10.55ZM6.4,6.4V8.662h.755V6.4Zm0-1.51h.755v.755H6.4Z" transform="translate(232.45 25.727)" fill="#707070" stroke="#707070" stroke-width="0.2"/>
      </g>`,
  },
  "dialer-sms-icon": {
    name: "dialer-sms-icon",
    viewBox: "0 0 15.301 15.307",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="sms-icon" transform="translate(-1.85 -2.35)">
        <path id="Path_14463" data-name="Path 14463" d="M9.512,2.5C5.371,2.5,2,5.539,2,9.275s3.371,6.775,7.512,6.775A8.217,8.217,0,0,0,11.8,15.72l2.6,1.7a.458.458,0,0,0,.478.018.486.486,0,0,0,.245-.424V13.76A6.384,6.384,0,0,0,17,9.275C17.024,5.539,13.653,2.5,9.512,2.5Zm4.831,10.7a.491.491,0,0,0-.15.353v2.584l-2.056-1.35a.458.458,0,0,0-.39-.053,7.306,7.306,0,0,1-2.235.348c-3.625,0-6.573-2.6-6.573-5.807S5.888,3.468,9.512,3.468s6.573,2.6,6.573,5.807A5.433,5.433,0,0,1,14.343,13.2Z" transform="translate(0 0)" fill="#707070" stroke="#707070" stroke-width="0.3"/>
        <path id="Path_14464" data-name="Path 14464" d="M17.258,15.5H10.484a.484.484,0,0,0,0,.968h6.775a.484.484,0,1,0,0-.968Z" transform="translate(-4.359 -6.709)" fill="#707070" stroke="#707070" stroke-width="0.3"/>
        <path id="Path_14465" data-name="Path 14465" d="M17.363,20.5H13.734a.484.484,0,1,0,0,.968h3.629a.484.484,0,0,0,0-.968Z" transform="translate(-6.037 -9.29)" fill="#707070" stroke="#707070" stroke-width="0.3"/>
        <path id="Path_14466" data-name="Path 14466" d="M10.764,11.468h6.5a.484.484,0,0,0,0-.968h-6.5a.484.484,0,0,0,0,.968Z" transform="translate(-4.504 -4.129)" fill="#707070" stroke="#707070" stroke-width="0.3"/>
      </g>`,
  },
  "dialer-chatInBox-icon": {
    name: "dialer-chatInBox-icon",
    viewBox: "0 0 34 34",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="dialer-chatInBox-icon" transform="translate(-667 -455)">
      <path id="Path_12119" data-name="Path 12119" d="M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z" transform="translate(666.502 454.502)" fill="#1971C9"/>
      <g id="chat-icon" transform="translate(674.75 460.5)">
        <path id="Path_14460" data-name="Path 14460" d="M10.682,19.5l-.932-.577,2.143-4.037h3.214a1.115,1.115,0,0,0,1.071-1.153V6.807a1.115,1.115,0,0,0-1.071-1.153H4.393A1.115,1.115,0,0,0,3.321,6.807v6.921a1.115,1.115,0,0,0,1.071,1.153H9.214v1.153H4.393A2.229,2.229,0,0,1,2.25,13.728V6.807A2.229,2.229,0,0,1,4.393,4.5H15.107A2.229,2.229,0,0,1,17.25,6.807v6.921a2.229,2.229,0,0,1-2.143,2.307H12.514Z" transform="translate(0 0)" fill="#fff" stroke="#fff" stroke-width="0.2"/>
        <path id="Path_14461" data-name="Path 14461" d="M9,11.25h8.016v1.164H9Z" transform="translate(-3.258 -3.292)" fill="#fff" stroke="#fff" stroke-width="0.2"/>
        <path id="Path_14462" data-name="Path 14462" d="M9,18h5.82v1.164H9Z" transform="translate(-3.69 -6.584)" fill="#fff" stroke="#fff" stroke-width="0.2"/>
      </g>
    </g>`,
  },
  "dialer-chatInBox-iconLight": {
    name: "dialer-chatInBox-iconLight",
    viewBox: "0 0 34 34",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="dialer-chatInBox-icon" transform="translate(-667 -455)">
      <path id="Path_12119" data-name="Path 12119" d="M23.979,33.991a41.743,41.743,0,0,1-12.97,0,12.01,12.01,0,0,1-10-10.012,41.382,41.382,0,0,1,0-12.97,12,12,0,0,1,10-10,41.381,41.381,0,0,1,12.97,0,12.01,12.01,0,0,1,10.012,10,41.743,41.743,0,0,1,0,12.97A12.016,12.016,0,0,1,23.979,33.991Z" transform="translate(666.502 454.502)" fill="#ececec"/>
      <g id="chat-icon" transform="translate(674.75 460.5)">
        <path id="Path_14460" data-name="Path 14460" d="M10.682,19.5l-.932-.577,2.143-4.037h3.214a1.115,1.115,0,0,0,1.071-1.153V6.807a1.115,1.115,0,0,0-1.071-1.153H4.393A1.115,1.115,0,0,0,3.321,6.807v6.921a1.115,1.115,0,0,0,1.071,1.153H9.214v1.153H4.393A2.229,2.229,0,0,1,2.25,13.728V6.807A2.229,2.229,0,0,1,4.393,4.5H15.107A2.229,2.229,0,0,1,17.25,6.807v6.921a2.229,2.229,0,0,1-2.143,2.307H12.514Z" transform="translate(0 0)" fill="#636363" stroke="#636363" stroke-width="0.2"/>
        <path id="Path_14461" data-name="Path 14461" d="M9,11.25h8.016v1.164H9Z" transform="translate(-3.258 -3.292)" fill="#636363" stroke="#fff" stroke-width="0.2"/>
        <path id="Path_14462" data-name="Path 14462" d="M9,18h5.82v1.164H9Z" transform="translate(-3.69 -6.584)" fill="#636363" stroke="#fff" stroke-width="0.2"/>
      </g>
    </g>`,
  },

  // no record / content icon
  "dialer-noRecord-icon": {
    name: "dialer-noRecord-icon",
    viewBox: "0 0 187 193",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="noRecord-icon" transform="translate(0.001 0.002)">
      <path id="Path_14439" data-name="Path 14439" d="M432.366,334.51c-16.345-3.073-28.153-11.066-37.155-26.121-11.8-19.729-25.219-35.2-47.7-38.974-19.127-3.208-37.3,5.269-47.462,23.219-22.783,40.224,3.754,96.269,34.639,122.149,32.068,26.87,82.676,32.688,117.569,8.553,15.884-10.987,29.046-31.606,25.713-52.743-1.665-10.571-6.019-20.476-14.081-27.044-7.881-6.426-17.709-6.992-27.133-8.311C435.3,335.024,433.836,334.787,432.366,334.51Z" transform="translate(-291.49 -268.75)" fill="#caf1ff"/>
      <path id="Path_14440" data-name="Path 14440" d="M1103.3,427.724s6.394,25.969,36.326,29.534,29-8.722,14.484-18S1097.579,408.917,1103.3,427.724Z" transform="translate(-995.888 -400.136)" fill="#caf1ff"/>
      <circle id="Ellipse_1004" data-name="Ellipse 1004" cx="3.073" cy="3.073" r="3.073" transform="translate(137.563 5.071)" fill="#66c8ff"/>
      <circle id="Ellipse_1005" data-name="Ellipse 1005" cx="3.874" cy="3.874" r="3.874" transform="translate(33.415 118.853) rotate(-45)" fill="#66c8ff"/>
      <circle id="Ellipse_1006" data-name="Ellipse 1006" cx="5.666" cy="5.666" r="5.666" transform="translate(167.652 169.333) rotate(-45)" fill="#97dfff"/>
      <path id="Path_14441" data-name="Path 14441" d="M779.178,1333.09l-10.728,10.728,4.522,4.522,10.8-10.8q-1.549-1.341-3.014-2.805Q779.949,1333.925,779.178,1333.09Z" transform="translate(-705.521 -1192.663)" fill="#8699ba"/>
      <path id="Path_14442" data-name="Path 14442" d="M843.531,1301.67l-5.711,5.711q.772.836,1.587,1.644,1.464,1.467,3.014,2.805l5.638-5.639Z" transform="translate(-765.733 -1165.379)" fill="#677691"/>
      <path id="Path_14443" data-name="Path 14443" d="M763.43,656.2a57.138,57.138,0,0,0,.348,6.313A55.949,55.949,0,0,0,777.769,693.8q1.058,1.19,2.2,2.325t2.32,2.2a56.464,56.464,0,0,0,77.52-2.194,56.957,56.957,0,0,0,7.8-9.718,56.492,56.492,0,0,0-77.931-77.93,57.123,57.123,0,0,0-9.716,7.8,56.105,56.105,0,0,0-16.533,39.922Zm8.038-1.377a48.3,48.3,0,0,1,11.788-30.351q1.127-1.3,2.364-2.541.444-.443.9-.87c.086-.082.171-.163.257-.242.115-.11.233-.218.352-.328s.229-.21.345-.313l.419-.374.466-.4c.209-.18.417-.356.628-.529.106-.089.209-.176.316-.265q.952-.775,1.936-1.5c.161-.12.323-.235.485-.352s.3-.214.451-.317q.6-.422,1.211-.82c.114-.075.226-.148.34-.22.168-.11.337-.216.508-.321q.764-.476,1.542-.926.264-.151.521-.294t.529-.288c.179-.094.35-.189.529-.279s.345-.183.52-.265a.069.069,0,0,1,.02-.008c.173-.09.345-.179.521-.265.34-.171.684-.335,1.029-.495.192-.09.386-.177.579-.265.54-.241,1.083-.474,1.631-.693.139-.056.274-.112.413-.165.091-.036.181-.073.274-.106l.413-.159c.184-.07.368-.132.552-.2l.331-.118.132-.046.1-.033c.185-.065.369-.132.557-.19.073-.026.147-.05.218-.071.114-.041.228-.077.34-.112l.3-.094.45-.14c.122-.037.246-.075.37-.111l.079-.025c.132-.037.25-.073.376-.107l.106-.03h.018c.118-.034.238-.066.356-.1.23-.065.462-.132.692-.184s.458-.116.686-.172l.132-.032c.132-.033.253-.062.381-.09.038-.01.077-.018.112-.026l.385-.086.294-.063c.116-.026.234-.05.35-.074l.07-.015.264-.054.328-.064c.119-.022.239-.046.36-.066h.009l.132-.025.214-.037c.05-.011.1-.018.152-.026l.217-.038c.179-.029.356-.06.529-.086.026,0,.05-.008.073-.009l.332-.052.094-.015.1-.015.317-.044c.132-.02.274-.038.413-.054l.446-.055c.185-.023.372-.042.56-.062l.442-.046c.331-.033.661-.063.993-.087a.135.135,0,0,1,.04,0l.168-.013c.064-.007.132-.011.192-.015l.164-.012.142-.008h.082a1.1,1.1,0,0,0,.161-.008c.089-.007.175-.012.265-.015s.192-.012.288-.016h.036l.447-.017a.544.544,0,0,1,.066,0c.194-.008.386-.013.578-.017h0q.193,0,.389-.008h1.02a.131.131,0,0,1,.046,0h.394c.177,0,.356,0,.529.009.573.012,1.144.038,1.719.073.2.012.4.025.6.04a.6.6,0,0,1,.146.012c.132.008.255.018.384.028h.008c.29.024.579.05.866.081s.552.057.825.09a.877.877,0,0,1,.132.016c.354.041.71.09,1.058.139q.771.111,1.537.246l.368.069c.276.049.55.1.824.16.157.032.312.064.466.1l.075.013c.058.012.119.024.176.038.19.04.38.082.57.132q2.278.529,4.509,1.272l.555.188h0l1.107.4.4.152.29.114c.132.052.274.108.411.164.184.073.361.148.545.224.272.114.544.233.816.352q.317.132.635.286c.272.124.542.25.809.38l.4.188c.013.008.028.015.044.025q.529.264,1.058.54c.176.091.352.185.529.279s.349.19.529.288c.148.079.294.164.442.247l.078.046.1.056q.341.194.68.4c.172.1.344.205.513.311.257.159.509.319.763.48.319.2.632.411.946.624.071.048.144.1.216.145h0l.221.149c.041.028.078.054.119.085s.106.071.157.11c.118.082.235.168.356.251.079.056.157.114.235.172.245.176.484.353.726.529.147.112.3.224.446.337l.2.163q.881.686,1.737,1.421l.418.36.048.044c.618.546,1.225,1.107,1.82,1.689.148.144.3.292.446.439.227.229.454.46.677.692.066.069.132.132.2.2l.425.454c.14.152.28.3.418.458l.022.024.217.246c.058.063.116.132.172.193.016.016.03.033.045.049.122.132.241.278.361.415.068.082.132.161.206.243a.311.311,0,0,1,.021.028c.041.045.078.09.114.132.021.021.038.044.057.065l.078.094.106.132.205.25c.093.11.182.222.265.332.034.042.066.086.1.132s.069.086.1.132c.11.132.216.265.321.407s.226.3.339.446h0c.12.16.242.324.362.488.1.132.2.265.295.406l.049.067.012.019h0q.12.167.238.337c.042.061.086.12.132.18.06.085.116.168.175.253.033.048.068.1.1.147.02.026.036.053.054.078q.509.75.985,1.513h0c.041.065.081.132.12.2.169.275.337.552.5.829q.152.265.3.517l.046.078c.04.074.082.148.124.222a.211.211,0,0,0,.013.024l.108.2c.067.119.132.238.2.358l.065.12c.019.033.037.065.054.1l.253.47c.177.34.352.68.518,1.021l.074.151c.057.114.112.229.164.345.04.078.078.157.116.238.028.058.056.115.082.176.115.246.23.491.341.739s.212.479.313.72l.151.348v.009a.038.038,0,0,0,0,.008h0q.221.517.425,1.042l.074.19c.021.058.045.118.067.179l.087.233c.019.046.037.09.053.132.122.321.237.646.352.971.063.184.132.37.189.556.114.34.226.683.332,1.026l.019.057a.326.326,0,0,0,.008.034l.115.38c.044.149.09.3.132.448.03.1.058.2.086.295.106.376.208.751.3,1.13.048.189.1.38.142.57.024.1.048.189.067.283s.044.19.066.286.044.19.066.284.042.189.064.286.036.165.053.25c.04.181.075.364.114.548l.012.053v.033a.124.124,0,0,0,.011.057c.03.151.059.3.087.454.02.106.041.214.061.323h0c.021.114.041.226.06.34.016.093.032.188.048.282.012.063.023.132.034.2a.121.121,0,0,0,0,.03c.011.066.02.132.03.2a.977.977,0,0,0,.016.1c.028.171.056.343.079.515.019.132.038.265.054.4l.036.265c.048.357.09.717.132,1.075.012.115.025.229.037.344s.02.2.028.294c0,.046.009.091.013.14.015.143.026.287.038.433h0a.011.011,0,0,1,0,.008c.032.378.06.754.081,1.131v.02c.022.388.04.776.054,1.164,0,.176.012.353.016.529a.331.331,0,0,1,0,.052c0,.157.008.317.009.477v1.476c0,.316-.011.632-.023.948,0,.112-.008.225-.015.339,0,.132-.009.278-.017.415s-.012.235-.021.353v.069h0c0,.087-.009.177-.016.265s-.012.177-.02.265v.044a.074.074,0,0,1,0,.024v.07c0,.055-.008.112-.013.168-.008.114-.016.227-.026.344-.032.377-.067.755-.11,1.132-.007.061-.012.119-.02.179s-.012.118-.02.176c-.034.3-.07.6-.11.9-.022.16-.045.323-.069.484v.018c-.032.213-.065.429-.1.646-.008.057-.016.115-.025.173-.015.089-.029.175-.045.264a.34.34,0,0,1-.008.049.13.13,0,0,1-.008.054c-.029.174-.06.349-.091.529-.02.111-.041.222-.062.332-.016.082-.03.163-.046.242q-.065.345-.132.689c-.032.152-.065.3-.1.454-.009.042-.017.085-.028.132s-.024.1-.036.157-.032.144-.05.214a.7.7,0,0,1-.016.071h0c-.028.122-.056.241-.086.364s-.054.229-.083.345c-.041.165-.082.332-.132.5-.013.057-.029.115-.045.176-.026.106-.054.212-.085.317s-.046.173-.071.265q-.146.529-.3,1.058-.024.087-.052.175c-.015.044-.028.09-.042.132-.032.1-.066.21-.1.313-.02.066-.041.132-.061.2-.009.036-.021.071-.033.11q-.1.317-.21.634c-.038.115-.078.232-.118.345l-.081.23a.126.126,0,0,1-.016.044l-.177.5-.118.318c-.057.152-.114.3-.172.454s-.126.325-.192.489c-.093.231-.186.464-.284.7-.083.2-.169.4-.255.607s-.176.406-.265.606q-.25.553-.51,1.1-.273.569-.564,1.138c-.061.122-.123.243-.188.365q-.575,1.1-1.209,2.178c-.216.366-.438.727-.661,1.09-.12.189-.241.38-.362.567s-.243.376-.369.563-.25.374-.378.558-.228.329-.344.493c-.176.254-.357.505-.541.755-.233.317-.47.634-.714.946-.14.18-.279.36-.422.537s-.286.356-.429.529c-.282.343-.57.685-.862,1.022-.017.02-.036.04-.053.062l-.426.484c-.155.172-.31.344-.466.513s-.315.34-.474.508-.32.337-.483.5-.325.333-.489.5q-1.234,1.234-2.538,2.364a48.447,48.447,0,0,1-80.159-38.009Z" transform="translate(-701.431 -556.211)" fill="#8699ba"/>
      <path id="Path_14444" data-name="Path 14444" d="M838.227,674.5q-1.237,1.237-2.364,2.539A48.466,48.466,0,0,0,904.228,745.4q1.3-1.13,2.539-2.365a48.465,48.465,0,0,0-68.54-68.54Z" transform="translate(-754.039 -608.774)" fill="#66c8ff"/>
      <path id="Path_14445" data-name="Path 14445" d="M913.33,624.454q1.127-1.3,2.364-2.54a48.464,48.464,0,0,1,68.538,68.538q-1.237,1.235-2.539,2.365a56.5,56.5,0,0,0,15.992-6.429,56.488,56.488,0,0,0-77.923-77.929A56.513,56.513,0,0,0,913.33,624.454Z" transform="translate(-831.506 -556.146)" fill="#93a9c9"/>
      <path id="Path_14446" data-name="Path 14446" d="M999.117,687.161l43.108,43.108a14.627,14.627,0,0,0,24.14-5.423,48.457,48.457,0,0,0-61.832-61.832A14.635,14.635,0,0,0,999.117,687.161Z" transform="translate(-902.214 -608.677)" fill="#97dfff"/>
      <path id="Path_14447" data-name="Path 14447" d="M487.934,1421.995h0a8,8,0,0,0,11.322,0l30.769-30.768a8.007,8.007,0,0,0,0-11.323h0a8,8,0,0,0-11.322,0l-30.769,30.769a8,8,0,0,0,0,11.322Z" transform="translate(-459.917 -1231.342)" fill="#5f6877"/>
      <path id="Path_14448" data-name="Path 14448" d="M1125.106,701.557a2,2,0,0,0,1.735.561,39.644,39.644,0,0,1,34.319,11.057,39.216,39.216,0,0,1,11.072,21.651,2,2,0,1,0,3.947-.632,43.5,43.5,0,0,0-49.981-36.024,2,2,0,0,0-1.093,3.385Z" transform="translate(-1014.764 -641.047)" fill="#caf1ff"/>
      <path id="Path_14449" data-name="Path 14449" d="M1485.52,1027.966a2,2,0,0,0,3.385-1.094,44.025,44.025,0,0,0,.556-6,2,2,0,0,0-4-.094,39.77,39.77,0,0,1-.5,5.448A2,2,0,0,0,1485.52,1027.966Z" transform="translate(-1327.505 -919.86)" fill="#caf1ff"/>
      <path id="Path_14450" data-name="Path 14450" d="M763.439,877.56a57.14,57.14,0,0,0,.348,6.313l7.69-7.69,14.037-14.039-9.94-4.184-7.4-3.111A56.3,56.3,0,0,0,763.439,877.56Z" transform="translate(-701.177 -777.538)" fill="#677691" opacity="0.5"/>
      <rect id="Rectangle_3111" data-name="Rectangle 3111" width="69.654" height="69.654" rx="34.827" transform="translate(89.197 89.68) rotate(180)" fill="#fff"/>
      <path id="Path_14451" data-name="Path 14451" d="M596.521,581.511l-10.592-10.592a2.9,2.9,0,0,1,4.1-4.1l10.592,10.592,10.593-10.592a2.9,2.9,0,1,1,4.1,4.1l-10.592,10.592L615.315,592.1a2.9,2.9,0,1,1-4.1,4.1l-10.593-10.592L590.029,596.2a2.9,2.9,0,0,1-4.1-4.1Z" transform="translate(-546.354 -526.766)" fill="#005dff"/>
      <path id="Path_14452" data-name="Path 14452" d="M271.16,678.04l11.875,11.875V678.04Z" transform="translate(-235.382 -588.577)" fill="#fff"/>
      <circle id="Ellipse_1007" data-name="Ellipse 1007" cx="5.608" cy="5.608" r="5.608" transform="matrix(0.522, -0.853, 0.853, 0.522, 92.727, 100.98)" fill="#3191bc"/>
      <path id="Path_14453" data-name="Path 14453" d="M979.439,887.177a1.442,1.442,0,0,1-.507-2.792l14.187-5.32a1.443,1.443,0,0,1,1.013,2.7l-14.188,5.32A1.443,1.443,0,0,1,979.439,887.177Z" transform="translate(-887.42 -798.454)" fill="#3191bc"/>
      <circle id="Ellipse_1008" data-name="Ellipse 1008" cx="5.628" cy="5.628" r="5.628" transform="translate(129.519 94.124) rotate(-13.04)" fill="#3191bc"/>
      <path id="Path_14454" data-name="Path 14454" d="M1289.128,887.194a1.445,1.445,0,0,1-.507-.093l-14.188-5.317a1.442,1.442,0,0,1,1.013-2.7l14.187,5.32a1.442,1.442,0,0,1-.505,2.792Z" transform="translate(-1143.935 -798.471)" fill="#3191bc"/>
      <path id="Path_14455" data-name="Path 14455" d="M1161.783,1155.2h-6.956a1.442,1.442,0,0,1,0-2.882h6.958a1.442,1.442,0,0,1,0,2.882Z" transform="translate(-1039.695 -1035.725)" fill="#3191bc"/>
    </g>`,
  },

  // ivr keypad number icons
  
  // pin icon
  "dialer-pinIcon": {
    name: "dialer-pinIcon",
    viewBox: "0 0 443.294 443.294",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path d="m297.689 120.374 34.064-102.138c1.42-4.221.703-8.875-1.894-12.487-2.61-3.612-6.791-5.749-11.241-5.749h-193.942c-4.451 0-8.631 2.137-11.242 5.749-2.597 3.612-3.314 8.252-1.907 12.487l34.051 102.165c-38.799 25.582-62.46 68.696-62.46 115.099 0 7.657 6.196 13.853 13.853 13.853h110.823v166.235l13.853 27.706 13.853-27.706v-166.235h110.823c7.657 0 13.853-6.196 13.853-13.853 0-46.415-23.674-89.543-62.487-115.126zm-185.972 101.273c4.464-34.673 25.514-65.653 57.143-82.955 5.885-3.206 8.617-10.173 6.507-16.532l-31.48-94.454h155.507l-31.494 94.427c-2.124 6.358.609 13.325 6.494 16.545 31.656 17.289 52.72 48.282 57.184 82.969z"/>
    `,
  },
  // snooze icon

  "dialer-snoozeIcon-light": {
    name: "dialer-snoozeIcon-light",
    viewBox: "0 0 14.3 14.3",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
       <path id="snooze-icon" d="M10.035,6.125h3.527a.438.438,0,0,1,0,.875H9.187a.444.444,0,0,1-.437-.437.4.4,0,0,1,.137-.315L12.715.875H9.187A.42.42,0,0,1,8.88.745.42.42,0,0,1,8.75.438.42.42,0,0,1,8.88.13.42.42,0,0,1,9.187,0h4.375a.4.4,0,0,1,.3.157A.457.457,0,0,1,14,.438a.536.536,0,0,1-.109.287Zm-2.16,4.813a.444.444,0,0,1-.437.438h-3.5a.444.444,0,0,1-.438-.437.4.4,0,0,1,.137-.315L6.59,7H3.938a.438.438,0,0,1,0-.875h3.5a.4.4,0,0,1,.3.157.457.457,0,0,1,.137.28.536.536,0,0,1-.109.287L4.785,10.5H7.438a.444.444,0,0,1,.438.438Zm-5.25,2.625A.444.444,0,0,1,2.187,14H.437a.42.42,0,0,1-.308-.13A.42.42,0,0,1,0,13.563a.4.4,0,0,1,.137-.315l1.2-1.873h-.9a.42.42,0,0,1-.308-.13.429.429,0,0,1,0-.615.42.42,0,0,1,.308-.13h1.75a.4.4,0,0,1,.3.157.457.457,0,0,1,.137.28.536.536,0,0,1-.109.287l-1.23,1.9h.9a.444.444,0,0,1,.438.438Z" transform="translate(0.15 0.15)" fill="#fff" stroke="#fff" stroke-width="0.3"/>
       `,
  },
  "dialer-snoozeIcon": {
    name: "dialer-snoozIcon",
    viewBox: "0 0 14.3 14.3",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
       <path id="snooze-icon" d="M10.035,6.125h3.527a.438.438,0,0,1,0,.875H9.187a.444.444,0,0,1-.437-.437.4.4,0,0,1,.137-.315L12.715.875H9.187A.42.42,0,0,1,8.88.745.42.42,0,0,1,8.75.438.42.42,0,0,1,8.88.13.42.42,0,0,1,9.187,0h4.375a.4.4,0,0,1,.3.157A.457.457,0,0,1,14,.438a.536.536,0,0,1-.109.287Zm-2.16,4.813a.444.444,0,0,1-.437.438h-3.5a.444.444,0,0,1-.438-.437.4.4,0,0,1,.137-.315L6.59,7H3.938a.438.438,0,0,1,0-.875h3.5a.4.4,0,0,1,.3.157.457.457,0,0,1,.137.28.536.536,0,0,1-.109.287L4.785,10.5H7.438a.444.444,0,0,1,.438.438Zm-5.25,2.625A.444.444,0,0,1,2.187,14H.437a.42.42,0,0,1-.308-.13A.42.42,0,0,1,0,13.563a.4.4,0,0,1,.137-.315l1.2-1.873h-.9a.42.42,0,0,1-.308-.13.429.429,0,0,1,0-.615.42.42,0,0,1,.308-.13h1.75a.4.4,0,0,1,.3.157.457.457,0,0,1,.137.28.536.536,0,0,1-.109.287l-1.23,1.9h.9a.444.444,0,0,1,.438.438Z" transform="translate(0.15 0.15)" fill="#000" stroke="#000" stroke-width="0.3"/>
       `,
  },

  // welcome greeting icons

  // music library icon

  "dialer-musicLibraryIcon": {
    name: "dialer-musicLibraryIcon",
    viewBox: "0 0 16 16",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
       <path id="musicLibrary-icon" d="M4.864,1.375,4.458,12.223a3.2,3.2,0,0,0-1.949-.308A2.633,2.633,0,0,0,.018,14.6a2.585,2.585,0,0,0,3.119,1.867,2.765,2.765,0,0,0,2.5-2.264h0s0-.006,0-.009c0-.028,0-.056,0-.084C5.7,12.98,6.053,4.4,6.053,4.4l8.7-.922L14.359,11.2a3.177,3.177,0,0,0-2.03-.352,2.635,2.635,0,0,0-2.491,2.686,2.584,2.584,0,0,0,3.119,1.867,2.743,2.743,0,0,0,2.505-2.334h0c.029-.5.52-12.155.537-12.567Z" transform="translate(0 -0.504)" fill="#afafaf"/>
       `,
  },

  // T icon
  "dialer-textIcon": {
    name: "dialer-textIcon",
    viewBox: "0 0 17.5 16.5",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
       <path id="text-icon" d="M22.063,9.909V6.188h-17V9.909H8.02V7.676h4.066V20.7H9.5v1.488h8.13V20.7H15.041V7.676h4.066V9.909Z" transform="translate(-4.813 -5.938)" fill="#afafaf" stroke="#fff" stroke-width="0.5"/>
       `,
  },

  // upload icon
  "dialer-uploadIcon": {
    name: "dialer-uploadIcon",
    viewBox: "0 0 14.316 16",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="upload-icon" d="M14.053,6.224v9.408H12.263V6.224l-2.9,2.731L8.1,7.764,13.158,3,18.22,7.764,16.955,8.955ZM6.895,17.316H19.421a.844.844,0,1,1,0,1.684H6.895a.844.844,0,1,1,0-1.684Z" transform="translate(-6 -3)" fill="#afafaf" fill-rule="evenodd"/>
        `,
  },

  //chat icon
  "dialer-chatVideoIcon": {
    name: "dialer-chatVideoIcon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
        <g id="video_2_" data-name="video (2)" transform="translate(9.654 13.378)">
          <path id="Path_7034" data-name="Path 7034" d="M22.342,6,16,9.813v2.909L22.342,15.9Z" transform="translate(-0.273 -4.606)" fill="#8a8a8a"/>
          <path id="Path_12131" data-name="Path 12131" d="M-1.563,0h12.4a1.443,1.443,0,0,1,1.437,1.45V11.791a1.443,1.443,0,0,1-1.437,1.45h-12.4A1.443,1.443,0,0,1-3,11.791V1.45A1.443,1.443,0,0,1-1.563,0Z" transform="translate(3)" fill="#8a8a8a"/>
        </g>
    `,
  },
  //chat audio call icon
  "dialer-audioCallIcon": {
    name: "dialer-audioCallIcon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <g id="Group_12091" data-name="Group 12091">
        <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#3dd66b"/>
        <path id="phone_1_" data-name="phone (1)" d="M19.254,14.835v2.581a1.723,1.723,0,0,1-1.879,1.72,17.08,17.08,0,0,1-7.439-2.641,16.791,16.791,0,0,1-5.172-5.161A17,17,0,0,1,2.119,3.875,1.722,1.722,0,0,1,3.834,2H6.42A1.723,1.723,0,0,1,8.144,3.48a11.027,11.027,0,0,0,.6,2.417,1.718,1.718,0,0,1-.388,1.815L7.265,8.8a13.777,13.777,0,0,0,5.172,5.161l1.095-1.092a1.726,1.726,0,0,1,1.819-.387,11.085,11.085,0,0,0,2.422.6,1.721,1.721,0,0,1,1.483,1.746Z" transform="translate(9.317 9.429)" fill="#fff"/>
      </g>
    `,
  },

  "chat-favouriteIcon": {
    name: "chat-favouriteIcon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
      <path id="heart" d="M16.573,1.566A4.842,4.842,0,0,0,12.972,0a4.531,4.531,0,0,0-2.828.975A5.784,5.784,0,0,0,9,2.168,5.78,5.78,0,0,0,7.857.975,4.53,4.53,0,0,0,5.029,0a4.842,4.842,0,0,0-3.6,1.566A5.619,5.619,0,0,0,0,5.4,6.691,6.691,0,0,0,1.786,9.786a38.055,38.055,0,0,0,4.469,4.191c.619.527,1.321,1.125,2.05,1.762a1.057,1.057,0,0,0,1.391,0c.729-.637,1.431-1.235,2.051-1.762a38.034,38.034,0,0,0,4.469-4.191A6.69,6.69,0,0,0,18,5.4a5.618,5.618,0,0,0-1.428-3.839Zm0,0" transform="translate(11 12)" fill="#e51a1a"/>
    `,
  },

  "chat-notFavouriteIcon": {
    name: "chat-notFavouriteIcon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
      <path id="heart" d="M16.573,1.566A4.842,4.842,0,0,0,12.972,0a4.531,4.531,0,0,0-2.828.975A5.784,5.784,0,0,0,9,2.168,5.78,5.78,0,0,0,7.857.975,4.53,4.53,0,0,0,5.029,0a4.842,4.842,0,0,0-3.6,1.566A5.619,5.619,0,0,0,0,5.4,6.691,6.691,0,0,0,1.786,9.786a38.055,38.055,0,0,0,4.469,4.191c.619.527,1.321,1.125,2.05,1.762a1.057,1.057,0,0,0,1.391,0c.729-.637,1.431-1.235,2.051-1.762a38.034,38.034,0,0,0,4.469-4.191A6.69,6.69,0,0,0,18,5.4a5.618,5.618,0,0,0-1.428-3.839Zm0,0" transform="translate(11 12)" stroke="#8a8a8a" fill="#8a8a8a"/>
    `,
  },

  "chat-smileyIcon": {
    name: "chat-smileyIcon",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="chat-smileyIcon" transform="translate(0)">
      <path id="Path_12140" data-name="Path 12140" d="M33.647,47.782a58.932,58.932,0,0,1-18.31,0A16.955,16.955,0,0,1,1.219,33.647a58.421,58.421,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.31,0A16.955,16.955,0,0,1,47.782,15.337a58.932,58.932,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.782Z" transform="translate(-0.497 -0.497)" fill="#f2f2f2"/>
      <path id="Path_12084" data-name="Path 12084" d="M21,32A11,11,0,1,1,32,21,11.012,11.012,0,0,1,21,32Zm0-20.429A9.429,9.429,0,1,0,30.429,21,9.439,9.439,0,0,0,21,11.571Zm.027,15.844A7.035,7.035,0,0,1,15.455,24.7a.785.785,0,1,1,1.237-.968,5.5,5.5,0,0,0,8.7-.038.786.786,0,1,1,1.246.959,7.022,7.022,0,0,1-5.608,2.763Zm-3.536-6.337A1.178,1.178,0,0,1,16.313,19.9V18.329a1.179,1.179,0,1,1,2.357,0V19.9A1.18,1.18,0,0,1,17.491,21.079Zm7.071,0A1.178,1.178,0,0,1,23.384,19.9V18.329a1.179,1.179,0,1,1,2.357,0V19.9A1.18,1.18,0,0,1,24.563,21.079Z" transform="translate(3 3)" fill="#969696"/>
    </g>
    `,
  },
  "chat-importantIcon": {
    name: "chat-importantIcon",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12140" data-name="Path 12140" d="M33.647,47.782a58.932,58.932,0,0,1-18.31,0A16.955,16.955,0,0,1,1.219,33.647a58.421,58.421,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.31,0A16.955,16.955,0,0,1,47.782,15.337a58.932,58.932,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.782Z" transform="translate(-0.497 -0.497)" fill="#ffe9e9"/>
      <path id="important" d="M15.583.537A1.82,1.82,0,0,0,14.287,0H.917A.917.917,0,0,0,.269,1.565L5.95,7.246a.124.124,0,0,1,0,.175L.269,13.1a.917.917,0,0,0,.648,1.565h13.37a1.822,1.822,0,0,0,1.3-.537l6.148-6.148a.916.916,0,0,0,0-1.3Zm-1.3,12.3H3.13L7.247,8.717A1.919,1.919,0,0,0,7.58,8.25h2.5a.917.917,0,0,0,0-1.833H7.58a1.928,1.928,0,0,0-.334-.467L3.13,1.833H14.287l5.5,5.5Zm0,0" transform="translate(16.437 35) rotate(-90)" fill="#ee4949"/>
    `,
  },

  "chat-sendMsgIcon": {
    name: "chat-sendMsgIcon",
    viewBox: "0 0 66 66",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12139" data-name="Path 12139" d="M46.079,65.514a81.032,81.032,0,0,1-25.177,0A23.313,23.313,0,0,1,1.49,46.079a80.329,80.329,0,0,1,0-25.177A23.3,23.3,0,0,1,20.9,1.49a80.329,80.329,0,0,1,25.177,0A23.313,23.313,0,0,1,65.514,20.9a81.031,81.031,0,0,1,0,25.177A23.324,23.324,0,0,1,46.079,65.514Z" transform="translate(-0.497 -0.497)" fill="#f2f2f2"/>
      <path id="Path_12078" data-name="Path 12078" d="M0,25.607V15.672L21.339,12.8,0,9.935V0L29.874,12.8Z" transform="matrix(0.819, -0.574, 0.574, 0.819, 16.389, 28.112)" fill="#005dff"/>
    `,
  },

  "chat-plus": {
    name: "chat-plus",
    viewBox: "0 0 39.998 39.998",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <g id="Group_12647" data-name="Group 12647" transform="translate(-0.001 -0.001)">
        <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
        <path fill="#8A8A8A" id="Path_12210" data-name="Path 12210" d="M20.235,38.863h-7V33.248A1.428,1.428,0,0,0,11.674,32H10.117a1.428,1.428,0,0,0-1.557,1.248v5.615h-7A1.428,1.428,0,0,0,0,40.111v1.248a1.428,1.428,0,0,0,1.557,1.248h7v5.615a1.428,1.428,0,0,0,1.557,1.248h1.557a1.428,1.428,0,0,0,1.557-1.248V42.607h7a1.428,1.428,0,0,0,1.557-1.248V40.111A1.428,1.428,0,0,0,20.235,38.863Z" transform="translate(9.104 -20.735)"/>
      </g>
    `,
  },

  "chat-pinIcon": {
    name: "chat-pinIcon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <g id="Group_12647" data-name="Group 12647" transform="translate(0 0)">
        <path id="Path_12118" data-name="Path 12118" d="M28.124,39.9a49.113,49.113,0,0,1-15.26,0A14.13,14.13,0,0,1,1.1,28.124a48.687,48.687,0,0,1,0-15.26A14.123,14.123,0,0,1,12.865,1.1a48.687,48.687,0,0,1,15.26,0A14.13,14.13,0,0,1,39.9,12.865a49.112,49.112,0,0,1,0,15.26A14.137,14.137,0,0,1,28.124,39.9Z" transform="translate(-0.498 -0.498)" fill="#ececec"/>
        <path fill="#8a8a8a" id="Path_12211" data-name="Path 12211" d="M11.448,8.231l-.47-4.543H12.6a.922.922,0,0,0,.922-.922V.922A.922.922,0,0,0,12.6,0H2.151a.922.922,0,0,0-.922.922V2.766a.922.922,0,0,0,.922.922H3.772L3.3,8.231C1.439,9.1,0,10.651,0,12.6a.922.922,0,0,0,.922.922H6.146v4a.307.307,0,0,0,.032.137L7.1,19.5a.308.308,0,0,0,.55,0l.922-1.844a.308.308,0,0,0,.032-.137v-4h5.224a.922.922,0,0,0,.922-.922C14.751,10.633,13.292,9.088,11.448,8.231Z" transform="translate(12.625 10.166)"/>
      </g>
    `,
  },

  "chat-viewMoreDotsIcon": {
    name: "chat-viewMoreDotsIcon",
    viewBox: "0 0 5 21",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <g id="Group_12464" data-name="Group 12464">
        <circle id="Ellipse_935" data-name="Ellipse 935" cx="2.5" cy="2.5" r="2.5" transform="translate(5) rotate(90)" fill="#8a8a8a"/>
        <circle id="Ellipse_936" data-name="Ellipse 936" cx="2.5" cy="2.5" r="2.5" transform="translate(5 8) rotate(90)" fill="#8a8a8a"/>
        <circle id="Ellipse_937" data-name="Ellipse 937" cx="2.5" cy="2.5" r="2.5" transform="translate(5 16) rotate(90)" fill="#8a8a8a"/>
      </g>
    `,
  },

  "chat-paperclip": {
    name: "chat-paperclip",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <g id="_82fd84c50c6c63b7286b7857627a2966" data-name="82fd84c50c6c63b7286b7857627a2966">
        <path id="Path_12140" data-name="Path 12140" d="M33.647,47.782a58.932,58.932,0,0,1-18.31,0A16.955,16.955,0,0,1,1.219,33.647a58.421,58.421,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.31,0A16.955,16.955,0,0,1,47.782,15.337a58.932,58.932,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.782Z" transform="translate(-0.497 -0.497)" fill="rgba(242,242,242,0)"/>
      </g>
      <path id="XMLID_197_" d="M70.285,0h0a5.583,5.583,0,0,0-4.04,1.731A5.974,5.974,0,0,0,64.57,5.909V16.546a3.43,3.43,0,1,0,6.857,0V10.408a1.143,1.143,0,1,0-2.286,0v6.138a1.143,1.143,0,1,1-2.286,0V5.909a3.584,3.584,0,0,1,1-2.507,3.35,3.35,0,0,1,2.424-1.038,3.492,3.492,0,0,1,3.429,3.545V17.727A5.821,5.821,0,0,1,68,23.636a5.583,5.583,0,0,1-4.041-1.731,5.973,5.973,0,0,1-1.674-4.178V5.909a1.143,1.143,0,1,0-2.286,0V17.727a8.363,8.363,0,0,0,2.343,5.85A7.817,7.817,0,0,0,68,26a8.149,8.149,0,0,0,8-8.273V5.909A5.821,5.821,0,0,0,70.285,0Z" transform="translate(-43.999 11)" fill="#979797" stroke="#fff" stroke-width="0.5"/>
    `,
  },

  "chat-videoCameraLineIcon": {
    name: "chat-videoCameraLineIcon",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12140" data-name="Path 12140" d="M33.647,47.782a58.932,58.932,0,0,1-18.31,0A16.955,16.955,0,0,1,1.219,33.647a58.421,58.421,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.31,0A16.955,16.955,0,0,1,47.782,15.337a58.932,58.932,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.782Z" transform="translate(-0.497 -0.497)" fill="rgba(242,242,242,0)"/>
      <path id="video-camera_1_" data-name="video-camera (1)" d="M29.689,1.695a.633.633,0,0,0-.629-.011L22.177,5.461V3.194A3.19,3.19,0,0,0,19,0H3.179A3.19,3.19,0,0,0,0,3.194V15.806A3.19,3.19,0,0,0,3.179,19H19a3.19,3.19,0,0,0,3.178-3.194V13.58l6.884,3.778a.633.633,0,0,0,.629-.011A.64.64,0,0,0,30,16.8V2.244a.639.639,0,0,0-.311-.549ZM20.905,15.806A1.914,1.914,0,0,1,19,17.723H3.179a1.914,1.914,0,0,1-1.907-1.916V3.194A1.914,1.914,0,0,1,3.179,1.278H19a1.914,1.914,0,0,1,1.907,1.916Zm7.824-.085-6.553-3.6V6.916l6.553-3.6Zm0,0" transform="translate(9 15)" fill="#979797" stroke="#979797" stroke-width="0.3"/>
    `,
  },

  "chat-micLineIcon": {
    name: "chat-micLineIcon",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12140" data-name="Path 12140" d="M33.647,47.782a58.932,58.932,0,0,1-18.31,0A16.955,16.955,0,0,1,1.219,33.647a58.421,58.421,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.31,0A16.955,16.955,0,0,1,47.782,15.337a58.932,58.932,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.782Z" transform="translate(-0.497 -0.497)" fill="rgba(242,242,242,0)"/>
      <g id="mic" transform="translate(16.002 11)">
        <g id="Group_12487" data-name="Group 12487" transform="translate(3.517)">
          <g id="Group_12486" data-name="Group 12486" transform="translate(0)">
            <path id="Path_12141" data-name="Path 12141" d="M170.788,0a4.486,4.486,0,0,0-4.481,4.481v8.807a4.481,4.481,0,0,0,8.963.031V4.481A4.486,4.486,0,0,0,170.788,0ZM173.4,13.319a2.614,2.614,0,0,1-5.228-.031V4.481a2.614,2.614,0,1,1,5.228,0Z" transform="translate(-166.307)" fill="#979797"/>
          </g>
        </g>
        <g id="Group_12489" data-name="Group 12489" transform="translate(7.064 20.865)">
          <g id="Group_12488" data-name="Group 12488" transform="translate(0)">
            <rect id="Rectangle_2996" data-name="Rectangle 2996" width="1.867" height="4.201" fill="#979797"/>
          </g>
        </g>
        <g id="Group_12491" data-name="Group 12491" transform="translate(4.606 24.133)">
          <g id="Group_12490" data-name="Group 12490" transform="translate(0)">
            <path id="Path_12142" data-name="Path 12142" d="M193.958,474.628h-4.917a.934.934,0,0,0,0,1.867h4.917a.934.934,0,1,0,0-1.867Z" transform="translate(-188.107 -474.628)" fill="#979797"/>
          </g>
        </g>
        <g id="Group_12493" data-name="Group 12493" transform="translate(0 12.041)">
          <g id="Group_12492" data-name="Group 12492">
            <path id="Path_12143" data-name="Path 12143" d="M110.984,234.822a.934.934,0,0,0-.934.934v.747a6.131,6.131,0,1,1-12.262,0v-.747a.934.934,0,0,0-1.867,0v.747a8,8,0,1,0,16,0v-.747A.934.934,0,0,0,110.984,234.822Z" transform="translate(-95.922 -234.822)" fill="#979797"/>
          </g>
        </g>
      </g>
    `,
  },

  "chat-rightSideBarTaemIcon": {
    name: "chat-rightSideBarTaemIcon",
    viewBox: "0 0 55 54.995",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
     <g id="Group_12344" data-name="Group 12344" transform="translate(3.902 -1.502)">
        <path id="Path_12127" data-name="Path 12127" d="M115.894,341.684a67.564,67.564,0,0,1-20.987,0A19.431,19.431,0,0,1,78.725,325.5a67.52,67.52,0,0,1,0-20.983,19.441,19.441,0,0,1,16.182-16.188,67.559,67.559,0,0,1,20.987,0,19.441,19.441,0,0,1,16.191,16.188,67.519,67.519,0,0,1,0,20.983,19.431,19.431,0,0,1-16.191,16.188Z" transform="translate(-81.807 -286.007)" fill="#f9f9f9"/>
        <g id="user" transform="translate(18.003 18.001)">
          <g id="Group_12533" data-name="Group 12533" transform="translate(0.001 -0.006)">
            <path id="Path_12152" data-name="Path 12152" d="M21.945,18.853a.859.859,0,1,0-1.683.347.9.9,0,0,1-.182.753.873.873,0,0,1-.688.327H2.609a.873.873,0,0,1-.688-.327.9.9,0,0,1-.182-.753,9.5,9.5,0,0,1,9.032-7.519h.463a9.454,9.454,0,0,1,7.636,4.2.86.86,0,1,0,1.428-.958,11.179,11.179,0,0,0-5.79-4.4,5.844,5.844,0,1,0-7,0A11.178,11.178,0,0,0,.057,18.853,2.611,2.611,0,0,0,2.609,22H19.393a2.611,2.611,0,0,0,2.548-3.149ZM6.876,5.845A4.125,4.125,0,1,1,11.209,9.96h-.417A4.131,4.131,0,0,1,6.876,5.845Z" transform="translate(-0.001 0.006)" fill="black" stroke="#a3a3b1" stroke-width="0.5"/>
          </g>
        </g>
        <g id="user-2" data-name="user" transform="translate(6.408 22.81)">
          <g id="Group_12533-2" data-name="Group 12533" transform="translate(0.001 -0.006)">
            <path id="Path_12152-2" data-name="Path 12152" d="M17.15,14.732A.671.671,0,1,0,15.835,15a.7.7,0,0,1-.142.588.682.682,0,0,1-.538.255H2.039a.682.682,0,0,1-.538-.255A.7.7,0,0,1,1.359,15,7.421,7.421,0,0,1,8.418,9.128H8.78a7.388,7.388,0,0,1,5.967,3.28.672.672,0,1,0,1.116-.748A8.737,8.737,0,0,0,11.338,8.22a4.567,4.567,0,1,0-5.467,0A8.736,8.736,0,0,0,.044,14.732a2.041,2.041,0,0,0,1.995,2.462H15.156a2.041,2.041,0,0,0,1.991-2.461ZM5.374,4.567A3.224,3.224,0,1,1,8.76,7.782H8.434A3.228,3.228,0,0,1,5.374,4.567Z" transform="translate(-0.001 0.006)" fill="black" stroke="#a3a3b1" stroke-width="0.5"/>
          </g>
        </g>
      </g>
    `,
  },

  "dialer-MuteInBox-icon": {
    name: "dialer-MuteInBox-icon",
    viewBox: "0 0 40 40",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <path id="Path_12118" data-name="Path 12118" d="M28.122,39.9a49.11,49.11,0,0,1-15.259,0A14.129,14.129,0,0,1,1.1,28.122a48.684,48.684,0,0,1,0-15.259A14.122,14.122,0,0,1,12.864,1.1a48.684,48.684,0,0,1,15.259,0A14.129,14.129,0,0,1,39.9,12.864a49.11,49.11,0,0,1,0,15.259A14.136,14.136,0,0,1,28.122,39.9Z" transform="translate(-0.497 -0.497)" fill="#ececec"/>
    <g id="voice" transform="translate(-5.975 7.996)">
      <g id="Group_12497" data-name="Group 12497" transform="translate(19.975 4)">
        <path id="Path_12144" data-name="Path 12144" d="M34.19,14.2a3.242,3.242,0,0,0,3.12-3.345V3.345a3.127,3.127,0,1,0-6.239,0V10.86A3.242,3.242,0,0,0,34.19,14.2Z" transform="translate(-28.302 -2)" fill="#636363"/>
        <path id="Path_12145" data-name="Path 12145" d="M30.185,45.715h-.693a.4.4,0,0,0-.4.388v1.362a4.5,4.5,0,0,1-9,0V46.1a.4.4,0,0,0-.4-.388h-.693a.4.4,0,0,0-.4.388v1.362a5.933,5.933,0,0,0,5.25,5.718v.965h-3.1a.4.4,0,0,0-.4.388V55.2a.4.4,0,0,0,.4.388h7.693a.4.4,0,0,0,.4-.388v-.666a.4.4,0,0,0-.4-.388h-3.1v-.965a5.932,5.932,0,0,0,5.25-5.718V46.1A.4.4,0,0,0,30.185,45.715Z" transform="translate(-18.588 -37.589)" fill="#636363"/>
      </g>
    </g>
    <path id="Path_14330" data-name="Path 14330" d="M4.785,20.233,17.836,7.281l5.435-5.394L22.17.8,3.7,19.147l1.09,1.081Z" transform="translate(5.182 11.46) rotate(-8)" fill="#636363" fill-rule="evenodd"/>`,
  },

  "dialer-cross-icon": {
    name: "dialer-cross-icon",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <g id="_82fd84c50c6c63b7286b7857627a2966" data-name="82fd84c50c6c63b7286b7857627a2966" transform="translate(-1 1)">
      <path id="Path_12140" data-name="Path 12140" d="M33.647,47.782a58.932,58.932,0,0,1-18.31,0A16.955,16.955,0,0,1,1.219,33.647a58.421,58.421,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.31,0A16.955,16.955,0,0,1,47.782,15.337a58.932,58.932,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.782Z" transform="translate(0.503 -1.497)" fill="#f2f2f2"/>
      <path id="Path_12212" data-name="Path 12212" d="M12.929,89.375l5.33-5.33a1.676,1.676,0,0,0,0-2.369l-1.185-1.185a1.676,1.676,0,0,0-2.369,0l-5.33,5.33-5.33-5.33a1.676,1.676,0,0,0-2.369,0L.491,81.675a1.676,1.676,0,0,0,0,2.369l5.33,5.33-5.33,5.33a1.676,1.676,0,0,0,0,2.369l1.185,1.185a1.676,1.676,0,0,0,2.369,0l5.33-5.33,5.33,5.33a1.676,1.676,0,0,0,2.369,0l1.185-1.185a1.676,1.676,0,0,0,0-2.369Z" transform="translate(15.75 -66.5)"/>
    </g>
      `,
  },

  "setting-accounts-icon": {
    name: "setting-accounts-icon",
    viewBox: "0 0 47.999 47.999",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
    <path id="Path_12210" data-name="Path 12210" d="M33.647,47.781a58.931,58.931,0,0,1-18.31,0A16.954,16.954,0,0,1,1.219,33.647a58.42,58.42,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.42,58.42,0,0,1,18.31,0A16.954,16.954,0,0,1,47.781,15.337a58.931,58.931,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.781Z" transform="translate(-0.497 -0.497)" fill="#fff"/>
    <g id="planning" transform="translate(12.706 12.706)">
      <g id="Group_12736" data-name="Group 12736">
        <g id="Group_12735" data-name="Group 12735">
          <path id="Path_12307" data-name="Path 12307" d="M21.265,14.673V1.985A1.988,1.988,0,0,0,19.279,0H4.676A1.988,1.988,0,0,0,2.691,1.985v.706H1.985a1.985,1.985,0,0,0,0,3.971h.706V9.309H1.985a1.985,1.985,0,1,0,0,3.971h.706v2.647H1.985a1.985,1.985,0,1,0,0,3.971h.706v.662a2.041,2.041,0,0,0,.571,1.415,1.945,1.945,0,0,0,1.414.614H17.956a4.661,4.661,0,0,0,3.309-7.915ZM1.985,5.338a.662.662,0,1,1,0-1.324H3.353a.662.662,0,1,1,0,1.324Zm0,6.618a.662.662,0,1,1,0-1.324H3.353a.662.662,0,1,1,0,1.324Zm1.368,6.618H1.985a.662.662,0,1,1,0-1.324H3.353a.662.662,0,1,1,0,1.324Zm1.324,2.691a.7.7,0,0,1-.662-.706v-.776a1.985,1.985,0,0,0,0-3.743V13.166a1.985,1.985,0,0,0,0-3.743V6.548a1.985,1.985,0,0,0,0-3.743v-.82a.663.663,0,0,1,.662-.662h14.6a.663.663,0,0,1,.662.662V13.727a4.631,4.631,0,0,0-6.618,4.185,4.684,4.684,0,0,0,1.407,3.353Zm13.279,0a3.331,3.331,0,1,1,3.309-3.353A3.335,3.335,0,0,1,17.956,21.265Z" fill="#5576d1"/>
        </g>
      </g>
      <g id="Group_12738" data-name="Group 12738" transform="translate(13.241 5.331)">
        <g id="Group_12737" data-name="Group 12737">
          <path id="Path_12308" data-name="Path 12308" d="M306.726,121h-4.051a.675.675,0,0,0,0,1.35h4.051a.675.675,0,0,0,0-1.35Z" transform="translate(-302 -121)" fill="#5576d1"/>
        </g>
      </g>
      <g id="Group_12740" data-name="Group 12740" transform="translate(13.241 10.619)">
        <g id="Group_12739" data-name="Group 12739">
          <path id="Path_12309" data-name="Path 12309" d="M306.726,241h-4.051a.675.675,0,0,0,0,1.35h4.051a.675.675,0,0,0,0-1.35Z" transform="translate(-302 -241)" fill="#5576d1"/>
        </g>
      </g>
      <g id="Group_12742" data-name="Group 12742" transform="translate(17.187 15.884)">
        <g id="Group_12741" data-name="Group 12741">
          <path id="Path_12310" data-name="Path 12310" d="M394.026,362.35h-.675v-.675a.675.675,0,0,0-1.35,0v1.35a.675.675,0,0,0,.675.675h1.35a.675.675,0,1,0,0-1.35Z" transform="translate(-392 -361)" fill="#5576d1"/>
        </g>
      </g>
      <g id="Group_12744" data-name="Group 12744" transform="translate(6.434 3.997)">
        <g id="Group_12743" data-name="Group 12743">
          <path id="Path_12311" data-name="Path 12311" d="M152.176,91.2a.675.675,0,0,0-.955,0L149,93.421l-1.063-1.063a.675.675,0,1,0-.955.955l1.54,1.54a.675.675,0,0,0,.955,0l2.7-2.7A.675.675,0,0,0,152.176,91.2Z" transform="translate(-146.783 -91)" fill="#5576d1"/>
        </g>
      </g>
      <g id="Group_12746" data-name="Group 12746" transform="translate(6.434 9.269)">
        <g id="Group_12745" data-name="Group 12745">
          <path id="Path_12312" data-name="Path 12312" d="M152.176,211.2a.675.675,0,0,0-.955,0L149,213.421l-1.063-1.063a.675.675,0,1,0-.955.955l1.54,1.54a.675.675,0,0,0,.955,0l2.7-2.7A.675.675,0,0,0,152.176,211.2Z" transform="translate(-146.783 -211)" fill="#5576d1"/>
        </g>
      </g>
      <g id="Group_12748" data-name="Group 12748" transform="translate(6.434 14.54)">
        <g id="Group_12747" data-name="Group 12747">
          <path id="Path_12313" data-name="Path 12313" d="M152.176,331.2a.675.675,0,0,0-.955,0L149,333.421l-1.063-1.063a.675.675,0,0,0-.955.955l1.54,1.54a.675.675,0,0,0,.955,0l2.7-2.7A.675.675,0,0,0,152.176,331.2Z" transform="translate(-146.783 -331)" fill="#5576d1"/>
        </g>
      </g>
    </g>
      `,
  },

  "setting-calls-icon": {
    name: "setting-calls-icon",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12210" data-name="Path 12210" d="M33.648,47.782a58.932,58.932,0,0,1-18.311,0A16.955,16.955,0,0,1,1.219,33.648a58.421,58.421,0,0,1,0-18.311A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.311,0A16.955,16.955,0,0,1,47.782,15.337a58.932,58.932,0,0,1,0,18.311A16.963,16.963,0,0,1,33.648,47.782Z" transform="translate(-0.497 -0.497)" fill="#fff"/>
      <path id="telephone" d="M21.051,20.13h0Zm0,0h0Zm-.163-4.514c-2.207-2.14-4.456-3.234-6.76-1.065l0,0L12.969,15.7a18.268,18.268,0,0,1-3.685-2.887A18.28,18.28,0,0,1,6.4,9.129L7.545,7.973l0,0C9.717,5.66,8.625,3.413,6.486,1.2A3.248,3.248,0,0,0,1.976,1.04c-4.144,4.5-1.138,11.5,3.2,15.884l.008.008a20.834,20.834,0,0,0,2.039,1.776.855.855,0,0,0,1.039-1.357,19.116,19.116,0,0,1-1.879-1.637l-.008-.008c-2.9-2.9-4.639-6.471-4.654-9.542A5.283,5.283,0,0,1,3.11,2.318l.007-.006a1.536,1.536,0,0,1,2.14.077c2.211,2.3,2.051,3.378,1.074,4.381l-1.583,1.6a.855.855,0,0,0-.174.95A20.511,20.511,0,0,0,12.78,17.53a.854.854,0,0,0,.949-.174l1.595-1.584c1-.978,2.085-1.139,4.378,1.075a1.539,1.539,0,0,1,.077,2.142L19.773,19a5.268,5.268,0,0,1-3.844,1.386,11.068,11.068,0,0,1-4.215-1,.855.855,0,0,0-.677,1.57,12.592,12.592,0,0,0,4.883,1.138,7.1,7.1,0,0,0,5.13-1.96,3.255,3.255,0,0,0-.163-4.514Z" transform="translate(12.706 12.498)" fill="#5576d1"/>
    `,
  },

  "setting-balance-icon": {
    name: "setting-balance-icon",
    viewBox: "0 0 48 48",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_12210" data-name="Path 12210" d="M33.647,47.782a58.932,58.932,0,0,1-18.31,0A16.955,16.955,0,0,1,1.219,33.647a58.421,58.421,0,0,1,0-18.31A16.946,16.946,0,0,1,15.337,1.219a58.421,58.421,0,0,1,18.31,0A16.955,16.955,0,0,1,47.782,15.337a58.931,58.931,0,0,1,0,18.31A16.963,16.963,0,0,1,33.647,47.782Z" transform="translate(-0.497 -0.497)" fill="#5576d1" opacity="0.15"/>
      <g id="wallet" transform="translate(13.875 12.625)">
        <path id="Path_14552" data-name="Path 14552" d="M18.863,7.108a.88.88,0,0,0-.636-.271h-.635V4.3a.912.912,0,0,0-.9-.923H3.768A2.681,2.681,0,0,0,1.125,6.091V16.659a2.681,2.681,0,0,0,2.643,2.716H18.191a.913.913,0,0,0,.9-.92l.035-10.692a.93.93,0,0,0-.262-.655Zm-.97,11.036H3.768a1.466,1.466,0,0,1-1.446-1.486V6.091A1.466,1.466,0,0,1,3.768,4.606H16.394V6.837H4.82V8.067H17.927Z" fill="#5576d1" stroke="#5576d1" stroke-width="0.5"/>
        <path id="Path_14553" data-name="Path 14553" d="M27.7,18.7a1.37,1.37,0,0,1,1.937,1.937A1.37,1.37,0,1,1,27.7,18.7Z" transform="translate(-14.376 -8.868)" fill="#5576d1" stroke="#5576d1" stroke-width="0.5"/>
      </g>
      `,
  },

  // "show-sub-table-icon": {
  //   name: "show-sub-table-icon",
  //   viewBox: "0 0 16 16",
  //   fill: "",
  //   "stroke-width": "",
  //   "stroke-linecap": "",
  //   "stroke-linejoin": "",
  //   stroke: "",
  //   icon: `
  //       <g id="Group_13017" data-name="Group 13017" transform="translate(-62.035 -271)">
  //         <path id="details" d="M15.017,12h-7a1,1,0,1,1,0-2h7a1,1,0,1,1,0,2Zm0-6h-7a.954.954,0,0,1-.711-.3.983.983,0,0,1-.289-.711.956.956,0,0,1,.289-.7A.969.969,0,0,1,8.017,4h7a.987.987,0,0,1,1,.992.984.984,0,0,1-.289.711A.952.952,0,0,1,15.017,6Zm0-4h-7a.954.954,0,0,1-.711-.3A.983.983,0,0,1,7.017.993a.956.956,0,0,1,.289-.7A.969.969,0,0,1,8.017,0h7a.987.987,0,0,1,1,.992.984.984,0,0,1-.289.711A.952.952,0,0,1,15.017,2Zm-10,14h-4a.966.966,0,0,1-.711-.289A.966.966,0,0,1,.017,15V11a.966.966,0,0,1,.289-.711A.966.966,0,0,1,1.017,10h4a.973.973,0,0,1,.7.289.954.954,0,0,1,.3.711v4a.954.954,0,0,1-.3.711A.973.973,0,0,1,5.017,16Zm0-10h-4a.954.954,0,0,1-.711-.3A.973.973,0,0,1,.017,5V1A.966.966,0,0,1,.306.289.966.966,0,0,1,1.017,0h4a.973.973,0,0,1,.7.289.954.954,0,0,1,.3.711V5a1.013,1.013,0,0,1-1,1Zm3,8h7a.988.988,0,0,1,1,1,.954.954,0,0,1-.3.711.973.973,0,0,1-.7.289h-7a1,1,0,1,1,0-2Z" transform="translate(62.018 271)" fill="#636363"/>
  //       </g>
  //     `,
  // },

  "show-sub-table-icon": {
    name: "show-sub-table-icon",
    viewBox: "0 0 22 22",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
      <path id="Path_118543" data-name="Path 118543" d="M11,22A11,11,0,1,1,22.01,10.984,11,11,0,0,1,11,22M12.588,6H8.715A1.041,1.041,0,1,0,8.7,8.077q3.9.006,7.8,0a1.273,1.273,0,0,0,.536-.133A1.029,1.029,0,0,0,16.573,6H12.588m-.036,10h3.873a1.559,1.559,0,0,0,.361-.028,1.033,1.033,0,0,0,.791-1.133,1.05,1.05,0,0,0-1.1-.916H8.731a1.043,1.043,0,1,0,0,2.079h3.817m.03-3.966H14.2c.8,0,1.59.016,2.384-.01a1.019,1.019,0,0,0,.921-1.4,1.051,1.051,0,0,0-1.1-.661H8.751a2.4,2.4,0,0,0-.252.012,1,1,0,0,0-.875.789A1.024,1.024,0,0,0,8.71,12.032c1.29.008,2.581,0,3.871,0M4.437,11.009A1.061,1.061,0,1,0,5.5,9.934a1.072,1.072,0,0,0-1.062,1.075m1.073,2.9a1.055,1.055,0,1,0,1.041,1.07,1.055,1.055,0,0,0-1.041-1.07m0-5.823a.914.914,0,1,0-.011,0" transform="translate(-0.01)" fill="#1a1818"/>
    `,
  },

  "ticket-icon": {
    name: "ticket-icon",
    viewBox: "0 0 26 16",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="ticket" d="M3,14.333V11.667A2.634,2.634,0,0,1,5.6,9H26.4A2.634,2.634,0,0,1,29,11.667v2.667a2.668,2.668,0,0,0,0,5.333v2.667A2.634,2.634,0,0,1,26.4,25H5.6A2.634,2.634,0,0,1,3,22.333V19.667a2.668,2.668,0,0,0,0-5.333Zm3.9-2.667V22.333H25.1V11.667Zm2.6,2.667h13v5.333H9.5Z" transform="translate(-3 -9)" fill="#6a6a6a" fill-rule="evenodd"/>
      `,
  },

  "call-info-block": {
    name: "call-info-block",
    viewBox: "0 0 55.704 55.703",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g>
          <path d="M27.852,0C19.905,0,12.743,3.363,7.664,8.72C7.628,8.751,7.583,8.762,7.549,8.796C7.495,8.85,7.476,8.922,7.426,8.98   C2.833,13.949,0,20.568,0,27.852c0,15.357,12.493,27.851,27.851,27.851c15.356,0,27.851-12.494,27.851-27.851   C55.703,12.494,43.208,0,27.852,0z M4.489,27.851c0-5.315,1.805-10.207,4.806-14.138l32.691,32.694   c-3.93,3.001-8.819,4.806-14.135,4.806C14.969,51.213,4.489,40.732,4.489,27.851z M45.282,43.352l-32.933-32.93   c4.13-3.678,9.551-5.934,15.503-5.934c12.881,0,23.362,10.48,23.362,23.363C51.213,33.803,48.958,39.225,45.282,43.352z"/>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      `,
  },
  "callActivity-search": {
    name: "callActivity-search",
    viewBox: "0 0 17.503 17.506",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
          <path id="Icon_awesome-search" data-name="Icon awesome-search" d="M17.272,15.141l-3.41-3.41a.82.82,0,0,0-.581-.239h-.557a7.111,7.111,0,1,0-1.231,1.231v.557a.82.82,0,0,0,.239.581l3.41,3.41a.817.817,0,0,0,1.159,0l.968-.968A.825.825,0,0,0,17.272,15.141ZM7.114,11.492a4.375,4.375,0,1,1,3.1-1.281,4.378,4.378,0,0,1-3.1,1.281Z" transform="translate(-0.007 -0.006)" fill="#5576d1"/>    
      `,
  },
  "callActivity-refresh": {
    name: "callActivity-refresh",
    viewBox: "0 0 17.915 17.898",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="Icon_material-refresh" data-name="Icon material-refresh" d="M21.271,8.628A8.949,8.949,0,1,0,23.6,17.185H21.271a6.708,6.708,0,1,1-6.319-8.948,6.616,6.616,0,0,1,4.72,1.991l-3.6,3.6H23.9V6Z" transform="translate(-5.985 -5.999)" fill="#5576d1"/>
       `,
  },
  "callActivity-filter": {
    name: "callActivity-filter",
    viewBox: "0 0 17.892 17.896",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="Icon_awesome-filter" data-name="Icon awesome-filter" d="M.84,0H17.055a.839.839,0,0,1,.593,1.432L11.185,7.9v7.2a.839.839,0,0,1-.358.687l-2.8,1.957a.839.839,0,0,1-1.32-.687V7.9L.247,1.432A.839.839,0,0,1,.84,0Z" transform="translate(-0.002)" fill="#5576d1"/>
      `,
  },
  "callActivity-AdjustDesign-v3": {
    name: "callActivity-AdjustDesign-v3",
    viewBox: "0 0 18.539 16.844",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_12305" data-name="Group 12305" transform="translate(0 -0.59)">
          <g id="Group_12304" data-name="Group 12304">
            <rect id="Rectangle_2971" data-name="Rectangle 2971" width="18.539" height="2" rx="1" transform="translate(0 2.09)" fill="#5576d1"/>
            <g id="Ellipse_925" data-name="Ellipse 925" transform="translate(2.06 0.59)" fill="#fff" stroke="#5576d1" stroke-width="1.5">
              <circle cx="2.5" cy="2.5" r="2.5" stroke="none"/>
              <circle cx="2.5" cy="2.5" r="1.75" fill="none"/>
            </g>
          </g>
          <g id="Group_12302" data-name="Group 12302" transform="translate(0 13.389)">
            <rect id="Rectangle_2973" data-name="Rectangle 2973" width="18.539" height="2" rx="1" transform="translate(0 0.545)" fill="#5576d1"/>
            <g id="Ellipse_927" data-name="Ellipse 927" transform="translate(2.06 -0.955)" fill="#fff" stroke="#5576d1" stroke-width="1.5">
              <circle cx="2.5" cy="2.5" r="2.5" stroke="none"/>
              <circle cx="2.5" cy="2.5" r="1.75" fill="none"/>
            </g>
          </g>
          <g id="Group_12303" data-name="Group 12303" transform="translate(0 6.18)">
            <rect id="Rectangle_2972" data-name="Rectangle 2972" width="18.539" height="2" rx="1" transform="translate(0 2.06)" fill="#5576d1"/>
            <g id="Ellipse_926" data-name="Ellipse 926" transform="translate(10.3 0.59)" fill="#fff" stroke="#5576d1" stroke-width="1.5">
              <circle cx="2.5" cy="2.5" r="2.5" stroke="none"/>
              <circle cx="2.5" cy="2.5" r="1.75" fill="none"/>
            </g>
          </g>
        </g>
      `,
  },
  "teams-changeImage-icon": {
    name: "teams-changeImage-icon",
    viewBox: "0 0 29.517 27.332",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_14498" data-name="Group 14498" transform="translate(-1884.153 -305.14)">
          <path id="Path_40250" data-name="Path 40250" d="M1.646,16.216,5.233,12.6c.13-.131.257-.264.391-.39a.825.825,0,0,1,1.312.015q1.818,1.8,3.621,3.619c.13.13.245.275.392.442.168-.159.3-.279.427-.4l7.063-7.063c.677-.677.978-.674,1.669.015.58.579,1.164,1.155,1.738,1.74a.83.83,0,0,1,.1,1.238c-.351.346-.806.311-1.237-.111-.465-.456-.921-.922-1.421-1.424-.146.135-.279.252-.4.376q-2.982,2.98-5.963,5.962c-2.142,2.138-1.716,2.132-3.836.018-.923-.92-1.842-1.845-2.815-2.82-.4.413-.783.806-1.168,1.192-1.064,1.065-2.14,2.119-3.188,3.2a1.126,1.126,0,0,0-.29.688c-.031,1.02-.017,2.041-.012,3.061,0,1.112.515,1.616,1.639,1.618,2.342,0,4.685-.008,7.027.013a1.312,1.312,0,0,1,.814.269.753.753,0,0,1-.363,1.268,2.188,2.188,0,0,1-.6.056q-3.438,0-6.876,0A2.991,2.991,0,0,1,0,21.929Q0,12.593,0,3.257A2.979,2.979,0,0,1,3.237,0H21.959a2.962,2.962,0,0,1,3.219,3.214V8.685c0,.383-.1.737-.484.844a.955.955,0,0,1-.776-.093,1.251,1.251,0,0,1-.333-.826c-.029-1.773-.014-3.547-.015-5.32,0-1.2-.478-1.684-1.657-1.684H3.191c-1.04,0-1.58.5-1.582,1.514q-.009,6.38,0,12.75c0,.063.013.125.037.346" transform="translate(1884.167 305.152)" fill="#878787"/>
          <path id="Path_40251" data-name="Path 40251" d="M98.244,96.7c-.485,0-.97.007-1.455,0a.807.807,0,0,1-.889-.869q0-1.53.087-3.06a1.114,1.114,0,0,1,.332-.644q5.592-5.587,11.207-11.151a2.943,2.943,0,1,1,4.139,4.185q-5.565,5.57-11.175,11.106a1.414,1.414,0,0,1-.793.334,13.108,13.108,0,0,1-1.453.015v.08m-.673-1.68c.619,0,1.186.013,1.751-.01a.653.653,0,0,0,.375-.2q5.343-5.3,10.673-10.622a1.4,1.4,0,0,0,.125-2.019,1.377,1.377,0,0,0-2.013.119q-5.344,5.3-10.675,10.62a.665.665,0,0,0-.225.364c-.024.581-.011,1.164-.011,1.752" transform="translate(1801.131 235.767)" fill="#878787"/>
          <path id="Path_40252" data-name="Path 40252" d="M50.882,32.02a2.93,2.93,0,1,1-2.08.854,2.935,2.935,0,0,1,2.08-.854m1.344,2.947a1.338,1.338,0,1,0-1.347,1.313,1.324,1.324,0,0,0,1.347-1.313" transform="translate(1842.657 277.428)" fill="#878787"/>
        </g>
      `,
  },
  "profileSettings-envelope-icon": {
    name: "profileSettings-envelope-icon",
    viewBox: "0 0 17.966 14.373",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="Icon_material-email" data-name="Icon material-email" d="M19.17,6H4.8A1.794,1.794,0,0,0,3.009,7.8L3,18.576a1.8,1.8,0,0,0,1.8,1.8H19.17a1.8,1.8,0,0,0,1.8-1.8V7.8A1.8,1.8,0,0,0,19.17,6Zm0,3.593-7.187,4.492L4.8,9.593V7.8l7.187,4.492L19.17,7.8Z" transform="translate(-3 -6)" fill="#5576d1"/>
      `,
  },
  "profileSettings-lock-icon": {
    name: "profileSettings-lock-icon",
    viewBox: "0 0 15.348 17.54",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="Icon_awesome-lock" data-name="Icon awesome-lock" d="M13.7,7.674h-.822V5.207a5.207,5.207,0,0,0-10.415,0V7.674H1.644A1.645,1.645,0,0,0,0,9.318V15.9A1.645,1.645,0,0,0,1.644,17.54H13.7A1.645,1.645,0,0,0,15.348,15.9V9.318A1.645,1.645,0,0,0,13.7,7.674Zm-3.563,0H5.207V5.207a2.467,2.467,0,1,1,4.933,0Z" fill="#5576d1"/>
    `,
  },
  "profileSettings-eye-icon": {
    name: "profileSettings-eye-icon",
    viewBox: "0 0 31.502 20.25",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Icon_ionic-ios-eye" data-name="Icon ionic-ios-eye" transform="translate(-2.252 -7.875)">
          <path id="Path_15229" data-name="Path 15229" d="M17.986,7.875c-5.653,0-10.111,3.558-15.441,9.373a1.112,1.112,0,0,0-.007,1.5c4.563,5.041,8.585,9.38,15.448,9.38,6.778,0,11.862-5.463,15.476-9.422a1.1,1.1,0,0,0,.035-1.455C29.813,12.783,24.715,7.875,17.986,7.875ZM18.3,24.321A6.328,6.328,0,1,1,24.321,18.3,6.331,6.331,0,0,1,18.3,24.321Z"/>
          <path id="Path_15230" data-name="Path 15230" d="M18,14.7a3.3,3.3,0,0,1,.218-1.188c-.07,0-.141-.007-.218-.007A4.5,4.5,0,1,0,22.5,18c0-.091-.007-.183-.007-.274a3.118,3.118,0,0,1-1.28.274A3.264,3.264,0,0,1,18,14.7Z"/>
        </g>
       `,
  },
  "profileSettings-eyeOff-icon": {
    name: "profileSettings-eyeOff-icon",
    viewBox: "0 0 31.495 27",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Icon_ionic-ios-eye-off" data-name="Icon ionic-ios-eye-off" transform="translate(-2.252 -4.5)">
          <path id="Path_15223" data-name="Path 15223" d="M6.209,4.788A1,1,0,0,0,4.8,6.2l25,25.01a.991.991,0,0,0,.963.253.974.974,0,0,0,.45-.26,1,1,0,0,0,0-1.406Z"/>
          <g id="Group_14456" data-name="Group 14456">
            <path id="Path_15224" data-name="Path 15224" d="M18.3,24.321a6.322,6.322,0,0,1-6.012-9.028L8.529,11.531a49.321,49.321,0,0,0-5.984,5.716,1.112,1.112,0,0,0-.007,1.5c4.563,5.041,8.585,9.38,15.448,9.38a13.538,13.538,0,0,0,5.787-1.35l-3.059-3.059A6.389,6.389,0,0,1,18.3,24.321Z"/>
            <path id="Path_15225" data-name="Path 15225" d="M33.455,18.7a1.1,1.1,0,0,0,.035-1.455c-3.677-4.465-8.775-9.373-15.5-9.373A13.162,13.162,0,0,0,12.22,9.211l3.073,3.073a6.2,6.2,0,0,1,2.412-.6,6.322,6.322,0,0,1,6.012,9.028l3.762,3.762A46.51,46.51,0,0,0,33.455,18.7Z"/>
            <path id="Path_15226" data-name="Path 15226" d="M13.514,18.345a4.518,4.518,0,0,0,4.141,4.141A4.4,4.4,0,0,0,19.3,22.3L13.69,16.692A4.6,4.6,0,0,0,13.514,18.345Z"/>
            <path id="Path_15227" data-name="Path 15227" d="M22.5,18c0-.091-.007-.183-.007-.274a3.118,3.118,0,0,1-1.28.274c-.077,0-.148,0-.218-.007L22.3,19.308A4.5,4.5,0,0,0,22.5,18Z"/>
            <path id="Path_15228" data-name="Path 15228" d="M18,14.7a3.3,3.3,0,0,1,.218-1.188c-.07,0-.141-.007-.218-.007a4.448,4.448,0,0,0-1.3.2l1.315,1.315C18.007,14.906,18,14.8,18,14.7Z"/>
          </g>
        </g>
       `,
  },
  // mobile icons start

  "mobile-call-activity": {
    name: "mobile-call-activity",
    viewBox: "0 0 24 24",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_45786" data-name="Group 45786" transform="translate(2144 -4538)">
          <rect id="Rectangle_20010" data-name="Rectangle 20010" width="24" height="24" transform="translate(-2144 4538)" fill="#fff" opacity="0"/>
          <g id="Group_18189" data-name="Group 18189" transform="translate(-2146.54 4537.414)">
            <g id="Group_18184" data-name="Group 18184" transform="translate(3.147 1.283)">
              <g id="Group_13412" data-name="Group 13412" transform="translate(0)">
                <path id="Path_30030" data-name="Path 30030" d="M158.308,158.318a10.767,10.767,0,0,0,2.879-2.842c-.684-.607-1.339-1.231-2.041-1.8a1.405,1.405,0,0,1-.584-1.3c.047-.778.01-1.56.013-2.34,0-.454.2-.655.644-.656q2.075,0,4.151,0c.449,0,.651.207.644.656a10.769,10.769,0,0,1-3.164,7.557,12.4,12.4,0,0,1-8.112,3.76c-.495.042-.7-.159-.7-.658q0-1.862,0-3.724c0-.455.189-.647.647-.649,1.02,0,2.04-.013,3.059.009a.986.986,0,0,1,.566.225c.677.569,1.332,1.165,2,1.756m4.6-7.82h-3.25c0,.7,0,1.391,0,2.079a.242.242,0,0,0,.082.154c.665.595,1.334,1.186,2.022,1.8a9.6,9.6,0,0,0,1.142-4.03m-9.768,6.915v2.814a11.739,11.739,0,0,0,4.189-1.32c-.564-.5-1.1-.973-1.637-1.443a.237.237,0,0,0-.144-.048c-.8,0-1.593,0-2.407,0" transform="translate(-141.227 -138.768)" fill="#959595" stroke="#959595" stroke-width="0.75"/>
                <path id="Path_30031" data-name="Path 30031" d="M75.713,0a5.444,5.444,0,1,1-5.436,5.453A5.437,5.437,0,0,1,75.713,0m.011,1.087a4.36,4.36,0,1,0,4.357,4.368,4.365,4.365,0,0,0-4.357-4.368" transform="translate(-65.282 0)" fill="#959595" stroke="#959595" stroke-width="0.75"/>
                <path id="Path_30032" data-name="Path 30032" d="M4.293,195.739c-.843,0-1.685,0-2.528,0A1.63,1.63,0,0,1,0,193.984c0-1.25.007-2.5,0-3.751a1.592,1.592,0,0,1,.928-1.542,20.406,20.406,0,0,1,12.161-2.13.557.557,0,0,1,.533.581.545.545,0,0,1-.634.5c-.937-.056-1.875-.166-2.812-.162a18.921,18.921,0,0,0-8.8,2.213.492.492,0,0,0-.285.471c0,1.295,0,2.589,0,3.884,0,.406.224.606.644.606q2.621,0,5.242,0c.362,0,.588.156.641.434a.541.541,0,0,1-.581.65c-.736.008-1.472,0-2.208,0H4.293" transform="translate(0 -173.133)" fill="#959595" stroke="#959595" stroke-width="0.75"/>
              </g>
            </g>
          </g>
        </g>
    `,
  },
  "mobile-monitor-dashboard": {
    name: "mobile-monitor-dashboard",
    viewBox: "0 0 24 24",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_45781" data-name="Group 45781" transform="translate(2268 -4563)">
          <rect id="Rectangle_20007" data-name="Rectangle 20007" width="24" height="24" transform="translate(-2268 4563)" fill="#fff" opacity="0"/>
          <g id="Group_45721" data-name="Group 45721" transform="translate(-2266.174 4563.166)">
            <g id="Group_45780" data-name="Group 45780" transform="translate(0 0)">
              <path id="Path_40363" data-name="Path 40363" d="M32.327,23.668h-13.5a.289.289,0,0,0-.077-.041,2.859,2.859,0,0,1-2.153-1.661,6.83,6.83,0,0,1-.266-2.68h.28c.491,0,.984.015,1.474-.011a1.509,1.509,0,0,0,1.361-.947,1.624,1.624,0,0,0-1.48-2.292c-.535,0-1.07,0-1.613,0V13.457c.574,0,1.133.011,1.692,0a1.618,1.618,0,0,0,.431-3.154,2.626,2.626,0,0,0-.679-.087c-.481-.013-.962,0-1.442,0V7.631c.577,0,1.137.012,1.7,0a1.62,1.62,0,0,0,.015-3.237c-.491-.016-.983-.007-1.474-.009h-.254c0-.536,0-1.037,0-1.537A2.887,2.887,0,0,1,19.176,0Q25.593,0,32.009.013A2.782,2.782,0,0,1,33.138.27a2.838,2.838,0,0,1,1.717,2.766q.007,8.793,0,17.587c0,.077,0,.154,0,.231a2.859,2.859,0,0,1-1.519,2.453,6.419,6.419,0,0,1-1.008.362m-1.842-6.939c0-.436,0-.843,0-1.251a3.11,3.11,0,0,0-3.077-3.089q-1.278-.009-2.555,0a2.878,2.878,0,0,0-.636.078,3.039,3.039,0,0,0-2.406,2.768c-.044.493-.007.992-.007,1.491Zm-4.362-5.3a2.8,2.8,0,0,0,.023-5.6,2.8,2.8,0,0,0-.023,5.6" transform="translate(-14.905 0)" fill="#959595"/>
              <path id="Path_40364" data-name="Path 40364" d="M1.944,75.9c.308,0,.617-.006.924,0a.968.968,0,1,1,.011,1.935q-.949.021-1.9,0A.967.967,0,1,1,1,75.9c.316-.008.633,0,.949,0" transform="translate(-0.002 -70.829)" fill="#959595"/>
              <path id="Path_40365" data-name="Path 40365" d="M1.927,251.558c-.308,0-.616.005-.925,0A.968.968,0,1,1,1,249.621q.936-.017,1.873,0a.968.968,0,1,1-.017,1.936c-.308.006-.616,0-.925,0" transform="translate(-0.001 -232.954)" fill="#959595"/>
              <path id="Path_40366" data-name="Path 40366" d="M1.93,164.681c-.308,0-.617.006-.925,0A.969.969,0,1,1,1,162.743q.937-.016,1.873,0a.968.968,0,1,1,.008,1.935c-.316.01-.633,0-.949,0" transform="translate(-0.003 -151.876)" fill="#959595"/>
            </g>
          </g>
        </g>
      `,
  },
  "mobile-dialer": {
    name: "mobile-dialer",
    viewBox: "0 0 24 24",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_45785" data-name="Group 45785" transform="translate(2168 -4564)">
          <rect id="Rectangle_20009" data-name="Rectangle 20009" width="24" height="24" transform="translate(-2168 4564)" fill="#959595" opacity="0"/>
          <g id="Group_45784" data-name="Group 45784" transform="translate(-2175.803 4560.935)">
            <g id="Group_18190" data-name="Group 18190" transform="translate(7.907 3.564)">
              <g id="Group_18185" data-name="Group 18185" transform="translate(0)">
                <g id="Group_14802" data-name="Group 14802" transform="translate(0)">
                  <g id="Group_14799" data-name="Group 14799">
                    <circle id="Ellipse_981" data-name="Ellipse 981" cx="3.031" cy="3.031" r="3.031" fill="#959595"/>
                    <circle id="Ellipse_984" data-name="Ellipse 984" cx="3.031" cy="3.031" r="3.031" transform="translate(0 8.469)" fill="#959595"/>
                    <circle id="Ellipse_987" data-name="Ellipse 987" cx="3.031" cy="3.031" r="3.031" transform="translate(0 16.938)" fill="#959595"/>
                  </g>
                  <g id="Group_14800" data-name="Group 14800" transform="translate(9.251)">
                    <circle id="Ellipse_982" data-name="Ellipse 982" cx="3.031" cy="3.031" r="3.031" fill="#959595"/>
                    <circle id="Ellipse_985" data-name="Ellipse 985" cx="3.031" cy="3.031" r="3.031" transform="translate(0 8.469)" fill="#959595"/>
                    <circle id="Ellipse_988" data-name="Ellipse 988" cx="3.031" cy="3.031" r="3.031" transform="translate(0 16.938)" fill="#959595"/>
                  </g>
                  <g id="Group_14801" data-name="Group 14801" transform="translate(17.731)">
                    <circle id="Ellipse_983" data-name="Ellipse 983" cx="3.031" cy="3.031" r="3.031" fill="#959595"/>
                    <circle id="Ellipse_986" data-name="Ellipse 986" cx="3.031" cy="3.031" r="3.031" transform="translate(0 8.469)" fill="#959595"/>
                    <circle id="Ellipse_989" data-name="Ellipse 989" cx="3.031" cy="3.031" r="3.031" transform="translate(0 16.938)" fill="#959595"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
    `,
  },
  "mobile-chat": {
    name: "mobile-chat",
    viewBox: "0 0 24 24",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_45782" data-name="Group 45782" transform="translate(2203 -4563)">
          <rect id="Rectangle_20008" data-name="Rectangle 20008" width="24" height="24" transform="translate(-2203 4563)" fill="#fff" opacity="0"/>
          <path id="Path_117161" data-name="Path 117161" d="M69.415,10A10.509,10.509,0,0,0,58.7,20.288a10.367,10.367,0,0,0,7.969,9.933L75.556,34l.029-5.312a10.152,10.152,0,0,0,4.543-8.4A10.505,10.505,0,0,0,69.415,10ZM66.6,21.995H63.772V19.147H66.6Zm4.507,0H68.294V19.154H71.11Zm4.507,0H72.8V19.147h2.814Z" transform="translate(-2260.414 4553)" fill="#959595"/>
        </g>
      `,
  },
  "mobile-sound-settings": {
    name: "mobile-sound-settings",
    viewBox: "0 0 34.337 34.337",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_12857" data-name="Group 12857" transform="translate(-209.031 -13.331)">
          <path id="Path_14470" class="icon-bg-2" data-name="Path 14470" d="M24.212,34.323a42.158,42.158,0,0,1-13.1,0,12.129,12.129,0,0,1-10.1-10.111,41.792,41.792,0,0,1,0-13.1,12.123,12.123,0,0,1,10.1-10.1,41.792,41.792,0,0,1,13.1,0,12.129,12.129,0,0,1,10.111,10.1,42.158,42.158,0,0,1,0,13.1A12.135,12.135,0,0,1,24.212,34.323Z" transform="translate(208.534 12.834)" fill="#5576d1"/>
          <g id="Group_12848" data-name="Group 12848" transform="translate(209.362 13.331)">
            <g id="speakers" transform="translate(7.337 7.669)">
              <g id="Group_12590" data-name="Group 12590">
                <path id="Path_12203" data-name="Path 12203" d="M10.613.817,3.879,5.755H.807A.812.812,0,0,0,0,6.563v7.2a.812.812,0,0,0,.807.809H3.933l6.684,4.934a.808.808,0,0,0,1.292-.607V1.466A.822.822,0,0,0,10.613.817ZM3.348,12.994H1.575V7.329H3.352v5.665Zm6.944,4.328L5,13.43V6.9L10.291,3Z" transform="translate(0 -0.668)" fill="#fff" stroke="#fff" stroke-width="0.3"/>
                <path id="Path_12204" data-name="Path 12204" d="M402.819,102.485a.8.8,0,1,0-1.168,1.094,6.248,6.248,0,0,1,0,8.428.821.821,0,0,0,.039,1.133.785.785,0,0,0,1.129-.082A7.815,7.815,0,0,0,402.819,102.485Z" transform="translate(-385.879 -98.297)" fill="#fff" stroke="#fff" stroke-width="0.3"/>
                <path id="Path_12205" data-name="Path 12205" d="M341.645,166.984a.816.816,0,0,0-1.129-.039.78.78,0,0,0,0,1.129,2.49,2.49,0,0,1,0,3.39.815.815,0,0,0,.039,1.129.789.789,0,0,0,1.09-.039A4.065,4.065,0,0,0,341.645,166.984Z" transform="translate(-327.081 -160.273)" fill="#fff" stroke="#fff" stroke-width="0.3"/>
              </g>
            </g>
          </g>
        </g>
      `,
  },
  "mobile-settings": {
    name: "mobile-settings",
    viewBox: "0 0 24 24",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_45787" data-name="Group 45787" transform="translate(2059 -4546)">
          <rect id="Rectangle_20011" data-name="Rectangle 20011" width="24" height="24" transform="translate(-2059 4546)" fill="#fff" opacity="0"/>
          <g id="setting-icon" transform="translate(-2059 4546.001)">
            <path id="Path_11919" data-name="Path 11919" d="M33.944,24.069,34,20.293l-2.476-.664a9.628,9.628,0,0,0-.967-2.429l1.349-2.177-2.63-2.713L27.057,13.59a9.951,9.951,0,0,0-2.4-1.036l-.583-2.5L20.288,10l-.661,2.478a9.746,9.746,0,0,0-2.429.962l-2.18-1.349L12.3,14.724l1.283,2.216a9.831,9.831,0,0,0-1.036,2.4l-2.5.583L10,23.709l2.478.659a9.8,9.8,0,0,0,.965,2.437l-1.352,2.177,2.635,2.711L16.945,30.4a9.712,9.712,0,0,0,2.4,1.038l.585,2.5L23.714,34l.659-2.481a9.368,9.368,0,0,0,2.432-.962l2.177,1.354L31.7,29.278l-1.288-2.221a9.791,9.791,0,0,0,1.038-2.4ZM21.9,28.7a6.7,6.7,0,1,1,6.8-6.6A6.706,6.706,0,0,1,21.9,28.7Z" transform="translate(-10 -10.001)" fill="#959595"/>
          </g>
        </g>
      `,
  },

  "dialer-backspace-icon": {
    name: "dialer-backspace-icon",
    viewBox: "0 0 51.975 30.128",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_8125" data-name="Rectangle 8125" width="51.975" height="30.128" fill="#707070"/>
          </clipPath>
        </defs>
        <g id="Group_13078" data-name="Group 13078" clip-path="url(#clip-path)">
          <path id="Path_29939" data-name="Path 29939" d="M32.789,30.118c-5.719,0-11.439-.009-17.158.011a2.531,2.531,0,0,1-1.947-.808Q7.24,22.829.757,16.377c-1.012-1.012-1.01-1.618.01-2.638Q7.258,7.248,13.742.75A2.394,2.394,0,0,1,15.578,0Q32.837.019,50.1.01c1.423,0,1.878.454,1.879,1.876q0,13.184,0,26.368c0,1.409-.462,1.862-1.893,1.863q-8.646,0-17.292,0m16.393-2.76V2.791c-.178-.009-.309-.021-.44-.021q-16.32,0-32.639.017a1.441,1.441,0,0,0-.9.413Q9.467,8.888,3.768,14.61c-.138.138-.261.288-.418.462.19.2.35.379.52.549Q9.486,21.237,15.1,26.859a1.56,1.56,0,0,0,1.217.51q16.053-.022,32.106-.011Z" transform="translate(0 -0.001)" fill="#707070"/>
          <path id="Path_29940" data-name="Path 29940" d="M144.883,54.919c-1.482,1.49-2.872,2.9-4.282,4.289a2.187,2.187,0,0,1-.874.571,1.255,1.255,0,0,1-1.488-.612,1.349,1.349,0,0,1,.257-1.706q1.921-1.949,3.869-3.872c.173-.172.378-.312.612-.5-.215-.236-.354-.4-.5-.551-1.289-1.292-2.583-2.578-3.868-3.874a1.382,1.382,0,1,1,1.938-1.925c1.432,1.425,2.855,2.861,4.333,4.343l3.52-3.525c.315-.315.621-.638.947-.94a1.374,1.374,0,0,1,1.972-.036,1.358,1.358,0,0,1-.052,1.971c-1.355,1.383-2.733,2.743-4.1,4.113-.093.094-.181.193-.313.334.152.166.29.33.441.481,1.289,1.292,2.583,2.578,3.868,3.874a1.382,1.382,0,1,1-1.943,1.921c-1.431-1.427-2.852-2.863-4.333-4.353" transform="translate(-113.422 -37.943)" fill="#707070"/>
        </g>
      `,
  },

  "mobile-addressBook-icon": {
    name: "mobile-addressBook-icon",
    viewBox: "0 0 63 63",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <defs>
          <filter id="Path_29971" x="0" y="0" width="63" height="63" filterUnits="userSpaceOnUse">
            <feOffset dy="1" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3.5" result="blur"/>
            <feFlood flood-color="#5576d1" flood-opacity="0.2"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <clipPath id="clip-path">
            <rect id="Rectangle_8113" data-name="Rectangle 8113" width="28.147" height="20" fill="#5576d1" stroke="#fff" stroke-width="0.35"/>
          </clipPath>
        </defs>
        <g id="Group_13094" data-name="Group 13094" transform="translate(10.5 9.5)">
          <g transform="matrix(1, 0, 0, 1, -10.5, -9.5)" filter="url(#Path_29971)">
            <path id="Path_29971-2" data-name="Path 29971" d="M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z" transform="translate(10.5 9.5)" fill="#fff"/>
          </g>
          <g id="Group_13023" data-name="Group 13023" transform="translate(6.854 11.081)">
            <g id="Group_13022" data-name="Group 13022" clip-path="url(#clip-path)">
              <path id="Path_29931" data-name="Path 29931" d="M28.147,19.563A.757.757,0,0,1,27.37,20Q14.08,19.992.79,20C.2,20,0,19.8,0,19.206Q0,11.29,0,3.374c0-.568.189-.758.757-.761.492,0,.984,0,1.5,0,0-.408.006-.782,0-1.156A.665.665,0,0,1,2.726.764,10.928,10.928,0,0,1,9.863.45a13.1,13.1,0,0,1,4.005,1.883.3.3,0,0,0,.4.009A12.932,12.932,0,0,1,20.267.069,10.429,10.429,0,0,1,25.36.741c.436.175.528.316.529.788,0,.347,0,.695,0,1.084h1.133c.165,0,.33.007.495,0a.692.692,0,0,1,.631.4Zm-3.45-2.87c.007-.084.016-.146.016-.209q0-7.256,0-14.512c0-.159-.031-.263-.2-.3a19.692,19.692,0,0,0-2.335-.458,11.277,11.277,0,0,0-7.294,2.112.469.469,0,0,0-.225.449q.008,7.078,0,14.155v.33A12.157,12.157,0,0,1,24.7,16.693M13.468,18.256c.007-.08.014-.116.014-.152q0-7.212-.007-14.423a.467.467,0,0,0-.186-.32,11.78,11.78,0,0,0-2.782-1.47,10.2,10.2,0,0,0-6.78-.251.352.352,0,0,0-.3.4Q3.44,9.221,3.434,16.4c0,.095.009.19.014.289a12.143,12.143,0,0,1,10.02,1.561M1.186,3.793v15H11.991a1.631,1.631,0,0,0-.135-.092,10.319,10.319,0,0,0-8.725-.624.593.593,0,0,1-.872-.6c0-.082,0-.165,0-.247V3.793Zm24.7,0v.353q0,6.568,0,13.135c0,.092,0,.184,0,.275a.585.585,0,0,1-.814.54c-.207-.072-.408-.163-.617-.231a10.243,10.243,0,0,0-7.389.471c-.3.125-.582.273-.872.411l.021.054H26.959V3.792Z" transform="translate(-0.001 0)" fill="#5576d1" stroke="#fff" stroke-width="0.35"/>
            </g>
          </g>
        </g>
      `,
  },

  "mobile-speedDial-icon": {
    name: "mobile-speedDial-icon",
    viewBox: "0 0 63 63",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <defs>
          <filter id="Ellipse_5233" x="0" y="0" width="63" height="63" filterUnits="userSpaceOnUse">
            <feOffset dy="1" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3.5" result="blur"/>
            <feFlood flood-color="#5576d1" flood-opacity="0.2"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
        </defs>
        <g id="Group_13096" data-name="Group 13096" transform="translate(-10242.5 -901.5)">
          <g transform="matrix(1, 0, 0, 1, 10242.5, 901.5)" filter="url(#Ellipse_5233)">
            <circle id="Ellipse_5233-2" data-name="Ellipse 5233" cx="21" cy="21" r="21" transform="translate(10.5 9.5)" fill="#fff"/>
          </g>
          <g id="Group_13095" data-name="Group 13095" transform="translate(-4.576 -1.461)">
            <path id="Path_29964" data-name="Path 29964" d="M472.512,2639.9H479.5c.107,0,.2.192.2.425s-.089.425-.2.425h-6.986c-.107,0-.2-.192-.2-.425s.089-.425.2-.425" transform="translate(9797.012 -1698.976)" fill="#5576d1" fill-rule="evenodd"/>
            <path id="Path_29965" data-name="Path 29965" d="M472.536,2639.9h7.845c.121,0,.221.192.221.425s-.1.425-.221.425h-7.845c-.121,0-.22-.192-.22-.425s.1-.425.22-.425" transform="translate(9793.588 -1701.491)" fill="#5576d1" fill-rule="evenodd"/>
            <path id="Path_29966" data-name="Path 29966" d="M472.567,2639.9h8.938c.137,0,.251.192.251.425s-.114.425-.251.425h-8.938c-.138,0-.251-.192-.251-.425s.114-.425.251-.425" transform="translate(9791.176 -1703.804)" fill="#5576d1" fill-rule="evenodd"/>
            <g id="Group_13083" data-name="Group 13083" transform="translate(10279.442 925.146)">
              <g id="Group_13082" data-name="Group 13082">
                <path id="Path_29942" data-name="Path 29942" d="M1292.006,923.027h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1290.42 -920.681)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29943" data-name="Path 29943" d="M1292.006,1262.524h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1290.42 -1256.563)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29944" data-name="Path 29944" d="M1292.006,1602.021h-.826a.76.76,0,0,1-.76-.76v-.826a.761.761,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1290.42 -1592.447)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29945" data-name="Path 29945" d="M1614.534,923.027h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1609.515 -920.681)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29946" data-name="Path 29946" d="M1614.534,1262.524h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1609.515 -1256.563)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29947" data-name="Path 29947" d="M1614.534,1602.021h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1609.515 -1592.447)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29948" data-name="Path 29948" d="M1614.534,1948.85h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1609.515 -1935.585)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29949" data-name="Path 29949" d="M1937.061,923.028h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1928.608 -920.682)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29950" data-name="Path 29950" d="M1937.061,1262.525h-.826a.761.761,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1928.608 -1256.564)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
                <path id="Path_29951" data-name="Path 29951" d="M1937.061,1602.021h-.826a.76.76,0,0,1-.76-.76v-.826a.76.76,0,0,1,.76-.76h.826a.76.76,0,0,1,.76.76v.826a.76.76,0,0,1-.76.76" transform="translate(-1928.608 -1592.447)" fill="none" stroke="#5576d1" stroke-width="0.45"/>
              </g>
            </g>
            <path id="Icon_feather-phone" data-name="Icon feather-phone" d="M10.934,8.2V9.852a1.1,1.1,0,0,1-1.2,1.1A10.88,10.88,0,0,1,4.991,9.264a10.721,10.721,0,0,1-3.3-3.3A10.88,10.88,0,0,1,0,1.2,1.1,1.1,0,0,1,1.1,0H2.748a1.1,1.1,0,0,1,1.1.946,7.059,7.059,0,0,0,.385,1.545,1.1,1.1,0,0,1-.247,1.16l-.7.7a8.8,8.8,0,0,0,3.3,3.3l.7-.7A1.1,1.1,0,0,1,8.444,6.7a7.059,7.059,0,0,0,1.545.385A1.1,1.1,0,0,1,10.934,8.2Z" transform="matrix(0.974, 0.225, -0.225, 0.974, 10272.611, 927.75)" fill="none" stroke="#5576d1" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.65"/>
          </g>
        </g>
      `,
  },

  "mobile-usersContacts-icon": {
    name: "mobile-usersContacts-icon",
    viewBox: "0 0 63 63",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <defs>
          <filter id="Ellipse_5234" x="0" y="0" width="63" height="63" filterUnits="userSpaceOnUse">
            <feOffset dy="1" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3.5" result="blur"/>
            <feFlood flood-color="#5576d1" flood-opacity="0.2"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <clipPath id="clip-path">
            <rect id="Rectangle_8129" data-name="Rectangle 8129" width="16.545" height="19.547" fill="#5576d1" stroke="#fff" stroke-width="0.5"/>
          </clipPath>
        </defs>
        <g id="Group_13092" data-name="Group 13092" transform="translate(10.449 9.5)">
          <g transform="matrix(1, 0, 0, 1, -10.45, -9.5)" filter="url(#Ellipse_5234)">
            <circle id="Ellipse_5234-2" data-name="Ellipse 5234" cx="21" cy="21" r="21" transform="translate(10.5 9.5)" fill="#fff"/>
          </g>
          <g id="Group_13088" data-name="Group 13088" transform="translate(12.728 10.226)">
            <g id="Group_13087" data-name="Group 13087" clip-path="url(#clip-path)">
              <path id="Path_29962" data-name="Path 29962" d="M8.652,0c.317.062.641.1.95.191a4.843,4.843,0,0,1,3.48,3.471,4.847,4.847,0,0,1-1,4.592,6.293,6.293,0,0,1-.568.563c-.086.082-.183.153-.287.238.292.137.567.25.827.391A8.176,8.176,0,0,1,16.4,15.3a5.369,5.369,0,0,1,.085,2.027,2.749,2.749,0,0,1-2.573,2.215c-.273.01-.547.005-.82.005q-5.133,0-10.267,0A2.767,2.767,0,0,1,.147,17.676,3.7,3.7,0,0,1,.033,16.09a8.068,8.068,0,0,1,1.021-3.325A8.223,8.223,0,0,1,4.949,9.223l.314-.138A.261.261,0,0,0,5.3,9.05c-.066-.056-.127-.109-.189-.161a4.984,4.984,0,0,1-.721-7.044A4.894,4.894,0,0,1,7.7.035C7.766.027,7.827.011,7.888,0ZM8.269,18.045c1.781,0,3.562-.013,5.343.005A1.294,1.294,0,0,0,15.025,16.6a12.016,12.016,0,0,0-.2-1.431,6.571,6.571,0,0,0-2.536-3.806A6.556,6.556,0,0,0,9.241,10.1a6.757,6.757,0,0,0-6.876,3.4,6.588,6.588,0,0,0-.853,3.321,1.179,1.179,0,0,0,.267.739,1.316,1.316,0,0,0,1.11.484q2.691,0,5.381,0M8.293,1.5a3.507,3.507,0,1,0,3.485,3.551A3.522,3.522,0,0,0,8.293,1.5" transform="translate(0 0.001)" fill="#5576d1" stroke="#fff" stroke-width="0.5"/>
            </g>
          </g>
        </g>
      `,
  },

  "mobile-teamsContacts-icon": {
    name: "mobile-teamsContacts-icon",
    viewBox: "0 0 63 63",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <defs>
          <filter id="Ellipse_5235" x="0" y="0" width="63" height="63" filterUnits="userSpaceOnUse">
            <feOffset dy="1" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3.5" result="blur"/>
            <feFlood flood-color="#5576d1" flood-opacity="0.2"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter>
          <clipPath id="clip-path">
            <rect id="Rectangle_8130" data-name="Rectangle 8130" width="27.613" height="17.547" fill="#5576d1"/>
          </clipPath>
        </defs>
        <g id="Group_13091" data-name="Group 13091" transform="translate(10.5 9.5)">
          <g transform="matrix(1, 0, 0, 1, -10.5, -9.5)" filter="url(#Ellipse_5235)">
            <circle id="Ellipse_5235-2" data-name="Ellipse 5235" cx="21" cy="21" r="21" transform="translate(10.5 9.5)" fill="#fff"/>
          </g>
          <g id="Group_13090" data-name="Group 13090" transform="translate(7.194 12.226)">
            <g id="Group_13089" data-name="Group 13089" clip-path="url(#clip-path)">
              <path id="Path_29963" data-name="Path 29963" d="M27.613,13.352c-.314,0-.628-.013-.942-.013q-2.724,0-5.448,0h-.344a7.633,7.633,0,0,1,.037.842,6,6,0,0,1-.155,1.354,2.807,2.807,0,0,1-2.774,2c-2.8.019-5.61.025-8.414,0A2.883,2.883,0,0,1,6.632,14.5c0-.376,0-.751,0-1.161H.029A5.528,5.528,0,0,1,3.7,7.716,3.153,3.153,0,0,1,2.39,4.862a3.026,3.026,0,0,1,1.1-2.123,3.151,3.151,0,0,1,4.3.205,3.051,3.051,0,0,1,.875,2.486A3.1,3.1,0,0,1,7.4,7.677l1.836,1.07A7.4,7.4,0,0,1,11.7,7.42,3.992,3.992,0,0,1,9.787,3.959a3.836,3.836,0,0,1,1.281-2.9,3.99,3.99,0,0,1,5.752.346,4.032,4.032,0,0,1-.967,6.011,7.264,7.264,0,0,1,2.487,1.346l1.854-1.092a3.114,3.114,0,0,1-1.258-2.83,3.044,3.044,0,0,1,1.085-2.1,3.159,3.159,0,1,1,3.9,4.963c.3.15.616.278.9.448a5.469,5.469,0,0,1,2.742,4.134.892.892,0,0,0,.048.149ZM13.749,16.657c.368,0,.737,0,1.105,0,1.114,0,2.229.015,3.343-.022a1.965,1.965,0,0,0,1.812-1.764A6.269,6.269,0,0,0,11.564,8.4a6.119,6.119,0,0,0-4,5.064,5.033,5.033,0,0,0,.011,1.633,1.971,1.971,0,0,0,2.075,1.562c1.366.006,2.732,0,4.1,0m.01-9.555a3.112,3.112,0,1,0-3.116-3.1,3.107,3.107,0,0,0,3.116,3.1m5.274,2.3A7.745,7.745,0,0,1,20.6,12.194a.3.3,0,0,0,.352.261c1.824-.009,3.648-.005,5.473-.005h.29a4.624,4.624,0,0,0-3-3.85,4.556,4.556,0,0,0-4.686.8M8.51,9.369A4.559,4.559,0,0,0,3.5,8.753,4.575,4.575,0,0,0,.871,12.426c.1.01.163.022.224.022,1.851,0,3.7,0,5.552.005.175,0,.211-.081.272-.22.272-.622.542-1.247.862-1.845a9.317,9.317,0,0,1,.73-1.019M24.335,5.245A2.272,2.272,0,1,0,22,7.4a2.261,2.261,0,0,0,2.334-2.154M7.773,5.009A2.269,2.269,0,1,0,5.6,7.4,2.258,2.258,0,0,0,7.773,5.009" transform="translate(0 0)" fill="#5576d1"/>
            </g>
          </g>
        </g>
      `,
  },

  "mobile-pickup-icon": {
    name: "mobile-pickup-icon",
    viewBox: "0 0 72 72.013",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_13552" data-name="Group 13552" transform="translate(-34.784 -545.649)">
          <path id="Path_12061" data-name="Path 12061" d="M127.636,358.444a88.431,88.431,0,0,1-27.474,0,25.44,25.44,0,0,1-21.183-21.2,88.423,88.423,0,0,1,0-27.474,25.453,25.453,0,0,1,21.183-21.2,88.425,88.425,0,0,1,27.474,0,25.453,25.453,0,0,1,21.2,21.2,88.424,88.424,0,0,1,0,27.474,25.44,25.44,0,0,1-21.2,21.2Z" transform="translate(-43.121 258.144)" fill="#4cd964"/>
          <g id="Call-icon" transform="translate(55.534 566.349)">
            <rect id="Rectangle_2952" data-name="Rectangle 2952" width="30.488" height="30.488" transform="translate(0)" fill="rgba(243,243,243,0)"/>
            <path id="phone" d="M124.867,326.813V331.4a3.064,3.064,0,0,1-3.051,3.077h-.3a30.3,30.3,0,0,1-13.2-4.7,29.785,29.785,0,0,1-9.179-9.179,30.287,30.287,0,0,1-4.7-13.26,3.064,3.064,0,0,1,2.763-3.327h4.872a3.064,3.064,0,0,1,3.051,2.637,19.576,19.576,0,0,0,1.08,4.294,3.064,3.064,0,0,1-.691,3.227l-1.946,1.946a24.4,24.4,0,0,0,9.179,9.179l1.946-1.946a3.064,3.064,0,0,1,3.227-.678,20.092,20.092,0,0,0,4.294,1.067,3.051,3.051,0,0,1,2.637,3.1Z" transform="translate(-94.43 -303.985)" fill="#f3f3f3"/>
          </g>
        </g>
    `,
  },
  "mobile-hangup-icon": {
    name: "mobile-hangup-icon",
    viewBox: "0 0 72 72",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_13551" data-name="Group 13551" transform="translate(-145 -622)">
          <g id="Group_12070" data-name="Group 12070" transform="translate(144.608 621.637)">
            <rect id="base" width="72" height="72" rx="26" transform="translate(0.392 0.363)" fill="#ed0808"/>
          </g>
          <path id="Icon_material-call" data-name="Icon material-call" d="M5.347,11.506a22.375,22.375,0,0,0,9.734,9.734L18.33,17.99a1.469,1.469,0,0,1,1.507-.354,16.849,16.849,0,0,0,5.273.842,1.481,1.481,0,0,1,1.477,1.477V25.11a1.481,1.481,0,0,1-1.477,1.477A25.107,25.107,0,0,1,0,1.477,1.481,1.481,0,0,1,1.477,0h5.17A1.481,1.481,0,0,1,8.124,1.477,16.78,16.78,0,0,0,8.966,6.75,1.482,1.482,0,0,1,8.6,8.257L5.347,11.506Z" transform="translate(199.3 660.188) rotate(135)" fill="#fff"/>
        </g>
    `,
  },
  "mobile-duringCall-phone-icon": {
    name: "mobile-duringCall-phone-icon",
    viewBox: "0 0 14.784 14.784",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <path id="Icon_material-call" data-name="Icon material-call" d="M2.973,6.4a12.442,12.442,0,0,0,5.413,5.413L10.193,10a.817.817,0,0,1,.838-.2,9.369,9.369,0,0,0,2.932.468.824.824,0,0,1,.821.821v2.866a.824.824,0,0,1-.821.821A13.961,13.961,0,0,1,0,.821.824.824,0,0,1,.821,0H3.7a.824.824,0,0,1,.821.821,9.331,9.331,0,0,0,.468,2.932.824.824,0,0,1-.205.838L2.973,6.4Z" fill="#22db3a"/>
    `,
  },
  "mobile-duringCall-switchCall-icon": {
    name: "mobile-duringCall-phone-icon",
    viewBox: "0 0 19.461 19.492",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
          <defs>
            <clipPath id="clip-path">
              <rect id="Rectangle_8308" data-name="Rectangle 8308" width="19.461" height="19.492" fill="#c0c5ca"/>
            </clipPath>
          </defs>
          <g id="Group_13543" data-name="Group 13543" transform="translate(-315.897 -45.254)">
            <path id="Icon_material-call" data-name="Icon material-call" d="M1.632,3.511A6.828,6.828,0,0,0,4.6,6.482l.992-.992a.448.448,0,0,1,.46-.108,5.142,5.142,0,0,0,1.609.257.452.452,0,0,1,.451.451V7.663a.452.452,0,0,1-.451.451A7.662,7.662,0,0,1,0,.451.452.452,0,0,1,.451,0H2.028a.452.452,0,0,1,.451.451A5.121,5.121,0,0,0,2.736,2.06a.452.452,0,0,1-.113.46l-.992.992Z" transform="translate(321.571 50.943)" fill="#c0c5ca"/>
            <g id="Group_13542" data-name="Group 13542" transform="translate(315.897 45.254)">
              <g id="Group_13541" data-name="Group 13541" clip-path="url(#clip-path)">
                <path id="Path_30057" data-name="Path 30057" d="M0,9.153C.049,8.8.079,8.437.15,8.086A9.377,9.377,0,0,1,6.332.67a9.412,9.412,0,0,1,9.992,1.937c.081.071.161.142.243.213.007.006.022,0,0,0,0-.392,0-.788,0-1.183a.568.568,0,0,1,1.135-.052q.071,1.309.122,2.619a.543.543,0,0,1-.54.59c-.657.043-1.316.068-1.974.1-.2.01-.4.024-.607.03a.583.583,0,0,1-.635-.564.576.576,0,0,1,.584-.574c.382-.022.764-.041,1.147-.062l.033-.067c-.457-.355-.895-.739-1.374-1.06a8.407,8.407,0,0,0-5.069-1.42,8.585,8.585,0,0,0-8,10.652.966.966,0,0,1,.033.354.549.549,0,0,1-.522.468.541.541,0,0,1-.586-.437c-.109-.538-.19-1.083-.283-1.624L0,10.37V9.153" transform="translate(0 0)" fill="#c0c5ca"/>
                <path id="Path_30058" data-name="Path 30058" d="M39.723,147.9c-.362-.049-.727-.087-1.087-.148a9.516,9.516,0,0,1-4.621-2.155c-.193-.163-.381-.333-.593-.519a1.355,1.355,0,0,0-.013.154c.014.348.034.7.043,1.044a.568.568,0,1,1-1.135.049q-.069-1.29-.12-2.581a.545.545,0,0,1,.542-.607q1.309-.078,2.619-.13a.568.568,0,1,1,.029,1.136c-.385.023-.771.041-1.178.063a.479.479,0,0,0,.054.085,8.593,8.593,0,0,0,14.373-8.175,1.028,1.028,0,0,1-.037-.373.567.567,0,0,1,1.115-.008,13.812,13.812,0,0,1,.263,1.493,9.736,9.736,0,0,1-8.569,10.6l-.543.069Z" transform="translate(-30.561 -128.407)" fill="#c0c5ca"/>
              </g>
            </g>
          </g>
    `,
  },

  "mobile-duringCall-notes-icon": {
    name: "mobile-duringCall-notes-icon",
    viewBox: "0 0 72 71",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
          <g id="Group_14323" data-name="Group 14323" transform="translate(-43.902 -420.55)">
            <path id="Path_39393" data-name="Path 39393" d="M70.452,420.55h20a26,26,0,0,1,26,26v19a26,26,0,0,1-26,26h-20a26,26,0,0,1-26-26v-19a26,26,0,0,1,26-26" transform="translate(-0.55)" fill="#e9f2ff"/>
            <path id="Path_39394" data-name="Path 39394" d="M74.9,475.84h-.91l-3.66-5.55v5.55h-.91v-6.98h.91l3.66,5.54v-5.54h.91Z" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39395" data-name="Path 39395" d="M77.442,475.581a2.5,2.5,0,0,1-.98-.995,3.05,3.05,0,0,1-.355-1.5,2.971,2.971,0,0,1,.365-1.485,2.5,2.5,0,0,1,1-.989,3.046,3.046,0,0,1,2.82,0,2.517,2.517,0,0,1,1,.984,2.961,2.961,0,0,1,.365,1.49,2.923,2.923,0,0,1-.375,1.5,2.615,2.615,0,0,1-1.015,1,2.914,2.914,0,0,1-1.42.349,2.808,2.808,0,0,1-1.395-.349m2.315-.681a1.749,1.749,0,0,0,.695-.689,2.209,2.209,0,0,0,.265-1.121,2.249,2.249,0,0,0-.26-1.12,1.7,1.7,0,0,0-.68-.684,1.955,1.955,0,0,0-1.825,0,1.639,1.639,0,0,0-.665.684,2.314,2.314,0,0,0-.25,1.12,2.369,2.369,0,0,0,.245,1.13,1.629,1.629,0,0,0,.655.686,1.847,1.847,0,0,0,.9.224,1.917,1.917,0,0,0,.92-.23" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39396" data-name="Path 39396" d="M83.956,471.11v3.23a.772.772,0,0,0,.17.566.842.842,0,0,0,.59.165h.67v.769h-.82a1.636,1.636,0,0,1-1.14-.349,1.506,1.506,0,0,1-.38-1.151v-3.23h-.71v-.75h.71v-1.38h.91v1.38h1.43v.75Z" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39397" data-name="Path 39397" d="M91.457,473.44h-4.38a1.722,1.722,0,0,0,1.78,1.72,1.681,1.681,0,0,0,.985-.275,1.461,1.461,0,0,0,.555-.735h.98a2.356,2.356,0,0,1-.88,1.285,2.657,2.657,0,0,1-1.64.5,2.763,2.763,0,0,1-1.4-.35,2.473,2.473,0,0,1-.965-1,3.075,3.075,0,0,1-.35-1.495,3.129,3.129,0,0,1,.34-1.49,2.372,2.372,0,0,1,.955-.984,2.831,2.831,0,0,1,1.415-.346,2.747,2.747,0,0,1,1.38.34,2.363,2.363,0,0,1,.925.935,2.757,2.757,0,0,1,.325,1.345,5.357,5.357,0,0,1-.03.55m-1.14-1.635a1.5,1.5,0,0,0-.625-.57,1.951,1.951,0,0,0-.875-.2,1.688,1.688,0,0,0-1.175.44,1.789,1.789,0,0,0-.555,1.221h3.46a1.684,1.684,0,0,0-.23-.9" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39398" data-name="Path 39398" d="M88.738,464.372H72.362a.669.669,0,0,0-.128-.05,4.264,4.264,0,0,1-3.679-4.277q-.012-10.23,0-20.459a4.263,4.263,0,0,1,4.208-4.317h.1c5.125-.012,10.25,0,15.376,0a4.006,4.006,0,0,1,1.788.39,4.23,4.23,0,0,1,2.523,4.068v20.147c0,.133,0,.265-.006.4a4.305,4.305,0,0,1-3.038,3.913c-.252.074-.51.125-.765.187m-8.191-8.128h5.515c.218,0,.436.007.654-.006a.982.982,0,0,0,.283-1.9,1.671,1.671,0,0,0-.525-.078H74.621a1.762,1.762,0,0,0-.422.045.926.926,0,0,0-.7.679.98.98,0,0,0,.661,1.217,1,1,0,0,0,.339.038c2.018.006,4.037,0,6.055,0m-.016-5.44h5.855a3.179,3.179,0,0,0,.425-.02.978.978,0,0,0,.81-1.116c-.1-.551-.492-.84-1.165-.84H74.638a2.259,2.259,0,0,0-.368.021.98.98,0,0,0-.794,1.128,1.006,1.006,0,0,0,1.12.825h5.941m.019-7.414c-1.193,0-2.387-.007-3.581,0a.976.976,0,0,0-.963.935.988.988,0,0,0,.813,1.014,1.838,1.838,0,0,0,.339.029h6.764a1.636,1.636,0,0,0,.555-.09.98.98,0,0,0-.374-1.886c-1.184-.008-2.368,0-3.552,0" transform="translate(-0.55)" fill="#061238"/>
            <rect id="Rectangle_8426" data-name="Rectangle 8426" width="23.999" height="29.11" transform="translate(67.999 435.262)" fill="none"/>
          </g>
    `,
  },
  "mobile-duringCall-pause-icon": {
    name: "mobile-duringCall-pause-icon",
    viewBox: "0 0 71 71",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_14324" data-name="Group 14324" transform="translate(-145.332 -420.55)">
          <path id="Path_39358" data-name="Path 39358" d="M171.882,420.55h19a26,26,0,0,1,26,26v19a26,26,0,0,1-26,26h-19a26,26,0,0,1-26-26v-19a26,26,0,0,1,26-26" transform="translate(-0.55)" fill="#e9f2ff"/>
          <g id="Group_14322" data-name="Group 14322">
            <rect id="Rectangle_8421" data-name="Rectangle 8421" width="3.509" height="18.611" transform="translate(182.012 440.512)" fill="#061238"/>
            <rect id="Rectangle_8422" data-name="Rectangle 8422" width="3.509" height="18.611" transform="translate(174.479 440.512)" fill="#061238"/>
          </g>
          <g id="Group_14319" data-name="Group 14319">
            <path id="Path_39359" data-name="Path 39359" d="M170.862,473.065a2.522,2.522,0,0,1-1.815.575h-1.34v2.91h-.91v-6.969h2.25a2.55,2.55,0,0,1,1.8.569,2.058,2.058,0,0,1,.02,2.915m-.7-.505a1.21,1.21,0,0,0,.36-.939q0-1.291-1.48-1.29h-1.34v2.559h1.34a1.614,1.614,0,0,0,1.12-.33" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39360" data-name="Path 39360" d="M172.587,472.315a2.473,2.473,0,0,1,.935-.985,2.571,2.571,0,0,1,1.325-.35,2.428,2.428,0,0,1,1.25.31,2.063,2.063,0,0,1,.79.78v-1h.92v5.48h-.92v-1.019a2.139,2.139,0,0,1-.8.794,2.41,2.41,0,0,1-1.245.315,2.491,2.491,0,0,1-1.32-.359,2.541,2.541,0,0,1-.93-1.011,3.153,3.153,0,0,1-.34-1.48,3.088,3.088,0,0,1,.34-1.475m4.05.4a1.772,1.772,0,0,0-.675-.7,1.914,1.914,0,0,0-1.865-.005,1.748,1.748,0,0,0-.67.7,2.237,2.237,0,0,0-.25,1.08,2.287,2.287,0,0,0,.25,1.1,1.769,1.769,0,0,0,.67.71,1.815,1.815,0,0,0,.93.245,1.841,1.841,0,0,0,.935-.245,1.76,1.76,0,0,0,.675-.71,2.254,2.254,0,0,0,.25-1.085,2.226,2.226,0,0,0-.25-1.08" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39361" data-name="Path 39361" d="M184.207,471.069v5.48h-.91v-.808a1.776,1.776,0,0,1-.725.654,2.236,2.236,0,0,1-1.025.235,2.453,2.453,0,0,1-1.15-.264,1.931,1.931,0,0,1-.805-.8,2.609,2.609,0,0,1-.295-1.288v-3.212h.9v3.091a1.745,1.745,0,0,0,.41,1.246,1.472,1.472,0,0,0,1.12.435,1.494,1.494,0,0,0,1.15-.452,1.844,1.844,0,0,0,.42-1.308v-3.012Z" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39362" data-name="Path 39362" d="M186.557,476.425a1.917,1.917,0,0,1-.79-.6,1.6,1.6,0,0,1-.32-.885h.94a.92.92,0,0,0,.385.67,1.468,1.468,0,0,0,.9.26,1.32,1.32,0,0,0,.82-.23.7.7,0,0,0,.3-.58.573.573,0,0,0-.32-.535,4.459,4.459,0,0,0-.99-.345,7.283,7.283,0,0,1-.995-.325,1.767,1.767,0,0,1-.66-.49,1.275,1.275,0,0,1-.275-.855,1.3,1.3,0,0,1,.25-.77,1.692,1.692,0,0,1,.71-.555,2.552,2.552,0,0,1,1.05-.2,2.241,2.241,0,0,1,1.47.46,1.659,1.659,0,0,1,.6,1.26h-.91a.941.941,0,0,0-.345-.69,1.527,1.527,0,0,0-1.625-.05.647.647,0,0,0-.29.55.6.6,0,0,0,.175.445,1.287,1.287,0,0,0,.44.28,7.643,7.643,0,0,0,.735.235,7.9,7.9,0,0,1,.96.315,1.69,1.69,0,0,1,.635.465,1.248,1.248,0,0,1,.275.81,1.392,1.392,0,0,1-.25.81,1.674,1.674,0,0,1-.7.565,2.53,2.53,0,0,1-1.045.2,2.822,2.822,0,0,1-1.13-.215" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39363" data-name="Path 39363" d="M195.937,474.15h-4.38a1.722,1.722,0,0,0,1.78,1.72,1.68,1.68,0,0,0,.985-.275,1.461,1.461,0,0,0,.555-.735h.98a2.356,2.356,0,0,1-.88,1.285,2.657,2.657,0,0,1-1.64.5,2.763,2.763,0,0,1-1.4-.35,2.473,2.473,0,0,1-.965-1,3.075,3.075,0,0,1-.35-1.5,3.129,3.129,0,0,1,.34-1.49,2.372,2.372,0,0,1,.955-.984,2.831,2.831,0,0,1,1.415-.346,2.747,2.747,0,0,1,1.38.34,2.363,2.363,0,0,1,.925.935,2.757,2.757,0,0,1,.325,1.345,5.354,5.354,0,0,1-.03.55m-1.14-1.635a1.5,1.5,0,0,0-.625-.57,1.951,1.951,0,0,0-.875-.2,1.688,1.688,0,0,0-1.175.44,1.789,1.789,0,0,0-.555,1.221h3.46a1.684,1.684,0,0,0-.23-.9" transform="translate(-0.55)" fill="#061238"/>
          </g>
        </g>
    `,
  },
  "mobile-duringCall-transfer-icon": {
    name: "mobile-duringCall-transfer-icon",
    viewBox: "0 0 72 71",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_14325" data-name="Group 14325" transform="translate(-244.684 -420.55)">
          <path id="Path_39369" data-name="Path 39369" d="M271.234,420.55h20a26,26,0,0,1,26,26v19a26,26,0,0,1-26,26h-20a26,26,0,0,1-26-26v-19a26,26,0,0,1,26-26" transform="translate(-0.55)" fill="#e9f2ff"/>
          <path id="Path_39370" data-name="Path 39370" d="M287.823,438.215v3.315H267.934v3.315h19.889v3.315l6.63-4.972Zm-13.259,13.259-6.63,4.973,6.63,4.968V458.1h19.889v-3.315H274.564Z" transform="translate(-0.55)" fill="#061238"/>
          <g id="Group_14320" data-name="Group 14320">
            <path id="Path_39371" data-name="Path 39371" d="M265.895,469.58v.739h-1.9v6.231h-.91v-6.231h-1.91v-.739Z" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39372" data-name="Path 39372" d="M268.61,471.23a2.118,2.118,0,0,1,1.085-.26v.941h-.24q-1.53,0-1.53,1.659v2.98h-.91v-5.48h.91v.89a1.749,1.749,0,0,1,.685-.73" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39373" data-name="Path 39373" d="M270.744,472.315a2.474,2.474,0,0,1,.935-.985,2.57,2.57,0,0,1,1.325-.35,2.428,2.428,0,0,1,1.25.31,2.063,2.063,0,0,1,.79.78v-1h.92v5.48h-.92v-1.019a2.139,2.139,0,0,1-.8.794,2.41,2.41,0,0,1-1.245.315,2.491,2.491,0,0,1-1.32-.359,2.541,2.541,0,0,1-.93-1.011,3.154,3.154,0,0,1-.34-1.48,3.088,3.088,0,0,1,.34-1.475m4.05.4a1.772,1.772,0,0,0-.675-.7,1.914,1.914,0,0,0-1.865-.005,1.748,1.748,0,0,0-.67.7,2.237,2.237,0,0,0-.25,1.08,2.287,2.287,0,0,0,.25,1.1,1.769,1.769,0,0,0,.67.71,1.815,1.815,0,0,0,.93.245,1.84,1.84,0,0,0,.935-.245,1.76,1.76,0,0,0,.675-.71,2.254,2.254,0,0,0,.25-1.085,2.226,2.226,0,0,0-.25-1.08" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39374" data-name="Path 39374" d="M281.794,471.575a2.327,2.327,0,0,1,.62,1.744v3.231h-.9v-3.1a1.766,1.766,0,0,0-.41-1.256,1.468,1.468,0,0,0-1.12-.434,1.5,1.5,0,0,0-1.145.45,1.838,1.838,0,0,0-.425,1.309v3.031h-.91v-5.481h.91v.78a1.8,1.8,0,0,1,.735-.649,2.282,2.282,0,0,1,1.025-.23,2.224,2.224,0,0,1,1.62.605" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39375" data-name="Path 39375" d="M284.715,476.425a1.917,1.917,0,0,1-.79-.6,1.6,1.6,0,0,1-.32-.885h.94a.92.92,0,0,0,.385.67,1.468,1.468,0,0,0,.9.26,1.32,1.32,0,0,0,.82-.23.7.7,0,0,0,.3-.58.573.573,0,0,0-.32-.535,4.459,4.459,0,0,0-.99-.345,7.28,7.28,0,0,1-.995-.325,1.767,1.767,0,0,1-.66-.49,1.275,1.275,0,0,1-.275-.855,1.3,1.3,0,0,1,.25-.77,1.692,1.692,0,0,1,.71-.555,2.552,2.552,0,0,1,1.05-.2,2.241,2.241,0,0,1,1.47.46,1.659,1.659,0,0,1,.6,1.26h-.91a.941.941,0,0,0-.345-.69,1.527,1.527,0,0,0-1.625-.05.647.647,0,0,0-.29.55.6.6,0,0,0,.175.445,1.287,1.287,0,0,0,.44.28,7.653,7.653,0,0,0,.735.235,7.909,7.909,0,0,1,.96.315,1.69,1.69,0,0,1,.635.465,1.248,1.248,0,0,1,.275.81,1.392,1.392,0,0,1-.25.81,1.674,1.674,0,0,1-.7.565,2.53,2.53,0,0,1-1.045.2,2.822,2.822,0,0,1-1.13-.215" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39376" data-name="Path 39376" d="M291.354,471.819H290.2v4.73h-.91v-4.73h-.71v-.75h.71v-.389a1.713,1.713,0,0,1,.475-1.344,2.248,2.248,0,0,1,1.525-.426v.761a1.206,1.206,0,0,0-.845.235,1.033,1.033,0,0,0-.245.774v.389h1.15Z" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39377" data-name="Path 39377" d="M297.384,474.15H293a1.722,1.722,0,0,0,1.78,1.72,1.68,1.68,0,0,0,.985-.275,1.461,1.461,0,0,0,.555-.735h.98a2.356,2.356,0,0,1-.88,1.285,2.657,2.657,0,0,1-1.64.5,2.763,2.763,0,0,1-1.395-.35,2.473,2.473,0,0,1-.965-.995,3.075,3.075,0,0,1-.35-1.5,3.129,3.129,0,0,1,.34-1.49,2.373,2.373,0,0,1,.955-.984,2.831,2.831,0,0,1,1.415-.346,2.747,2.747,0,0,1,1.38.34,2.363,2.363,0,0,1,.925.935,2.756,2.756,0,0,1,.325,1.345,5.366,5.366,0,0,1-.03.55m-1.14-1.635a1.5,1.5,0,0,0-.625-.57,1.951,1.951,0,0,0-.875-.2,1.688,1.688,0,0,0-1.175.44,1.789,1.789,0,0,0-.555,1.221h3.46a1.684,1.684,0,0,0-.23-.9" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39378" data-name="Path 39378" d="M300.209,471.23a2.118,2.118,0,0,1,1.085-.26v.941h-.24q-1.53,0-1.53,1.659v2.98h-.91v-5.48h.91v.89a1.749,1.749,0,0,1,.685-.73" transform="translate(-0.55)" fill="#061238"/>
          </g>
        </g>
    `,
  },
  "mobile-duringCall-cancelTransfer-icon": {
    name: "mobile-duringCall-cancelTransfer-icon",
    viewBox: "0 0 72 71",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_13692" data-name="Group 13692" transform="translate(-480 -7517)">
          <g id="Group_12077" data-name="Group 12077" transform="translate(479.751 7516.579)">
            <rect id="base" width="72" height="71" rx="26" transform="translate(0.249 0.421)" fill="#e9f2ff"/>
          </g>
          <text id="Cancel" transform="translate(497.195 7573)" fill="#061238" font-size="10" font-family="Poppins-Regular, Poppins"><tspan x="0" y="0">Cancel</tspan></text>
          <g id="Group_13691" data-name="Group 13691" transform="translate(-64.643 4)">
            <path id="Subtraction_2" data-name="Subtraction 2" d="M6.629,28.011h0L0,23.038l6.629-4.972v3.316H9.6L8.329,24.7h-1.7v3.315ZM26.519,24.7H12.077l1.272-3.315h13.17ZM19.89,14.755V11.436H17.168L18.44,8.122h1.449V4.807l6.629,4.972L19.891,14.75ZM13.419,11.44H0V8.122H14.691l-1.272,3.314Z" transform="translate(567.384 7525.858)" fill="#061238"/>
            <rect id="Rectangle_8328" data-name="Rectangle 8328" width="2.5" height="34" transform="matrix(0.934, 0.358, -0.358, 0.934, 586.335, 7525.86)" fill="#061238"/>
          </g>
        </g>
    `,
  },
  "mobile-duringCall-tags-icon": {
    name: "mobile-duringCall-tags-icon",
    viewBox: "0 0 72 72",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_14326" data-name="Group 14326" transform="translate(-44.127 -518.55)">
          <path id="Path_39387" data-name="Path 39387" d="M70.677,518.55h20a26,26,0,0,1,26,26v20a26,26,0,0,1-26,26h-20a26,26,0,0,1-26-26v-20a26,26,0,0,1,26-26" transform="translate(-0.55)" fill="#e9f2ff"/>
          <g id="Group_14317" data-name="Group 14317">
            <path id="Path_39388" data-name="Path 39388" d="M73.747,569.58v.739h-1.9v6.231h-.91v-6.231h-1.91v-.739Z" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39389" data-name="Path 39389" d="M74.867,572.315a2.474,2.474,0,0,1,.935-.985,2.57,2.57,0,0,1,1.325-.35,2.428,2.428,0,0,1,1.25.31,2.063,2.063,0,0,1,.79.78v-1h.92v5.48h-.92v-1.019a2.139,2.139,0,0,1-.8.794,2.411,2.411,0,0,1-1.245.315,2.491,2.491,0,0,1-1.32-.359,2.541,2.541,0,0,1-.93-1.011,3.154,3.154,0,0,1-.34-1.48,3.088,3.088,0,0,1,.34-1.475m4.05.4a1.772,1.772,0,0,0-.675-.7,1.914,1.914,0,0,0-1.865-.005,1.748,1.748,0,0,0-.67.7,2.237,2.237,0,0,0-.25,1.08,2.287,2.287,0,0,0,.25,1.1,1.767,1.767,0,0,0,.67.71,1.815,1.815,0,0,0,.93.245,1.841,1.841,0,0,0,.935-.245,1.761,1.761,0,0,0,.675-.71,2.254,2.254,0,0,0,.25-1.085,2.226,2.226,0,0,0-.25-1.08" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39390" data-name="Path 39390" d="M85.132,571.29a2.049,2.049,0,0,1,.8.78v-1h.92v5.6a2.737,2.737,0,0,1-.32,1.335,2.276,2.276,0,0,1-.915.915,2.806,2.806,0,0,1-1.385.33,3.044,3.044,0,0,1-1.8-.509,2,2,0,0,1-.85-1.391h.9a1.442,1.442,0,0,0,.62.806,2.032,2.032,0,0,0,1.13.3,1.673,1.673,0,0,0,1.225-.469,1.776,1.776,0,0,0,.475-1.321v-1.15a2.19,2.19,0,0,1-.8.8,2.353,2.353,0,0,1-1.24.32,2.488,2.488,0,0,1-2.26-1.37,3.154,3.154,0,0,1-.34-1.48,3.088,3.088,0,0,1,.34-1.475,2.474,2.474,0,0,1,.935-.985,2.57,2.57,0,0,1,1.325-.35,2.432,2.432,0,0,1,1.245.31m.545,1.43a1.772,1.772,0,0,0-.675-.7,1.914,1.914,0,0,0-1.865-.005,1.747,1.747,0,0,0-.67.7,2.237,2.237,0,0,0-.25,1.08,2.287,2.287,0,0,0,.25,1.1,1.768,1.768,0,0,0,.67.71,1.815,1.815,0,0,0,.93.245A1.84,1.84,0,0,0,85,575.6a1.761,1.761,0,0,0,.675-.71,2.254,2.254,0,0,0,.25-1.085,2.226,2.226,0,0,0-.25-1.08" transform="translate(-0.55)" fill="#061238"/>
            <path id="Path_39391" data-name="Path 39391" d="M89.2,576.425a1.917,1.917,0,0,1-.79-.6,1.6,1.6,0,0,1-.32-.885h.94a.92.92,0,0,0,.385.67,1.468,1.468,0,0,0,.9.26,1.32,1.32,0,0,0,.82-.23.7.7,0,0,0,.3-.58.573.573,0,0,0-.32-.535,4.465,4.465,0,0,0-.99-.345,7.274,7.274,0,0,1-.995-.325,1.768,1.768,0,0,1-.66-.49,1.275,1.275,0,0,1-.275-.855,1.3,1.3,0,0,1,.25-.77,1.692,1.692,0,0,1,.71-.555,2.552,2.552,0,0,1,1.05-.205,2.241,2.241,0,0,1,1.47.46,1.659,1.659,0,0,1,.6,1.26h-.91a.941.941,0,0,0-.345-.69,1.527,1.527,0,0,0-1.625-.05.647.647,0,0,0-.29.55.6.6,0,0,0,.175.445,1.289,1.289,0,0,0,.44.28,7.634,7.634,0,0,0,.735.235,7.891,7.891,0,0,1,.96.315,1.691,1.691,0,0,1,.635.465,1.248,1.248,0,0,1,.275.81,1.392,1.392,0,0,1-.25.81,1.674,1.674,0,0,1-.705.565,2.531,2.531,0,0,1-1.045.205,2.821,2.821,0,0,1-1.13-.215" transform="translate(-0.55)" fill="#061238"/>
          </g>
          <path id="Path_39392" data-name="Path 39392" d="M64.5,551.354v-.819a3.6,3.6,0,0,1,.95-1.8q6.56-6.543,13.106-13.1a1.067,1.067,0,0,1,.8-.332q5,.008,9.99,0a3,3,0,0,1,3.1,2.9v10.19a1.071,1.071,0,0,1-.332.8L79,562.322a3.147,3.147,0,0,1-1.337.813c-.146.043-.293.08-.44.12H76.4a.365.365,0,0,0-.093-.046,3.051,3.051,0,0,1-1.7-.906q-4.575-4.579-9.147-9.164a4.842,4.842,0,0,1-.722-1.043,3.648,3.648,0,0,1-.238-.742m22.678-9a1.752,1.752,0,1,0,0,.154v-.154" transform="translate(-0.55)" fill="#061238"/>
          <rect id="Rectangle_8424" data-name="Rectangle 8424" width="27.953" height="27.953" transform="translate(63.951 535.301)" fill="none"/>
        </g>
    `,
  },
  "mobile-duringCall-mute-icon": {
    name: "mobile-duringCall-mute-icon",
    viewBox: "0 0 71 72",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
          <g id="Group_13593" data-name="Group 13593" transform="translate(-145.11 -519)">
            <g id="m" transform="translate(0 -1.55)">
              <path id="Path_39364" data-name="Path 39364" d="M171.385,517.55h19a26,26,0,0,1,26,26v20a26,26,0,0,1-26,26h-19a26,26,0,0,1-26-26v-20a26,26,0,0,1,26-26" transform="translate(-0.275 3)" fill="#5576d1"/>
              <g id="Group_14321" data-name="Group 14321" transform="translate(0.275 3)">
                <path id="Path_39401" data-name="Path 39401" d="M181.667,531.79c.2.04.4.081.6.119a6.118,6.118,0,0,1,4.868,5.893.613.613,0,0,1-.191.358q-1.855,1.872-3.724,3.731l-7.628,7.632a3.115,3.115,0,0,0-.248.333,4.893,4.893,0,0,1-.383-1.7c-.025-.774-.026-1.55-.025-2.325,0-2.749-.025-5.5.028-8.247a5.83,5.83,0,0,1,2.83-4.857,5.4,5.4,0,0,1,2.422-.881,1.294,1.294,0,0,0,.206-.057Z" transform="translate(-0.55)" fill="#fff"/>
                <path id="Path_39402" data-name="Path 39402" d="M167.135,560.1a1.768,1.768,0,0,1,.377-1.25c.092-.111.191-.217.293-.319l24.061-24.066a1.79,1.79,0,0,1,1.93-.57,1.708,1.708,0,0,1,.815,2.657,3.935,3.935,0,0,1-.313.344l-24.085,24.086a1.736,1.736,0,0,1-2.158.461,1.613,1.613,0,0,1-.92-1.343" transform="translate(-0.55)" fill="#fff"/>
                <path id="Path_39403" data-name="Path 39403" d="M179.8,561.12v-2.526a10.826,10.826,0,0,1-4.493-1.531c.376-.363.736-.709,1.094-1.056.229-.224.427-.58.691-.639s.576.2.872.3a8.562,8.562,0,0,0,9.264-2.1,8.429,8.429,0,0,0,2.373-6.009c0-.786-.007-1.572.006-2.357a1.214,1.214,0,0,1,2.386-.293.739.739,0,0,1,.034.212c-.036,1.4,0,2.815-.133,4.21a9.506,9.506,0,0,1-2.06,4.94,10.957,10.957,0,0,1-4.508,3.538,10.552,10.552,0,0,1-2.651.722c-.123.017-.244.042-.384.066v2.521h.365c1.468,0,2.936-.005,4.4,0a1.219,1.219,0,1,1,.226,2.427,1.015,1.015,0,0,1-.124.008q-6.126,0-12.253-.005a1.21,1.21,0,0,1-1.182-1.375,1.235,1.235,0,0,1,1.288-1.054c1.468-.008,2.936,0,4.4,0h.381" transform="translate(-0.55)" fill="#fff"/>
                <path id="Path_39404" data-name="Path 39404" d="M179.058,553.442l8.07-8.071c-.008-.009.015.005.015.019a16.835,16.835,0,0,1-.2,3.915,6.217,6.217,0,0,1-4.915,4.4,6.4,6.4,0,0,1-2.817-.2c-.065-.02-.127-.051-.155-.062" transform="translate(-0.55)" fill="#fff"/>
                <path id="Path_39405" data-name="Path 39405" d="M171.677,553.438a8.951,8.951,0,0,1-1.466-3.963c-.133-1.447-.124-2.908-.139-4.363a1.185,1.185,0,0,1,1.206-1.1,1.212,1.212,0,0,1,1.2,1.142c.021.6.011,1.2.008,1.8a9.962,9.962,0,0,0,.5,3.631c.114.3.26.585.371.884a.35.35,0,0,1-.015.293c-.537.557-1.087,1.1-1.664,1.676" transform="translate(-0.55)" fill="#fff"/>
              </g>
            </g>
            <g id="Group_14333" data-name="Group 14333" transform="translate(4069 169)">
              <path id="Path_39426" data-name="Path 39426" d="M.91,0V4.41a1.866,1.866,0,0,0,.455,1.38,1.72,1.72,0,0,0,1.265.449A1.708,1.708,0,0,0,3.885,5.79,1.871,1.871,0,0,0,4.34,4.41V0h.91V4.4A2.847,2.847,0,0,1,4.9,5.864a2.2,2.2,0,0,1-.945.886,3.014,3.014,0,0,1-1.335.29,3.007,3.007,0,0,1-1.335-.29,2.158,2.158,0,0,1-.94-.886A2.877,2.877,0,0,1,0,4.4V0Z" transform="translate(-3907 402)" fill="#fff"/>
              <path id="Path_39427" data-name="Path 39427" d="M11.06,2a2.327,2.327,0,0,1,.62,1.744V6.97h-.9V3.87a1.766,1.766,0,0,0-.41-1.256A1.468,1.468,0,0,0,9.25,2.18a1.5,1.5,0,0,0-1.15.45,1.838,1.838,0,0,0-.42,1.309V6.97H6.77V1.489h.91v.78a1.8,1.8,0,0,1,.735-.649A2.282,2.282,0,0,1,9.44,1.39,2.224,2.224,0,0,1,11.06,2" transform="translate(-3907 402)" fill="#fff"/>
              <path id="Path_39428" data-name="Path 39428" d="M20.9,1.654a1.913,1.913,0,0,1,.79.8,2.652,2.652,0,0,1,.29,1.289v3.23h-.9V3.87a1.778,1.778,0,0,0-.4-1.256,1.427,1.427,0,0,0-1.095-.435,1.465,1.465,0,0,0-1.13.455,1.874,1.874,0,0,0-.42,1.316V6.969h-.9V3.87a1.778,1.778,0,0,0-.4-1.256,1.427,1.427,0,0,0-1.1-.435,1.463,1.463,0,0,0-1.13.455,1.874,1.874,0,0,0-.42,1.316V6.969h-.91V1.489h.91v.79a1.8,1.8,0,0,1,.725-.659,2.2,2.2,0,0,1,1-.231,2.37,2.37,0,0,1,1.22.311,1.891,1.891,0,0,1,.79.909,1.8,1.8,0,0,1,.76-.9,2.233,2.233,0,0,1,1.18-.321,2.4,2.4,0,0,1,1.14.265" transform="translate(-3907 402)" fill="#fff"/>
              <path id="Path_39429" data-name="Path 39429" d="M28.33,1.489v5.48h-.91V6.16a1.77,1.77,0,0,1-.725.654,2.237,2.237,0,0,1-1.025.236,2.455,2.455,0,0,1-1.15-.265,1.929,1.929,0,0,1-.805-.8,2.611,2.611,0,0,1-.3-1.289V1.489h.9V4.58a1.744,1.744,0,0,0,.41,1.245,1.469,1.469,0,0,0,1.12.435A1.5,1.5,0,0,0,27,5.809,1.849,1.849,0,0,0,27.42,4.5V1.489Z" transform="translate(-3907 402)" fill="#fff"/>
              <path id="Path_39430" data-name="Path 39430" d="M30.979,2.239v3.23a.772.772,0,0,0,.17.566.842.842,0,0,0,.59.165h.67v.769h-.82a1.636,1.636,0,0,1-1.14-.349,1.506,1.506,0,0,1-.38-1.151V2.239h-.71v-.75h.71V.109h.91v1.38h1.43v.75Z" transform="translate(-3907 402)" fill="#fff"/>
              <path id="Path_39431" data-name="Path 39431" d="M38.48,4.57H34.1a1.722,1.722,0,0,0,1.78,1.72,1.68,1.68,0,0,0,.985-.275,1.461,1.461,0,0,0,.555-.735h.98a2.356,2.356,0,0,1-.88,1.285,2.657,2.657,0,0,1-1.64.5,2.763,2.763,0,0,1-1.4-.35,2.473,2.473,0,0,1-.965-1,3.075,3.075,0,0,1-.35-1.5,3.129,3.129,0,0,1,.34-1.49,2.372,2.372,0,0,1,.955-.984A2.831,2.831,0,0,1,35.88,1.4a2.747,2.747,0,0,1,1.38.34,2.363,2.363,0,0,1,.925.935A2.757,2.757,0,0,1,38.51,4.02a5.355,5.355,0,0,1-.03.55M37.34,2.935a1.5,1.5,0,0,0-.625-.57,1.951,1.951,0,0,0-.875-.2,1.688,1.688,0,0,0-1.175.44,1.789,1.789,0,0,0-.555,1.221h3.46a1.684,1.684,0,0,0-.23-.9" transform="translate(-3907 402)" fill="#fff"/>
            </g>
          </g>
    `,
  },
  "mobile-duringCall-keypad-icon": {
    name: "mobile-duringCall-keypad-icon",
    viewBox: "0 0 72 72",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
        <g id="Group_14328" data-name="Group 14328" transform="translate(-245 -517.55)">
          <path id="Path_39379" data-name="Path 39379" d="M271.55,517.55h20a26,26,0,0,1,26,26v20a26,26,0,0,1-26,26h-20a26,26,0,0,1-26-26v-20a26,26,0,0,1,26-26" transform="translate(-0.55)" fill="#e9f2ff"/>
          <path id="Path_39380" data-name="Path 39380" d="M281.193,556.184a2.536,2.536,0,1,0,2.524,2.548v-.012a2.536,2.536,0,0,0-2.524-2.536m-7.446-22.838a2.536,2.536,0,1,0,2.526,2.546v-.01a2.536,2.536,0,0,0-2.526-2.536m0,7.615a2.536,2.536,0,1,0,2.526,2.546V543.5a2.537,2.537,0,0,0-2.526-2.535m0,7.615a2.536,2.536,0,1,0,2.526,2.546v-.011a2.536,2.536,0,0,0-2.526-2.536Zm14.892-10.152a2.539,2.539,0,1,0-2.524-2.554v.012a2.537,2.537,0,0,0,2.524,2.542m-7.446,10.151a2.536,2.536,0,1,0,2.524,2.548v-.012a2.536,2.536,0,0,0-2.524-2.536m7.446,0a2.536,2.536,0,1,0,2.524,2.548v-.012a2.536,2.536,0,0,0-2.524-2.536m0-7.615a2.536,2.536,0,1,0,2.524,2.548V543.5a2.536,2.536,0,0,0-2.524-2.535Zm-7.446,0a2.536,2.536,0,1,0,2.524,2.548V543.5a2.536,2.536,0,0,0-2.524-2.535Zm0-7.615a2.536,2.536,0,1,0,2.524,2.548v-.012a2.536,2.536,0,0,0-2.524-2.535Z" transform="translate(-0.55)" fill="#061238"/>
          <path id="Path_39381" data-name="Path 39381" d="M266.75,576.55l-2.15-2.42v2.42h-.91v-7.4h.91v4.35l2.11-2.43h1.27l-2.58,2.73,2.59,2.75Z" transform="translate(-0.55)" fill="#061238"/>
          <path id="Path_39382" data-name="Path 39382" d="M273.81,574.15h-4.38a1.722,1.722,0,0,0,1.78,1.72,1.681,1.681,0,0,0,.985-.275,1.461,1.461,0,0,0,.555-.735h.98a2.356,2.356,0,0,1-.88,1.285,2.657,2.657,0,0,1-1.64.495,2.762,2.762,0,0,1-1.395-.35,2.474,2.474,0,0,1-.965-1,3.075,3.075,0,0,1-.35-1.495,3.129,3.129,0,0,1,.34-1.49,2.372,2.372,0,0,1,.955-.984,2.831,2.831,0,0,1,1.415-.346,2.748,2.748,0,0,1,1.38.34,2.363,2.363,0,0,1,.925.935,2.757,2.757,0,0,1,.325,1.345,5.357,5.357,0,0,1-.03.55m-1.14-1.635a1.5,1.5,0,0,0-.625-.57,1.95,1.95,0,0,0-.875-.2,1.687,1.687,0,0,0-1.175.44,1.789,1.789,0,0,0-.555,1.221h3.46a1.685,1.685,0,0,0-.23-.9" transform="translate(-0.55)" fill="#061238"/>
          <path id="Path_39383" data-name="Path 39383" d="M279.76,571.069l-3.3,8.061h-.94l1.08-2.64-2.21-5.421h1.01l1.72,4.44,1.7-4.44Z" transform="translate(-0.55)" fill="#061238"/>
          <path id="Path_39384" data-name="Path 39384" d="M282.385,571.295a2.408,2.408,0,0,1,1.245-.315,2.567,2.567,0,0,1,1.325.35,2.476,2.476,0,0,1,.935.984,3.08,3.08,0,0,1,.34,1.476,3.142,3.142,0,0,1-.34,1.48,2.493,2.493,0,0,1-2.26,1.37,2.389,2.389,0,0,1-1.235-.315,2.246,2.246,0,0,1-.815-.785v3.609h-.91v-8.08h.91v1.011a2.178,2.178,0,0,1,.8-.785m2.665,1.415a1.733,1.733,0,0,0-.675-.7,1.868,1.868,0,0,0-.935-.24,1.825,1.825,0,0,0-.925.245,1.8,1.8,0,0,0-.68.71,2.415,2.415,0,0,0,0,2.16,1.8,1.8,0,0,0,.68.71,1.887,1.887,0,0,0,1.86,0,1.766,1.766,0,0,0,.675-.71,2.275,2.275,0,0,0,.25-1.1,2.226,2.226,0,0,0-.25-1.08" transform="translate(-0.55)" fill="#061238"/>
          <path id="Path_39385" data-name="Path 39385" d="M287.429,572.315a2.474,2.474,0,0,1,.935-.985,2.57,2.57,0,0,1,1.325-.35,2.428,2.428,0,0,1,1.25.31,2.063,2.063,0,0,1,.79.78v-1h.92v5.48h-.92v-1.019a2.139,2.139,0,0,1-.8.794,2.41,2.41,0,0,1-1.245.315,2.49,2.49,0,0,1-1.32-.359,2.542,2.542,0,0,1-.93-1.011,3.154,3.154,0,0,1-.34-1.48,3.088,3.088,0,0,1,.34-1.475m4.05.4a1.772,1.772,0,0,0-.675-.7,1.914,1.914,0,0,0-1.865-.005,1.747,1.747,0,0,0-.67.7,2.237,2.237,0,0,0-.25,1.08,2.287,2.287,0,0,0,.25,1.1,1.768,1.768,0,0,0,.67.71,1.815,1.815,0,0,0,.93.245,1.841,1.841,0,0,0,.935-.245,1.76,1.76,0,0,0,.675-.71,2.254,2.254,0,0,0,.25-1.085,2.226,2.226,0,0,0-.25-1.08" transform="translate(-0.55)" fill="#061238"/>
          <path id="Path_39386" data-name="Path 39386" d="M294.189,572.315a2.473,2.473,0,0,1,.935-.985,2.588,2.588,0,0,1,1.335-.35,2.475,2.475,0,0,1,1.19.3,2.127,2.127,0,0,1,.84.775v-2.9h.92v7.4h-.92v-1.03a2.123,2.123,0,0,1-.8.8,2.379,2.379,0,0,1-1.24.315,2.488,2.488,0,0,1-2.26-1.37,3.154,3.154,0,0,1-.34-1.48,3.088,3.088,0,0,1,.34-1.475m4.05.4a1.772,1.772,0,0,0-.675-.7,1.914,1.914,0,0,0-1.865-.005,1.747,1.747,0,0,0-.67.7,2.237,2.237,0,0,0-.25,1.08,2.287,2.287,0,0,0,.25,1.1,1.769,1.769,0,0,0,.67.71,1.814,1.814,0,0,0,.93.245,1.841,1.841,0,0,0,.935-.245,1.76,1.76,0,0,0,.675-.71,2.254,2.254,0,0,0,.25-1.085,2.226,2.226,0,0,0-.25-1.08" transform="translate(-0.55)" fill="#061238"/>
        </g>
    `,
  },
  "mobile-duringCall-play-icon": {
    name: "mobile-duringCall-play-icon",
    viewBox: "0 0 71 71",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
          <g id="Group_13594" data-name="Group 13594" transform="translate(-145.332 -421)">
            <g id="Group_14324" data-name="Group 14324" transform="translate(0 0.45)">
              <path id="Path_39358" data-name="Path 39358" d="M171.882,420.55h19a26,26,0,0,1,26,26v19a26,26,0,0,1-26,26h-19a26,26,0,0,1-26-26v-19a26,26,0,0,1,26-26" transform="translate(-0.55)" fill="#5576d1"/>
            </g>
            <g id="p">
              <path id="Polygon_10" data-name="Polygon 10" d="M11.278,2.914a2,2,0,0,1,3.444,0l9.5,16.069A2,2,0,0,1,22.5,22H3.5a2,2,0,0,1-1.722-3.017Z" transform="translate(194 438) rotate(90)" fill="#fff"/>
              <g id="Group_14330" data-name="Group 14330" transform="translate(3.967 -10)">
                <path id="Path_39407" data-name="Path 39407" d="M4.065,3.915A2.522,2.522,0,0,1,2.25,4.49H.91V7.4H0V.431H2.25A2.55,2.55,0,0,1,4.045,1,1.916,1.916,0,0,1,4.66,2.471a1.925,1.925,0,0,1-.6,1.444m-.7-.5a1.21,1.21,0,0,0,.36-.939q0-1.291-1.48-1.29H.91V3.74H2.25a1.614,1.614,0,0,0,1.12-.33" transform="translate(167 479)" fill="#fff"/>
                <rect id="Rectangle_8427" data-name="Rectangle 8427" width="0.91" height="7.4" transform="translate(172.79 479)" fill="#fff"/>
                <path id="Path_39408" data-name="Path 39408" d="M8.25,3.165a2.473,2.473,0,0,1,.935-.985,2.57,2.57,0,0,1,1.325-.35,2.428,2.428,0,0,1,1.25.31,2.063,2.063,0,0,1,.79.78v-1h.92V7.4h-.92V6.381a2.139,2.139,0,0,1-.8.794A2.41,2.41,0,0,1,10.5,7.49a2.491,2.491,0,0,1-1.32-.359A2.541,2.541,0,0,1,8.25,6.12a3.153,3.153,0,0,1-.34-1.48,3.088,3.088,0,0,1,.34-1.475m4.05.4a1.772,1.772,0,0,0-.675-.7A1.914,1.914,0,0,0,9.76,2.86a1.748,1.748,0,0,0-.67.7,2.237,2.237,0,0,0-.25,1.08,2.287,2.287,0,0,0,.25,1.1,1.769,1.769,0,0,0,.67.71,1.815,1.815,0,0,0,.93.245,1.841,1.841,0,0,0,.935-.245,1.76,1.76,0,0,0,.675-.71,2.254,2.254,0,0,0,.25-1.085,2.226,2.226,0,0,0-.25-1.08" transform="translate(167 479)" fill="#fff"/>
                <path id="Path_39409" data-name="Path 39409" d="M19.73,1.92l-3.3,8.061h-.94l1.08-2.64L14.36,1.92h1.01l1.72,4.44,1.7-4.44Z" transform="translate(167 479)" fill="#fff"/>
              </g>
            </g>
          </g>
    `,
  },
  "mobile-duringCall-unmute-icon": {
    name: "mobile-duringCall-unmute-icon",
    viewBox: "0 0 71 72",
    fill: "",
    "stroke-width": "",
    "stroke-linecap": "",
    "stroke-linejoin": "",
    stroke: "",
    icon: `
          <g id="Group_13592" data-name="Group 13592" transform="translate(-145.11 -519)">
            <g id="Group_14327" data-name="Group 14327" transform="translate(0 -1.55)">
              <path id="Path_39364" data-name="Path 39364" d="M171.385,517.55h19a26,26,0,0,1,26,26v20a26,26,0,0,1-26,26h-19a26,26,0,0,1-26-26v-20a26,26,0,0,1,26-26" transform="translate(-0.275 3)" fill="#e9f2ff"/>
            </g>
            <g id="Group_14331" data-name="Group 14331">
              <path id="Path_39412" data-name="Path 39412" d="M21.96,13.33c-.04,1.4-.01,2.82-.14,4.21a9.444,9.444,0,0,1-2.06,4.94,10.922,10.922,0,0,1-4.5,3.54,10.694,10.694,0,0,1-2.66.72c-.12.02-.24.04-.38.07v2.52h.37c1.46,0,2.93-.01,4.4,0a1.221,1.221,0,0,1,.23,2.43h-.13c-4.08,0-8.17.01-12.25,0a1.212,1.212,0,0,1-1.18-1.38,1.232,1.232,0,0,1,1.28-1.05c1.47-.01,2.94,0,4.41,0h.38V26.8a11.033,11.033,0,0,1-3.51-1c-.15-.07-.3-.14-.44-.22-.18-.1-.36-.2-.54-.31h.005A10.84,10.84,0,0,1,1.45,21.4a.124.124,0,0,0-.02-.03A8.875,8.875,0,0,1,.14,17.68C.01,16.24.01,14.77,0,13.32a1.189,1.189,0,0,1,1.21-1.1,1.206,1.206,0,0,1,1.2,1.14c.02.6.01,1.2.01,1.8a9.908,9.908,0,0,0,.49,3.63c.09.23.19.44.28.67a.3.3,0,0,1,.04.08,8.727,8.727,0,0,0,4.25,4.14l.01.01c.13.06.27.14.4.19a2.016,2.016,0,0,0,.23.07l.01.01a8.544,8.544,0,0,0,9.03-2.18,8.43,8.43,0,0,0,2.37-6.01c0-.79-.01-1.57.01-2.36a1.21,1.21,0,0,1,2.38-.29.779.779,0,0,1,.04.21" transform="translate(169.852 533)" fill="#061238"/>
              <path id="Path_39414" data-name="Path 39414" d="M17.07,5.92V16.07a5.941,5.941,0,0,1-5.93,5.92h-.35a5.941,5.941,0,0,1-5.93-5.92V9.92c0-1.38.01-2.76.04-4.13A5.808,5.808,0,0,1,7.73.94,5.383,5.383,0,0,1,10.15.05a.355.355,0,0,0,.1-.02s0-.01.01,0A4.578,4.578,0,0,1,10.79,0h.35a5.879,5.879,0,0,1,.6.03c.02,0,.03,0,.04.01.14.02.28.05.42.08a6.156,6.156,0,0,1,4.84,5.2v.04a5.116,5.116,0,0,1,.03.56" transform="translate(169.852 533)" fill="#061238"/>
            </g>
            <g id="Group_14332" data-name="Group 14332">
              <path id="Path_39422" data-name="Path 39422" d="M6.1,0,3.539,5.72.98,0H0V6.92H.91V1.751L3.22,6.92h.64l2.3-5.16V6.92h.91V0Z" transform="translate(169.166 570)" fill="#061238"/>
              <path id="Path_39423" data-name="Path 39423" d="M13.47,1.439v5.48h-.91V6.11a1.776,1.776,0,0,1-.725.655A2.249,2.249,0,0,1,10.81,7a2.455,2.455,0,0,1-1.15-.265,1.928,1.928,0,0,1-.8-.8,2.609,2.609,0,0,1-.3-1.288V1.435h.9V4.526a1.749,1.749,0,0,0,.41,1.246,1.474,1.474,0,0,0,1.12.434,1.5,1.5,0,0,0,1.15-.451,1.846,1.846,0,0,0,.42-1.309V1.435Z" transform="translate(169.166 570)" fill="#061238"/>
              <path id="Path_39424" data-name="Path 39424" d="M16.12,2.189v3.23a.773.773,0,0,0,.17.566.838.838,0,0,0,.59.166h.67v.768h-.82a1.635,1.635,0,0,1-1.14-.348,1.51,1.51,0,0,1-.38-1.152V2.189H14.5v-.75h.71V.059h.91v1.38h1.43v.75Z" transform="translate(169.166 570)" fill="#061238"/>
              <path id="Path_39425" data-name="Path 39425" d="M23.621,4.52h-4.38a1.722,1.722,0,0,0,1.723,1.721h.057a1.678,1.678,0,0,0,.985-.275,1.467,1.467,0,0,0,.555-.735h.981a2.358,2.358,0,0,1-.881,1.285,2.652,2.652,0,0,1-1.64.5,2.755,2.755,0,0,1-1.4-.35,2.471,2.471,0,0,1-.965-.995,3.085,3.085,0,0,1-.35-1.5,3.111,3.111,0,0,1,.341-1.49A2.377,2.377,0,0,1,19.6,1.7a2.827,2.827,0,0,1,1.414-.346A2.754,2.754,0,0,1,22.4,1.7a2.367,2.367,0,0,1,.924.935,2.741,2.741,0,0,1,.326,1.345c0,.174-.011.356-.03.55m-1.14-1.635a1.514,1.514,0,0,0-.625-.57,1.951,1.951,0,0,0-.875-.2,1.686,1.686,0,0,0-1.175.44,1.782,1.782,0,0,0-.556,1.221h3.461a1.68,1.68,0,0,0-.23-.9" transform="translate(169.166 570)" fill="#061238"/>
            </g>
          </g> 
    `,
  },
}